/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/ 		var executeModules = data[2];
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 		// add entry modules from loaded chunk to deferred list
/******/ 		deferredModules.push.apply(deferredModules, executeModules || []);
/******/
/******/ 		// run deferred modules when all chunks ready
/******/ 		return checkDeferredModules();
/******/ 	};
/******/ 	function checkDeferredModules() {
/******/ 		var result;
/******/ 		for(var i = 0; i < deferredModules.length; i++) {
/******/ 			var deferredModule = deferredModules[i];
/******/ 			var fulfilled = true;
/******/ 			for(var j = 1; j < deferredModule.length; j++) {
/******/ 				var depId = deferredModule[j];
/******/ 				if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 			}
/******/ 			if(fulfilled) {
/******/ 				deferredModules.splice(i--, 1);
/******/ 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 			}
/******/ 		}
/******/
/******/ 		return result;
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		0: 0
/******/ 	};
/******/
/******/ 	var deferredModules = [];
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	var jsonpArray = window["wpJsonpPaskit"] = window["wpJsonpPaskit"] || [];
/******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ 	jsonpArray.push = webpackJsonpCallback;
/******/ 	jsonpArray = jsonpArray.slice();
/******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
/******/ 	var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ 	// add entry module to deferred list
/******/ 	deferredModules.push([929,1]);
/******/ 	// run deferred modules when ready
/******/ 	return checkDeferredModules();
/******/ })
/************************************************************************/
/******/ ({

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomerLicence; });
/* harmony import */ var lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49);
/* harmony import */ var lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _LicenceSwitcherModal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




/*
  Module used to capture interactions related to fetching and settings a Customer's licence via the integration.
*/

var CustomerLicence = /*#__PURE__*/function () {
  function CustomerLicence() {
    _classCallCheck(this, CustomerLicence);

    if (!!CustomerLicence.instance) {
      return CustomerLicence.instance;
    }

    CustomerLicence.instance = this;
    this.licenceSwitcher = new _LicenceSwitcherModal__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]("[data-licence-switcher-modal-contents]");
    var customerJSON = Object(_helpers__WEBPACK_IMPORTED_MODULE_2__[/* getLiquidVars */ "q"])('[data-scripts]');
    var hasActiveTag = lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_0___default()(false, 'customer.active_tag', customerJSON);
    var isLoggedIn = document.body.classList.contains('customer--logged-in');
    this.API = Object(_helpers__WEBPACK_IMPORTED_MODULE_2__[/* useIntegrationAPI */ "y"])();

    if (isLoggedIn) {
      return hasActiveTag ? true : this._initHeartbeat();
    }
  }
  /*
    Start the heartbeat call.
  */


  _createClass(CustomerLicence, [{
    key: "_initHeartbeat",
    value: function _initHeartbeat() {
      var _this = this;

      $.when(this._heartbeat()).then(function (_ref, textStatus, _jqXHR) {
        var _ref$data$activeLicen = _ref.data.activeLicenceChanged,
            activeLicenceChanged = _ref$data$activeLicen === void 0 ? true : _ref$data$activeLicen;

        if (textStatus === 'success') {
          // Check for active licence change, and reload if change found
          return activeLicenceChanged ? location.reload() : _this.licenceSwitcher.enableOpenButton();
        }
      });
    }
    /*
      Initiate background job on the Integration to update a Customers records.
    */

  }, {
    key: "_heartbeat",
    value: function _heartbeat() {
      return $.ajax({
        data: this.API.authPayload(),
        dataType: 'json',
        method: 'POST',
        url: this.API.postHeartbeat()
      });
    }
    /*
      Returns all of a Customers Licences as a JSON object.
    */

  }, {
    key: "fetchLicences",
    value: function fetchLicences() {
      return $.ajax({
        data: this.API.authPayload(),
        dataType: 'json',
        method: 'GET',
        url: this.API.getLicences()
      });
    }
    /*
      Set a new active licence on the Customer.
    */

  }, {
    key: "setLicence",
    value: function setLicence() {
      var licence = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      // NOTE: Create payload along with required AUTH info
      var payload = Object.assign({
        licence: parseInt(licence)
      }, this.API.authPayload());
      return $.ajax({
        data: payload,
        dataType: 'json',
        method: 'POST',
        url: this.API.postLicence()
      });
    }
  }]);

  return CustomerLicence;
}();



/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckboxMaster; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
 * This file controls the interaction of our custom checkbox elements.
 *
 * NOTE: IE11 has issues with converting a NodeList to an Array,
 * so we're using [].slice.call() to help with that.
 * Read more at: https://davidwalsh.name/nodelist-array
 */


var CheckboxMaster = /*#__PURE__*/function () {
  function CheckboxMaster(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, CheckboxMaster);

    this.el = el;
    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el);
    this.options = options;
    this.init();
  }

  _createClass(CheckboxMaster, [{
    key: "init",
    value: function init() {
      this.masterWrapper = this.el.querySelector('[data-form-checkbox-master-wrapper]');
      this.master = this.masterWrapper.querySelector('[data-form-checkbox-master]');
      this.masterText = this.masterWrapper.querySelector('[data-form-checkbox-master-text]'); // NOTE: IE11 fix, read more at top of module

      this.slaves = [].slice.call(this.el.querySelectorAll('[data-form-checkbox-slave]'));
      this.slaveCount = this.slaves.length;
      this.onChange = this.options.onChange;
      this.currentState = 'empty';

      this._bindEvents();
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;

      this.$el.on('change.checkbox-master', '[data-form-checkbox-master]', function () {
        _this._handleMasterChange();
      });
      this.$el.on('change.checkbox-master', '[data-form-checkbox-slave]', function () {
        _this.handleSlaveChange();
      });
      this.$el.on('checkbox-master:update-cart', '[data-form-checkbox-master]', function () {
        _this.handleSlaveChange();
      });
    }
  }, {
    key: "unload",
    value: function unload() {
      this.$el.off('.checkbox-master');
      this.$el.off('checkbox-master:update-cart');
    }
  }, {
    key: "clear",
    value: function clear() {
      this.master.checked = false;
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.master).trigger('change.checkbox-master');
    }
  }, {
    key: "_getMasterState",
    value: function _getMasterState() {
      return this.masterWrapper.dataset.formCheckboxState;
    }
  }, {
    key: "_handleMasterChange",
    value: function _handleMasterChange() {
      var checked = this.master.checked;
      this.slaves.forEach(function (el) {
        el.checked = checked ? true : false;
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).trigger('change.checkbox-master');
      });
    }
  }, {
    key: "handleSlaveChange",
    value: function handleSlaveChange() {
      var slavesChecked = this._checkActiveSlaves();

      this.masterText.innerHTML = "".concat(slavesChecked, " selected");
      if (slavesChecked === 0) return this._updateMasterState('empty');
      if (slavesChecked === this.slaveCount) return this._updateMasterState('all');
      return this._updateMasterState('indeterminate');
    }
  }, {
    key: "_updateMasterState",
    value: function _updateMasterState(state) {
      this.currentState = state;
      this.masterWrapper.dataset.formCheckboxState = this.currentState;

      if (this.currentState === 'all' || this.currentState === 'indeterminate') {
        this.master.checked = true;
      } else {
        this.master.checked = false;
      }

      this.onChange(this.currentState);
    }
  }, {
    key: "_checkActiveSlaves",
    value: function _checkActiveSlaves() {
      var slavesChecked = 0;
      this.slaves.forEach(function (el) {
        if (el.checked) slavesChecked++;
      });
      return slavesChecked;
    }
  }]);

  return CheckboxMaster;
}();



/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductRowScroller; });
/* harmony import */ var just_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32);
/* harmony import */ var just_debounce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(just_debounce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }





var ProductRowScroller = /*#__PURE__*/function () {
  function ProductRowScroller(productRow) {
    _classCallCheck(this, ProductRowScroller);

    this.$window = $(window);
    this.flickity = null;
    this.productRow = productRow;
    this.$productRow = $(this.productRow); // Activate flickity on mobile

    this._mobileSlider = this._mobileSlider.bind(this);
    _Layout__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].onBreakpointChange(this._mobileSlider);

    this._mobileSlider();
  }

  _createClass(ProductRowScroller, [{
    key: "unload",
    value: function unload() {
      _Layout__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].offBreakpointChange(this._mobileSlider);

      this._destroyFlickity();
    }
  }, {
    key: "_initFlickity",
    value: function _initFlickity() {
      this.flickity = new flickity__WEBPACK_IMPORTED_MODULE_1___default.a(this.productRow, {
        cellSelector: '.productgrid--item',
        contain: true,
        freeScroll: true,
        percentPosition: false,
        prevNextButtons: false,
        pageDots: false,
        setGallerySize: false,
        cellAlign: 'left'
      });

      this._bindSlider();
    }
  }, {
    key: "_destroyFlickity",
    value: function _destroyFlickity() {
      if (!this.flickity) {
        return;
      }

      this.$window.off('.product-row');
      this.$productRow.off('.product-row');
      this.flickity.destroy();
      this.flickity = null;
    }
  }, {
    key: "_mobileSlider",
    value: function _mobileSlider() {
      // If is Large layout, attempt to destroy flickity
      if (_Layout__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].isBreakpoint('L')) {
        this._destroyFlickity();

        return;
      } // Is XS/S/M, and flickity is init'd -- do nothing


      if (this.flickity) {
        return;
      } // Is XS/S/M, and flickity is not init'd


      this._initFlickity();
    }
  }, {
    key: "_bindSlider",
    value: function _bindSlider() {
      var _this = this;

      var $slider = this.$productRow.find('.flickity-slider');
      this.$window.on('resize.product-row', just_debounce__WEBPACK_IMPORTED_MODULE_0___default()(function () {
        _this.$productRow.trigger('heightUpdate.product-row');
      }));
      this.flickity.on('cellSelect', function () {
        _this.$productRow.trigger('heightUpdate.product-row');
      });
      this.$productRow.on('heightUpdate.product-row', function () {
        if (!_this.flickity) {
          return;
        }

        $slider.height(Math.ceil(_this.flickity.maxCellHeight));
      }); // Sets the Slider to the height of the first slide

      this.$productRow.trigger('heightUpdate.product-row');
    }
  }]);

  return ProductRowScroller;
}();



/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductDetails_ProductDetails; });

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(0);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./source/scripts/Forms.js
var Forms = __webpack_require__(21);

// CONCATENATED MODULE: ./source/scripts/ProductOptions.js
function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var Node = /*#__PURE__*/function () {
  function Node(variant, variantAvailabilities) {
    _classCallCheck(this, Node);

    this.variant = variant;
    this.variantAvailabilities = variantAvailabilities;
    this.optionsCount = this.variant.options.length;
    this.neighbors = [];

    for (var i = 0; i < this.optionsCount; i++) {
      this.neighbors.push([]);
    }
  }

  _createClass(Node, [{
    key: "addNeighbor",
    value: function addNeighbor(variant) {
      for (var i = 0; i < this.optionsCount; i++) {
        if (this.variant.options[i] !== variant.options[i]) {
          this.neighbors[i].push(variant);
          break;
        }
      }
    }
  }, {
    key: "getValidOptions",
    value: function getValidOptions() {
      var _this = this;

      var options = [];

      var _loop = function _loop(i) {
        var variants = [_this.variant].concat(_toConsumableArray(_this.neighbors[i]));
        options[i] = {};
        variants.forEach(function (item) {
          var variant = item;
          var option = variant.options[i];
          var variantAvailability = _this.variantAvailabilities[variant.id];
          var variantAvailable = true;

          if (variantAvailability.wholesale_lifecycle === 'temporary_hold') {
            variantAvailable = false;
          } else if (!variantAvailability.available) {
            variantAvailable = false;
          }

          options[i][option] = {
            available: options[i][option] && options[i][option].available || variantAvailable
          };
        });
      };

      for (var i = 0; i < this.optionsCount; i++) {
        _loop(i);
      }

      return options;
    }
  }]);

  return Node;
}();

var ProductOptions = /*#__PURE__*/function () {
  function ProductOptions(product, variantAvailabilities, exclusivities) {
    _classCallCheck(this, ProductOptions);

    this.productHandle = product.handle;
    this.optionsCount = product.options.length;
    this.variants = [];
    this.variantAvailabilities = variantAvailabilities;
    this.exclusivities = exclusivities;
    this.nodeMap = {};

    var _iterator = _createForOfIteratorHelper(product.variants),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var variant = _step.value;

        if (this._checkVariantAccessibility(variant)) {
          this.variants.push(variant);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    this._generateNodeMap(product);
  }

  _createClass(ProductOptions, [{
    key: "_generateNodeMap",
    value: function _generateNodeMap() {
      var _this2 = this;

      this.variants.forEach(function (variant) {
        if (_this2._checkVariantAccessibility(variant)) {
          _this2.nodeMap[variant.id] = new Node(variant, _this2.variantAvailabilities);

          _this2.variants.forEach(function (variant2) {
            _this2.nodeMap[variant.id].addNeighbor(variant2);
          });
        }
      });
    }
  }, {
    key: "_checkVariantAccessibility",
    value: function _checkVariantAccessibility(variant) {
      var exclusivityPassed = this.exclusivities[variant.id] && this.exclusivities[variant.id].exclusive,
          pricePassed = variant.price > 0;
      return exclusivityPassed && pricePassed;
    }
  }, {
    key: "getVariantFromOptions",
    value: function getVariantFromOptions(options) {
      this.variants.forEach(function (variant) {
        var found = true;

        for (var i = 0; i < variant.options.length; i++) {
          if (options[i] !== variant.options[i]) {
            found = false;
          }
        }

        if (found) {
          return variant;
        }
      });
      return false;
    }
  }, {
    key: "getClosestVariantFromOptions",
    value: function getClosestVariantFromOptions(options) {
      var closestVariant = null;
      var matchingValues = 0;
      this.variants.forEach(function (variant) {
        var tempMatchingValues = 0;

        for (var i = 0; i < variant.options.length; i++) {
          if (options[i] === variant.options[i]) {
            tempMatchingValues++;
          } else {
            break;
          }
        }

        if (tempMatchingValues >= matchingValues) {
          closestVariant = variant;
          matchingValues = tempMatchingValues;
        }
      });
      return closestVariant ? closestVariant : false;
    }
  }, {
    key: "getVariantOrClosestFromOptions",
    value: function getVariantOrClosestFromOptions(options) {
      return this.getVariantFromOptions(options) || this.getClosestVariantFromOptions(options);
    }
  }, {
    key: "getAvailableOptionsFromVariant",
    value: function getAvailableOptionsFromVariant(variant) {
      return this.nodeMap[variant.id].getValidOptions();
    }
  }]);

  return ProductOptions;
}();


// CONCATENATED MODULE: ./source/scripts/VariantHelper.js
function VariantHelper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function VariantHelper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function VariantHelper_createClass(Constructor, protoProps, staticProps) { if (protoProps) VariantHelper_defineProperties(Constructor.prototype, protoProps); if (staticProps) VariantHelper_defineProperties(Constructor, staticProps); return Constructor; }




var VariantHelper_VariantHelper = /*#__PURE__*/function () {
  function VariantHelper(product, variantAvailabilities, exclusivities, $variants, $options) {
    VariantHelper_classCallCheck(this, VariantHelper);

    this.product = product;
    this.optionsCount = this.product.options.length;
    this.$variants = $variants;
    this.$options = $options;
    this.productOptions = new ProductOptions(this.product, variantAvailabilities, exclusivities);
    this.optionsTypes = {
      select: 'select',
      radio: 'input[type="radio"]'
    };

    this._bindEvents();

    if (this.$options.is(this.optionsTypes.select)) {
      this.optionsType = this.optionsTypes.select;
    } else if (this.$options.is(this.optionsTypes.radio)) {
      this.optionsType = this.optionsTypes.radio;
    } else {
      console.warn('Variant helper: Option set is not a valid type');

      this._unbindEvents();
    }

    this._switchVariant(true);
  }

  VariantHelper_createClass(VariantHelper, [{
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;

      this.$options.on('change.variant-helper', function () {
        return _this._switchVariant();
      });
    }
  }, {
    key: "_unbindEvents",
    value: function _unbindEvents() {
      this.$options.off('change.variant-helper');
    }
  }, {
    key: "_switchVariant",
    value: function _switchVariant() {
      var firstLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var options = [];
      var product = this.product;
      var variant = null;
      var availableOptions = null;

      if (this.optionsType === this.optionsTypes.select) {
        this.$options.each(function (i, option) {
          options.push(option.value);
        });
      } else if (this.optionsType === this.optionsTypes.radio) {
        this.$options.filter(':checked').each(function (i, option) {
          options.push(option.value);
        });
      } else {
        return;
      }

      variant = this.productOptions.getVariantOrClosestFromOptions(options);

      if (variant) {
        availableOptions = this.productOptions.getAvailableOptionsFromVariant(variant);
      } else {
        return;
      }

      if (this.optionsType === this.optionsTypes.select) {
        this._switchVariantSelect(variant, availableOptions);
      } else if (this.optionsType === this.optionsTypes.radio) {
        this._switchVariantRadio(variant, availableOptions);
      } else {
        return;
      }

      this.$variants.val(variant.id);
      jquery_default()(window).trigger('product-variant-switch', {
        product: product,
        variant: variant,
        firstLoad: firstLoad
      });
    }
  }, {
    key: "_switchVariantSelect",
    value: function _switchVariantSelect(variant, availableOptions) {
      var _this2 = this;

      var _loop = function _loop(i) {
        // Corresponding select dropdown
        var $select = jquery_default()(_this2.$options[i]);
        var $optionEls = $select.find('option'); // Iterate over each option on dropdown

        $optionEls.each(function (index, option) {
          var $option = jquery_default()(option);
          var value = option.value; // Not an available option

          $option.prop('selected', false); // Dropdown option matches variant option

          if (variant.options[i] === value) {
            $option.prop('selected', true);
          }
        });
      };

      // Iterate over each option type
      for (var i = 0; i < this.product.options.length; i++) {
        _loop(i);
      }
    }
  }, {
    key: "_switchVariantRadio",
    value: function _switchVariantRadio(variant, availableOptions) {
      var _this3 = this;

      this.$options.attr('disabled', true).prop('checked', false).attr('data-soldout', false);

      var _loop2 = function _loop2(i) {
        var selector = _this3.product.options[i].replace(/"/g, '\\"');

        var $options = _this3.$options.filter("[name=\"".concat(selector, "\"]"));

        $options.each(function (index, option) {
          var $option = jquery_default()(option);

          if (variant.options[i] === $option.val()) {
            $option.prop('checked', true);
          }

          if (availableOptions[i][$option.val()]) {
            $option.attr('disabled', false);

            if (!availableOptions[i][$option.val()].available) {
              $option.attr('disabled', true);
              $option.attr('data-soldout', true);
            }
          }
        });
      };

      for (var i = 0; i < this.product.options.length; i++) {
        _loop2(i);
      }
    }
  }, {
    key: "isDefault",
    value: function isDefault() {
      if (this.product.variants[0].title === 'Default Title' && this.product.variants[0].option1 === 'Default Title') {
        return true;
      }
    }
  }, {
    key: "hasSingleOption",
    value: function hasSingleOption() {
      return this.optionsCount === 1;
    }
  }, {
    key: "getSelectedVariant",
    value: function getSelectedVariant() {
      var options = [];

      if (this.optionsType === this.optionsTypes.select) {
        this.$options.each(function (i, option) {
          options.push(option.value);
        });
      } else if (this.optionsType === this.optionsTypes.radio) {
        this.$options.filter(':checked').each(function (i, option) {
          options.push(option.value);
        });
      } else {
        return;
      }

      return this.productOptions.getVariantFromOptions(options);
    }
  }, {
    key: "unload",
    value: function unload() {
      this._unbindEvents();
    }
  }]);

  return VariantHelper;
}();


// EXTERNAL MODULE: ./node_modules/flickity/js/index.js
var js = __webpack_require__(44);
var js_default = /*#__PURE__*/__webpack_require__.n(js);

// EXTERNAL MODULE: ./node_modules/flickity-imagesloaded/flickity-imagesloaded.js
var flickity_imagesloaded = __webpack_require__(901);

// EXTERNAL MODULE: ./source/scripts/Layout.js
var Layout = __webpack_require__(4);

// EXTERNAL MODULE: ./source/scripts/helpers/index.js + 24 modules
var helpers = __webpack_require__(2);

// CONCATENATED MODULE: ./source/scripts/components/ProductGallery.js
function ProductGallery_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ProductGallery_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ProductGallery_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductGallery_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductGallery_defineProperties(Constructor, staticProps); return Constructor; }



 // eslint-disable-line no-unused-vars




var ProductGallery_ProductGallery = /*#__PURE__*/function () {
  function ProductGallery(options) {
    ProductGallery_classCallCheck(this, ProductGallery);

    this.$gallery = options.$gallery;
    this.settings = options.settings;
    this.isQuickshop = options.isQuickshop || false; // Gallery

    this.flickity = null;
    this.slider = '[data-product-slider]';
    this.$slider = this.$gallery.find(this.slider);
    this.slides = '[data-product-image]';
    this.$slides = this.$gallery.find(this.slides);
    this.slideImages = this.$slider[0].querySelectorAll('[data-rimg]');
    this.$sliderPagination = this.$gallery.find('[data-product-slider-pagination]');
    this.$paginationTrigger = this.$gallery.find('[data-product-thumbnail]'); // Re-initialise gallery when crossing breakpoints if needed

    this._onUpdateGallery = this._onUpdateGallery.bind(this);
    Layout["a" /* default */].onBreakpointChange(this._onUpdateGallery);
    this.slideImageLoaded = this._onSlideImageLoaded.bind(this);
    this.variantChange = this._onVariantChange.bind(this);

    if (this.isQuickshop) {
      this.$gallery.trigger('theme:rimg:watch');
    }

    this._init();
  }

  ProductGallery_createClass(ProductGallery, [{
    key: "unload",
    value: function unload() {
      for (var i = 0; i < this.slideImages.length; i += 1) {
        this.slideImages[i].removeEventListener('rimg:load', this.slideImageLoaded);
      }

      if (this.isQuickshop) {
        this.$gallery.trigger('theme:rimg:unwatch');
      }

      Layout["a" /* default */].offBreakpointChange(this._onUpdateGallery);

      this._unloadGallery();
    }
  }, {
    key: "_init",
    value: function _init() {
      for (var i = 0; i < this.slideImages.length; i += 1) {
        this.slideImages[i].addEventListener('rimg:load', this.slideImageLoaded);
      }

      if (this.$slides.length) {
        this._initGallery();
      }
    }
    /**
     * Make sure Flickity updates viewport height when images load in
     * @private
     */

  }, {
    key: "_onSlideImageLoaded",
    value: function _onSlideImageLoaded() {
      if (!this.flickity) {
        return;
      }

      var activeHeight = this.flickity.selectedElement.offsetHeight;
      var flickityHeight = this.flickity.viewport.offsetHeight; // If flickity height is greater than slide height, ignore

      if (activeHeight < flickityHeight) {
        return;
      }

      this.flickity.resize();
    }
  }, {
    key: "_unloadGallery",
    value: function _unloadGallery() {
      if (this.flickity) {
        this.$paginationTrigger.off('.gallery');
        this.flickity.destroy();
        this.flickity = null;
        this.$slider.find(this.slides).attr('style', '');
      }
    }
  }, {
    key: "_onUpdateGallery",
    value: function _onUpdateGallery() {
      this._unloadGallery();

      this._initGallery();
    }
    /**
     * Update gallery on variant change
     *
     * @param variant
     * @property {Object} options.featured_image - Featured image information
     * @private
     */

  }, {
    key: "_onVariantChange",
    value: function _onVariantChange(variant) {
      if (!variant.featured_image || !this.flickity) {
        return;
      }

      var index = this.$slider.find("[data-product-image=".concat(variant.featured_image.id, "]")).attr('data-product-image-index');
      this.flickity.select(index, false, false);
    }
  }, {
    key: "_initGallery",
    value: function _initGallery() {
      var $selectedImage = this.$slider.find('.image--selected'); // Options shared on Desktop and Mobile

      var flickityOptions = {
        autoPlay: 0,
        accessibility: true,
        adaptiveHeight: true,
        cellAlign: 'left',
        cellSelector: this.slides,
        pageDots: false,
        imagesLoaded: true,
        prevNextButtons: false,
        wrapAround: true
      }; // Mobile only options

      var optionsMobile = {
        draggable: true,
        friction: 0.8,
        selectedAttraction: 0.2
      }; // Desktop only options

      var optionsDesktop = {
        draggable: false
      };

      if (Layout["a" /* default */].isBreakpoint('XS')) {
        flickityOptions = jquery_default.a.extend({}, optionsMobile, flickityOptions);
      } else {
        flickityOptions = jquery_default.a.extend({}, optionsDesktop, flickityOptions);
      } // If a variant has an image pre-selected, start the slideshow at that image
      // If the slideshow has been re-initalised across a break point, slideshow
      // restarts at same slide


      if ($selectedImage.length) {
        var initialIndex = parseInt($selectedImage.attr('data-product-image-index'), 10);
        flickityOptions = jquery_default.a.extend({}, {
          initialIndex: initialIndex
        }, flickityOptions);
      }

      this.flickity = new js_default.a(this.$slider[0], flickityOptions);

      this._bindGallery();
    }
  }, {
    key: "_bindGallery",
    value: function _bindGallery() {
      var _this = this;

      this.flickity.on('select', function () {
        _this._updateActiveSlide(_this.flickity.selectedIndex);
      });
      this.$paginationTrigger.on('click.gallery', function (event) {
        event.preventDefault();
        var $target = jquery_default()(event.currentTarget);

        _this.flickity.select($target.attr('data-product-thumbnail'), false, false);
      });
    }
    /**
     * Adds a non-flickity active class to thumbnails, and main slideshow
     *  - Is used on re-init across breakpoints
     *  - Is used to show the active thumbnail in the pagination
     *
     * @param index
     * @private
     */

  }, {
    key: "_updateActiveSlide",
    value: function _updateActiveSlide(index) {
      var $newSlide = this.$slider.find("[data-product-image-index=".concat(index, "]"));
      var $newThumbnail = this.$sliderPagination.find("[data-product-thumbnail=".concat(index, "]"));
      $newSlide.addClass('image--selected').siblings('.image--selected').removeClass('image--selected');
      $newThumbnail.addClass('thumbnail--selected').siblings('.thumbnail--selected').removeClass('thumbnail--selected');

      if (Layout["a" /* default */].isBreakpoint('XS')) {
        Object(helpers["v" /* scrollLeft */])($newThumbnail);
      }
    } // NOTE: Select quickshop product slider container after load and initialize rimg

  }, {
    key: "onQuickshopOpen",
    value: function onQuickshopOpen() {
      this.slideImages = this.$slider[0].querySelectorAll('[data-rimg]');

      this._onUpdateGallery();
    }
  }]);

  return ProductGallery;
}();


// EXTERNAL MODULE: ./node_modules/@shopify/theme-a11y/theme-a11y.js
var theme_a11y = __webpack_require__(98);

// CONCATENATED MODULE: ./source/scripts/components/ProductDetails.js
function ProductDetails_createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = ProductDetails_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function ProductDetails_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ProductDetails_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProductDetails_arrayLikeToArray(o, minLen); }

function ProductDetails_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ProductDetails_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ProductDetails_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ProductDetails_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductDetails_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductDetails_defineProperties(Constructor, staticProps); return Constructor; }








var ProductDetails_ProductDetails = /*#__PURE__*/function () {
  function ProductDetails(options) {
    ProductDetails_classCallCheck(this, ProductDetails);

    this.$window = jquery_default()(window);
    this.$body = jquery_default()(document.body);
    this.$product = options.$el;
    this.$formArea = options.$formArea;
    this.$gallery = options.$gallery;
    this.$details = options.$details;
    this.$detailsLink = options.$detailsLink;
    this.context = options.context;
    this.collection = options.collection;
    this.settings = options.settings;
    this.restrictions = options.restrictions;
    this.volumeEquivalencies = options.volumeEquivalencies;
    this.exclusivities = options.exclusivities;
    this.variantAvailabilities = options.variantAvailabilities;
    this.caseSizes = options.caseSizes;
    this.badges = options.badges;
    this.cdfData = options.cdfData;
    this.product = options.product;
    this.currentVariant = options.product.variants[0];
    this.useHistory = options.useHistory;
    this.type = options.type;
    this.title = options.product.title;
    this.skuOrderLimits = options.context.sku_order_limits;
    this.globalData = Object(helpers["q" /* getLiquidVars */])('[data-scripts]');
    this.variantHelper = null; // Product ATC Actions

    this._onATCOpen = this._onATCOpen.bind(this);
    this._onATCClose = this._onATCClose.bind(this);
    this.atcCallbacks = jquery_default.a.extend({
      onClose: this._onATCClose,
      onOpen: this._onATCOpen
    }, options.atcCallbacks); // Form

    this.$form = this.$formArea.find('[data-product-form] form');
    this.$productAtcButton = this.$formArea.find('[data-product-atc]');
    this.$productVariants = this.$form.find('[data-variants]');
    this.$productOptions = this.$form.find('[data-product-option]');

    if (this.type === 'product-item') {
      this.variantFields = {
        $price: this.$details.find('[data-price]'),
        $priceMoney: this.$details.find('[data-price] .money'),
        $compareAtPrice: this.$details.find('[data-price-compare-at]'),
        $compareAtPriceMoney: this.$details.find('[data-price-compare-at] .money'),
        $badge: this.$details.find('[data-product-badge]'),
        $sku: this.$formArea.find('[data-product-sku]'),
        $skuOrderLimit: this.$formArea.find('[data-sku-order-limit]'),
        $volumeEquivalency: this.$formArea.find('[data-product-volume-equivalency]'),
        $dollarPerGram: this.$details.find('[data-dollar-per-gram]')
      };
    } else {
      this.variantFields = {
        $price: this.$product.find('[data-price]'),
        $priceMoney: this.$product.find('[data-price] .money'),
        $compareAtPrice: this.$product.find('[data-price-compare-at]'),
        $compareAtPriceMoney: this.$product.find('[data-price-compare-at] .money'),
        $badge: this.$details.find('[data-product-badge]'),
        $sku: this.$product.find('[data-product-sku]'),
        $skuOrderLimit: this.$formArea.find('[data-sku-order-limit]'),
        $volumeEquivalency: this.$formArea.find('[data-product-volume-equivalency]'),
        $dollarPerGram: this.$details.find('[data-dollar-per-gram]')
      };
    }

    this.forms = new Forms["a" /* default */](this.$form);
    this.gallery = new ProductGallery_ProductGallery(options);
    this.manageCart = new helpers["g" /* ManageCart */]();

    if (this.$body.hasClass('template-cart')) {
      this.orderValidator = new helpers["h" /* OrderValidator */]();
    }

    this._parseCartData(null, this.globalData.cart);

    this._bindEvents();

    this._initOptions();
  }

  ProductDetails_createClass(ProductDetails, [{
    key: "onQuickshopOpen",
    value: function onQuickshopOpen() {
      this.gallery.onQuickshopOpen();
    }
  }, {
    key: "_parseCartData",
    value: function _parseCartData(event, cart) {
      var cartItems = {};

      var _iterator = ProductDetails_createForOfIteratorHelper(cart.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          cartItems[item.id] = item;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.cartItems = cartItems;
    }
  }, {
    key: "unload",
    value: function unload() {
      this.$form.off('.product-details');
      this.forms.unload();

      if (this.variantHelper) {
        this.variantHelper.unload();
      }

      this.gallery.unload();
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;

      this.$window.on('product-variant-switch.product-details', function (event, data) {
        return _this._switchVariant(event, data);
      });
      this.$body.on('product-details:update-cart', this._parseCartData.bind(this));
      this.$form.on('submit.product-details', function (event) {
        return _this._addToCart(event);
      });
      this.$form.on('keydown.product-details', '[data-product-quantity]', function (event) {
        return Object(helpers["u" /* numberInputValidation */])(event);
      });
    }
  }, {
    key: "_initOptions",
    value: function _initOptions() {
      if (!this.$productVariants.length) {
        return;
      }

      this.variantHelper = new VariantHelper_VariantHelper(this.product, this.variantAvailabilities, this.exclusivities, this.$productVariants, this.$productOptions);
    }
  }, {
    key: "_switchVariant",
    value: function _switchVariant(event, data) {
      if (data.product !== this.product) {
        return;
      }

      var variant = data.variant;
      var firstLoad = data.firstLoad;
      this.currentVariant = variant;

      if (firstLoad) {
        return;
      } // Update main select


      this.$productVariants.val(variant.id);
      this.gallery.variantChange(variant); // Update Variant information

      this._updatePrice(variant);

      this._updateBadge(variant);

      this._updateButton(variant);

      this._updateSku(variant);

      this._updateSkuOrderLimit(variant);

      this._updateVolumeEquivalency(variant);

      this._updateUrl(variant);

      this._updateDollarPerGram(variant);

      if (this.useHistory) {
        var url = "".concat(this.product.handle, "?").concat(jquery_default.a.param({
          variant: variant.id
        }));
        history.replaceState({}, 'variant', url);
      }
    }
  }, {
    key: "_updateUrl",
    value: function _updateUrl(variant) {
      if (!this.$detailsLink) {
        return;
      }

      var baseUrl = "/products/".concat(this.product.handle, "?").concat(jquery_default.a.param({
        variant: variant.id
      }));
      var url = this.collection ? "/collections/".concat(this.collection).concat(baseUrl) : baseUrl;
      this.$detailsLink.attr('href', url);
    }
  }, {
    key: "_updateSkuOrderLimit",
    value: function _updateSkuOrderLimit(variant) {
      // NOTE: Guard when product does not have an order limit and it may not exist.
      if (this.skuOrderLimits) {
        var orderLimit = this.skuOrderLimits[variant.sku] ? this.skuOrderLimits[variant.sku] : '';
        var renderOrderLimitLabel = orderLimit ? orderLimit : '';
        this.variantFields.$skuOrderLimit.html(renderOrderLimitLabel);
      }
    }
  }, {
    key: "_updatePrice",
    value: function _updatePrice(variant) {
      // Update compare at price
      var hasComparePrice = this._checkForOnSale(variant);

      this.variantFields.$compareAtPrice.toggleClass('visible', hasComparePrice);
      this.variantFields.$compareAtPriceMoney.text(Shopify.formatMoney(variant.compare_at_price, this.settings.money_format)); // Update price

      this.variantFields.$priceMoney.text(Shopify.formatMoney(variant.price, this.settings.money_format));
    }
  }, {
    key: "_updateBadge",
    value: function _updateBadge(variant) {
      var $badge = jquery_default()(this.badges[variant.id]);
      this.variantFields.$badge.html($badge);
    }
  }, {
    key: "_checkQuantity",
    value: function _checkQuantity(variant) {
      var limited = false;

      if (this.settings.quantity_flags.vq[variant.id]) {
        var productType = this.product.type.toLowerCase();
        var stock = parseInt(this.settings.quantity_flags.vq[variant.id], 10);

        if (productType === 'cannabis') {
          if (variant.price < parseInt(this.settings.quantity_flags.cannabis_price, 10)) {
            if (stock <= parseInt(this.settings.quantity_flags.cannabis_low, 10)) {
              limited = true;
            }
          } else if (stock <= parseInt(this.settings.quantity_flags.cannabis_high, 10)) {
            limited = true;
          }
        } else if (variant.price < parseInt(this.settings.quantity_flags.accessories_price, 10)) {
          if (stock <= parseInt(this.settings.quantity_flags.accessories_low, 10)) {
            limited = true;
          }
        } else if (stock <= parseInt(this.settings.quantity_flags.accessories_high, 10)) {
          limited = true;
        }
      }

      return limited;
    }
  }, {
    key: "_updateButton",
    value: function _updateButton(variant) {
      var availability_object = this.variantAvailabilities[variant.id];
      var variantAvailable;
      var buttonText;

      if (availability_object.wholesale_lifecycle === 'temporary_hold') {
        variantAvailable = false;
        buttonText = this.context.product_unavailable;
      } else if (!availability_object.available) {
        variantAvailable = false;
        buttonText = this.context.product_sold_out;
      } else {
        variantAvailable = true;
        buttonText = this.context.product_available;
      }

      this.$productAtcButton.find('[data-product-atc-text]').text(buttonText);

      if (variantAvailable) {
        this.$productAtcButton.removeClass('disabled').prop('disabled', false);
      } else {
        this.$productAtcButton.addClass('disabled').prop('disabled', true);
      }
    }
  }, {
    key: "_updateSku",
    value: function _updateSku(variant) {
      if (!variant.sku) {
        this.variantFields.$sku.empty();
        return false;
      }

      this.variantFields.$sku.text("SKU ".concat(variant.sku));
    }
  }, {
    key: "_updateVolumeEquivalency",
    value: function _updateVolumeEquivalency(variant) {
      var volumeEquivalency = this._getVolumeEquivalency(variant, this.variantFields.$volumeEquivalency);

      if (!volumeEquivalency) {
        return false;
      }

      var text = this.context.volume_equivalency.replace('** quantity **', volumeEquivalency);
      this.variantFields.$volumeEquivalency.text(text);
    }
    /**
     * Updates the dollar $/g messaging on variant switch.
     *
     * @param {string} variant.
     */

  }, {
    key: "_updateDollarPerGram",
    value: function _updateDollarPerGram(variant) {
      var $dollarPerGramEl = this.variantFields.$dollarPerGram;

      var volumeEquivalency = this._getVolumeEquivalency(variant, $dollarPerGramEl);

      var caseSize = this.caseSizes[variant.sku];

      if (!volumeEquivalency) {
        return false;
      }

      var displayDollarPerGram = Shopify.formatMoney(variant.price / volumeEquivalency / caseSize, this.settings.money_format);

      var isOnSale = this._checkForOnSale(variant);

      var saleClass = 'product-dollar-per-gram--sale';
      var uom = 'g';
      $dollarPerGramEl.toggleClass(saleClass, isOnSale).text("(".concat(displayDollarPerGram, "/").concat(uom, ")"));
    }
  }, {
    key: "_getVolumeEquivalency",
    value: function _getVolumeEquivalency(variant, $element) {
      if (!$element.length) {
        return false;
      }

      if (!variant.sku || !this.volumeEquivalencies[variant.sku]) {
        // Clear the element for variant switch
        $element.empty();
        return false;
      }

      return this.volumeEquivalencies[variant.sku];
    }
  }, {
    key: "_checkForOnSale",
    value: function _checkForOnSale(variant) {
      return !!variant.compare_at_price && variant.compare_at_price > variant.price;
    }
    /**
     * Prepare default set of data for atc requests
     */

  }, {
    key: "_formatVariantData",
    value: function _formatVariantData() {
      var _this$currentVariant = this.currentVariant,
          id = _this$currentVariant.id,
          sku = _this$currentVariant.sku;

      var _this$_getCdfInformat = this._getCdfInformation(sku),
          cdf = _this$_getCdfInformat.cdf,
          consumerUnits = _this$_getCdfInformat.consumerUnits,
          caseSize = _this$_getCdfInformat.caseSize;

      var availability = this.variantAvailabilities[id];
      var inCart = this.cartItems[id] ? this.cartItems[id].quantity : 0;
      return {
        available: !(availability.is_sold_out || availability.is_unavailable),
        caseSize: caseSize,
        cdf: cdf,
        consumerUnits: consumerUnits,
        id: id,
        quantity: 1,
        inCart: inCart,
        remaining: false,
        inventoryQuantity: this.settings.quantity_flags.vq[id] || false,
        sku: sku,
        title: this.title
      };
    }
    /**
     * Add a product to the cart.
     *
     * @param {object} event - event triggering the add to cart.
     */

  }, {
    key: "_addToCart",
    value: function _addToCart(event) {
      var _this2 = this;

      event.preventDefault();
      Object(helpers["j" /* disableButton */])(this.$productAtcButton);
      var formData = this.$form.serializeArray(); // Get the new quantity.

      var quantity = parseInt(formData[3].value, 10);
      var data = Object.assign(this._formatVariantData(), {
        quantity: quantity
      }); // True if interacting with quick shop modals from the "customers also
      // bought" section or header search on the cart page

      if (this.$body.hasClass('template-cart')) {
        var validateSku = this.orderValidator.validateSku({
          sku: this.currentVariant.sku,
          quantity: quantity
        });
        return jquery_default.a.when(validateSku).done(function (response) {
          var sku = response.sku,
              remaining = response.remaining,
              valid = response.valid; // Add remaining limit to request data

          data = Object.assign(data, {
            remaining: remaining
          }); // Update checkout button passing true, as we do not
          // know the validity of the entire order

          var validityFlag = true;

          _this2.$body.trigger('cart:update-checkout-button', validityFlag);

          _this2.manageCart.add(data, _this2.$productAtcButton);

          if (remaining === 0) {
            _this2.$body.trigger('cart:search-sku', [sku, remaining, valid]);
          }
        });
      }

      return this._continueAddToCart(quantity, false, this.$productAtcButton);
    }
  }, {
    key: "_continueAddToCart",
    value: function _continueAddToCart(quantity) {
      var remaining = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var productAtcButton = arguments.length > 2 ? arguments[2] : undefined;
      var data = Object.assign(this._formatVariantData(), {
        quantity: quantity,
        remaining: remaining
      });
      this.manageCart.add(data, productAtcButton);
    }
    /**
     * Get CDF information based on current variant's SKU
     * @param {string} sku of parent product
     */

  }, {
    key: "_getCdfInformation",
    value: function _getCdfInformation(sku) {
      var cdf = false;
      var consumerUnits = 1;
      var caseSize = 1;

      if (this.cdfData && this.cdfData[sku]) {
        cdf = this.cdfData[sku].cdf_sku;
        consumerUnits = parseInt(this.cdfData[sku].consumer_units, 10);
        caseSize = parseInt(this.cdfData[sku].case_size, 10);
      }

      return {
        cdf: cdf,
        consumerUnits: consumerUnits,
        caseSize: caseSize
      };
    }
    /**
     * Callback when AddToCartFlyout opens
     * Move keyboard focus into flyout
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @private
     */

  }, {
    key: "_onATCOpen",
    value: function _onATCOpen(options) {
      Object(theme_a11y["b" /* trapFocus */])(options.$container, {
        elementToFocus: options.$elementToFocus
      });
    }
    /**
     * Callback when AddToCartFlyout closes
     * Move keyboard focus back into grid item
     *
     * @private
     */

  }, {
    key: "_onATCClose",
    value: function _onATCClose() {
      Object(theme_a11y["a" /* removeTrapFocus */])();
      this.$productAtcButton.focus();
    }
  }]);

  return ProductDetails;
}();



/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ RelatedProducts_RelatedProducts; });

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(0);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/scriptjs/dist/script.js
var script = __webpack_require__(24);
var script_default = /*#__PURE__*/__webpack_require__.n(script);

// EXTERNAL MODULE: ./node_modules/@pixelunion/rimg/dist/index.es.js
var index_es = __webpack_require__(93);

// EXTERNAL MODULE: ./source/scripts/components/ProductListItem.js + 1 modules
var ProductListItem = __webpack_require__(48);

// CONCATENATED MODULE: ./source/scripts/components/RelatedProductsTemplates.js
/**
 * Shows a product list item component when result is a product
 *
 * @param product
 * @param enableImages
 * @returns {string}
 * @constructor
 */
function ProductItem(product, enableImages) {
  return "\n    ".concat(product.item_html, "\n  ");
}
/**
 * Shows a list of product results
 *
 * @param props
 * @returns {jQuery|HTMLElement}
 * @constructor
 */


function ProductResults(props) {
  var products = props.products,
      enableImages = props.enableImages;
  var productItems = products.map(function (product) {
    return ProductItem(product, enableImages);
  });
  return $("\n    ".concat(productItems.join(''), "\n  "));
}


// EXTERNAL MODULE: ./source/scripts/components/ProductRowScroller.js
var ProductRowScroller = __webpack_require__(165);

// EXTERNAL MODULE: ./source/scripts/Search.js
var Search = __webpack_require__(95);

// CONCATENATED MODULE: ./source/scripts/components/RelatedProducts.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }









var RelatedProducts_RelatedProducts = /*#__PURE__*/function () {
  function RelatedProducts(section) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, RelatedProducts);

    this.section = section;
    this.$el = jquery_default()(section.el);
    this.sectionId = this.$el.attr('id');
    this.settings = section.data.settings;
    this.$relatedProducts = this.$el.find('[data-related-products]');
    this.$relatedProductsItems = this.$relatedProducts.find('[data-related-products-items]');
    this.searchTerms = this.$relatedProducts.data('related-products');
    this.relatedProducts = [];
    this.options = jquery_default.a.extend({
      limit: 5,
      hasScroller: true
    }, options);

    if (this.$relatedProducts.is('[data-related-products-type="smart"]')) {
      this._initSmart();
    } else {
      this._init();
    }
  }

  _createClass(RelatedProducts, [{
    key: "_init",
    value: function _init() {
      var _this = this;

      if (this.options.hasScroller) {
        // Initialize scroll layout
        this.relatedProductsScroller = new ProductRowScroller["a" /* default */](this.$relatedProductsItems[0]);
      } // Initialize product item functionality


      this.$relatedProducts.find('[data-product-item]').each(function (i, productItem) {
        _this.relatedProducts.push(new ProductListItem["a" /* default */](jquery_default()(productItem), _this.sectionId));
      });
    }
  }, {
    key: "_initSmart",
    value: function _initSmart() {
      var _this2 = this;

      var $scripts = jquery_default()('[data-scripts]');
      script_default()($scripts.data('shopify-api-url'), function () {
        _this2.search = new Search["a" /* default */]({
          view: 'related',
          type: 'product'
        });

        _this2.search.on('complete', _this2._searchComplete.bind(_this2));

        _this2.search.execute(_this2.searchTerms);
      });
    }
  }, {
    key: "_searchComplete",
    value: function _searchComplete(response) {
      // Remove `Related products` section when products aren't present.
      if (!response.products.length) {
        this.$relatedProducts.remove();
        return;
      }

      var products = response.products,
          terms = response.terms;
      var productsToRender = products.slice(0, this.options.limit);
      var settings = {
        products: {
          results: {
            products: productsToRender,
            enableImages: true
          },
          noResults: {
            context: 'no results right now',
            terms: terms
          }
        }
      };
      var $productResults = ProductResults(settings.products.results); // Show results

      this.$relatedProductsItems.html($productResults);
      this.$relatedProducts.addClass('active'); // Load images

      Object(index_es["a" /* default */])('[data-related-products-items] [data-rimg]');

      this._init();
    }
  }, {
    key: "unload",
    value: function unload() {
      this.relatedProducts.forEach(function (productItem) {
        return productItem.unload();
      });
    }
  }]);

  return RelatedProducts;
}();



/***/ }),

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ disableButton; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ CartValidator_CartValidator; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ EventHandler; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ InfiniteScroll_InfiniteScroll; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ LazyLoader; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ ManageCart_ManageCart; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ OrderValidator_OrderValidator; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ CDFupdateQuantities; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ CDFQuantityTotal; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* reexport */ flickityTouchFix; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* reexport */ getCart_getCart; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* reexport */ getHeaderOffset; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* reexport */ getLiquidVars; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ productsByCustomerTypeCheck_filterByCustomerType; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* reexport */ isMoney; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* reexport */ formatMoney; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* reexport */ localStorage; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* reexport */ sessionTimer; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ deleteLS; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* reexport */ getLS; });
__webpack_require__.d(__webpack_exports__, "x", function() { return /* reexport */ setLS; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* reexport */ makeIDsUnique; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* reexport */ numberInputValidation; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* reexport */ scrollLeft; });
__webpack_require__.d(__webpack_exports__, "y", function() { return /* reexport */ useIntegrationAPI; });

// UNUSED EXPORTS: enableButton, Images, ManageCartMessages, ManageFees, storeFront, SHIPPING_RATES

// CONCATENATED MODULE: ./source/scripts/helpers/buttonState.js
/**
 * Helper functions for enabling/disabling
 * button states.
 */
var enableButton = function enableButton(button) {
  button.prop('disabled', false).removeClass('processing');
};
var disableButton = function disableButton(button) {
  button.addClass('processing').prop('disabled', true);
};
// EXTERNAL MODULE: ./source/scripts/Forms.js
var Forms = __webpack_require__(21);

// CONCATENATED MODULE: ./source/scripts/helpers/liquidJsHelpers.js
var moneyKeys = ['discounted_price', 'line_price', 'price', 'subtotal_price', 'tax_price', 'total_discount', 'total_discounts', 'total_line_items_price', 'total_price', 'total_price_usd', 'total_tax', 'total_tip_received', 'total_spent'];
function isMoney(key) {
  return moneyKeys.indexOf(key) !== -1;
}
function formatMoney(money) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'currency';
  var useGrouping = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var cents = "".concat(money).indexOf('.') !== -1 ? money * 100 : money;
  var formatter = new Intl.NumberFormat('en-CA', {
    style: style,
    currency: 'CAD',
    minimumFractionDigits: 2,
    useGrouping: useGrouping
  });
  return formatter.format(cents / 100);
}
// EXTERNAL MODULE: ./node_modules/lodash/fp/isObject.js
var isObject = __webpack_require__(385);
var isObject_default = /*#__PURE__*/__webpack_require__.n(isObject);

// EXTERNAL MODULE: ./node_modules/lodash/fp/isArray.js
var isArray = __webpack_require__(386);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);

// EXTERNAL MODULE: ./node_modules/eventemitter2/lib/eventemitter2.js
var eventemitter2 = __webpack_require__(162);
var eventemitter2_default = /*#__PURE__*/__webpack_require__.n(eventemitter2);

// CONCATENATED MODULE: ./source/scripts/helpers/EventHandler.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


/**
 * Event handler API Class
 */

var EventHandler = /*#__PURE__*/function (_EventEmitter) {
  _inherits(EventHandler, _EventEmitter);

  var _super = _createSuper(EventHandler);

  function EventHandler() {
    var _this;

    _classCallCheck(this, EventHandler);

    _this = _super.call(this);

    if (!!EventHandler.instance) {
      return _possibleConstructorReturn(_this, EventHandler.instance);
    }

    EventHandler.instance = _assertThisInitialized(_this);
    return _this;
  }

  return EventHandler;
}(eventemitter2_default.a);
// CONCATENATED MODULE: ./source/scripts/helpers/getLiquidVars.js
/**
 * A helper to return a JSON object of Liquid variables.
 * @param {selector}
 * @returns {JSON}
 */
function getLiquidVars() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var context = parent ? parent : document;
  var dataEl = context.querySelector(selector);

  try {
    return JSON.parse(dataEl.innerHTML);
  } catch (error) {
    return null;
  }
}
// CONCATENATED MODULE: ./source/scripts/helpers/ManageFees.js
function ManageFees_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }


var ManageFees_ManageFees = /*#__PURE__*/function () {
  function ManageFees() {
    ManageFees_classCallCheck(this, ManageFees);

    var data = getLiquidVars('[data-scripts]');
    this.cdf = this._getAccessibleCdfObject(data.cdf);
    this.updateCartFeesTracking(data.cart);
  }
  /**
   * Gets fee associated with cart item
   * @param {string} id cart item id
   */


  _createClass(ManageFees, [{
    key: "getAssociatedCdfItemFromCart",
    value: function getAssociatedCdfItemFromCart(id) {
      return this.cartFees[id] || false;
    }
    /**
     * Updates fee tracking object (called on cart updates)
     * @param {object} cart
     */

  }, {
    key: "updateCartFeesTracking",
    value: function updateCartFeesTracking(cart) {
      this.cartFees = this._getAccessibleCartFees(cart);
    }
    /**
     * Checks if item has associated fees
     * @param {object} variant
     * @param {string} key
     */

  }, {
    key: "checkFeeRequirements",
    value: function checkFeeRequirements(variant, key) {
      if (!variant.cdf) {
        return false;
      }

      return this._addFees(variant, key);
    }
    /**
     * Formats the CDF item's variants for easy lookup
     * @param {object} cdf Shopify formatted product item
     */

  }, {
    key: "_getAccessibleCdfObject",
    value: function _getAccessibleCdfObject(cdf) {
      var accessibleCdf = {};

      if (cdf.variants === undefined) {
        throw new Error('Container deposit fee product is not available');
      }

      cdf.variants.map(function (v) {
        accessibleCdf[v.sku] = v.id;
      });
      return accessibleCdf;
    }
    /**
     * Returns filtered object of fee items from cart
     * @param {object} cart
     */

  }, {
    key: "_getAccessibleCartFees",
    value: function _getAccessibleCartFees(cart) {
      var accessibleCartFees = {};
      cart.items.map(function (i) {
        if (i.product_type.toLowerCase() === 'fee') {
          accessibleCartFees[i.properties.id] = i.key;
        }
      });
      return accessibleCartFees;
    }
    /**
     * Adds fee items to cart request
     * @param {object} variant
     * @param {string} key
     */

  }, {
    key: "_addFees",
    value: function _addFees(variant, key) {
      var caseSize = variant.caseSize,
          cdf = variant.cdf,
          consumerUnits = variant.consumerUnits,
          id = variant.id,
          quantity = variant.quantity,
          sku = variant.sku; // It's possible due to liquid splitting that the cdf exists, but is not
      // representative of an actual cdf item. Let's weed those out.

      if (!this.cdf[cdf]) {
        return false;
      } // Calculate proper CDF quantity


      var cdfQuantity = caseSize * consumerUnits * quantity; // Check if CDF already exists within the cart
      // only applicable to cart updates (not adds)

      if (key === 'updated') {
        var cdfKey = this.getAssociatedCdfItemFromCart(id);

        if (cdfKey) {
          return {
            id: cdfKey,
            quantity: cdfQuantity
          };
        }
      } // If not already in cart create new CDF payload


      return {
        id: this.cdf[cdf],
        // Get correct CDF variant ID
        quantity: cdfQuantity,
        // Passing properties to fee item differentiates it from other instances
        // of the same variant ID
        properties: {
          sku: sku,
          id: id
        }
      };
    }
  }]);

  return ManageFees;
}();
// EXTERNAL MODULE: ./node_modules/lodash/fp/findIndex.js
var findIndex = __webpack_require__(387);
var findIndex_default = /*#__PURE__*/__webpack_require__.n(findIndex);

// CONCATENATED MODULE: ./source/scripts/helpers/ManageCartMessages.js
function ManageCartMessages_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ManageCartMessages_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ManageCartMessages_createClass(Constructor, protoProps, staticProps) { if (protoProps) ManageCartMessages_defineProperties(Constructor.prototype, protoProps); if (staticProps) ManageCartMessages_defineProperties(Constructor, staticProps); return Constructor; }



var ManageCartMessages_ManageCartMessages = /*#__PURE__*/function () {
  function ManageCartMessages() {
    ManageCartMessages_classCallCheck(this, ManageCartMessages);

    if (!!ManageCartMessages.instance) {
      return ManageCartMessages.instance;
    }

    ManageCartMessages.instance = this;
    var data = getLiquidVars('[data-scripts]');
    this.lang = data.context.atc_banner;
    this.init();
  }
  /**
   * Initializes/reset message log
   */


  ManageCartMessages_createClass(ManageCartMessages, [{
    key: "init",
    value: function init() {
      this.messages = this._createEmptyState();
    }
    /**
     * Creates initial/empty cart request object
     */

  }, {
    key: "_createEmptyState",
    value: function _createEmptyState() {
      return {
        items: []
      };
    }
    /**
     * Retrieves current message log
     */

  }, {
    key: "get",
    value: function get() {
      return this.messages;
    }
    /**
     * Adds to messages object
     * @param {object} item
     * @param {string} key defines type of add to cart action or error
     */

  }, {
    key: "add",
    value: function add(variant, key) {
      var id = variant.id,
          quantity = variant.quantity,
          sku = variant.sku;

      var message = this._getMessage(key);

      this.messages.items.push(Object.assign({
        id: id,
        quantity: quantity,
        sku: sku
      }, message));
      return message;
    }
    /**
     * Removes item from logged messages
     * @param {int} id
     */

  }, {
    key: "remove",
    value: function remove(id) {
      var index = findIndex_default()({
        id: id
      }, this.messages.items);
      this.messages.items.splice(index, 1);
    }
    /**
     * Returns error messaging for atc requests
     * @param {string} key
     */

  }, {
    key: "_getMessage",
    value: function _getMessage(key) {
      switch (key) {
        case 'not_available':
          return {
            error: true,
            reason: key,
            message: this.lang.not_available
          };

        case 'out_of_stock':
          return {
            error: true,
            reason: key,
            message: this.lang.out_of_stock
          };

        case 'insufficient_stock':
          return {
            error: true,
            reason: key,
            message: this.lang.quantity_unavailable
          };

        case 'exceeds_limit':
          return {
            error: true,
            reason: key,
            message: this.lang.quantity_unavailable
          };

        case 'removed':
          return {
            error: false,
            reason: key,
            message: this.lang.items_removed_single.replace('*count*', '1')
          };

        case 'pact_unavailable':
          return {
            error: true,
            reason: key,
            message: this.lang.pact_unavailable.replace('*count*', '1')
          };

        case 'updated':
          return {
            error: false,
            reason: key,
            message: this.lang.quantity_revised
          };

        default:
          return {
            error: false,
            reason: 'added',
            message: this.lang.items_added_single
          };
      }
    }
  }, {
    key: "getToast",
    value: function getToast() {
      var message;
      var locale = this.lang;
      var items = this.messages.items;
      var errorCount = items.filter(function (i) {
        return i.error;
      }).length;
      var updates = items.filter(function (i) {
        return i.reason === 'updated';
      });
      var additions = items.filter(function (i) {
        return i.reason === 'added';
      });
      var removals = items.filter(function (i) {
        return i.reason === 'removed';
      });
      var pactUnavailable = items.filter(function (i) {
        return i.reason === 'pact_unavailable';
      });
      this.messages.errorCount = errorCount; // If only 1 item updated, return that item's message

      if (items.length === 1) {
        this.messages.message = items[0].message;
        return this.messages.message;
      } // If multiple updates, determine relevant messaging


      if (pactUnavailable.length) {
        message = locale.pact_unavailable.replace('*count*', pactUnavailable.length);
      } else if (errorCount > 0) {
        message = locale.default_error.replace('*count*', errorCount);
      } else if (updates.length) {
        message = locale.quantity_revised;
      } else if (additions.length) {
        message = locale.items_added_other.replace('*count*', additions.length);
      } else if (removals.length) {
        message = locale.items_removed_other.replace('*count*', removals.length);
      } else {
        message = locale.default.replace('*count*', items.length);
      }

      this.messages.message = message;
      return this.messages.message;
    }
  }]);

  return ManageCartMessages;
}();
// CONCATENATED MODULE: ./source/scripts/helpers/ManageCart.js
function ManageCart_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ManageCart_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ManageCart_createClass(Constructor, protoProps, staticProps) { if (protoProps) ManageCart_defineProperties(Constructor.prototype, protoProps); if (staticProps) ManageCart_defineProperties(Constructor, staticProps); return Constructor; }







var ManageCart_ManageCart = /*#__PURE__*/function () {
  function ManageCart() {
    ManageCart_classCallCheck(this, ManageCart);

    if (!!ManageCart.instance) {
      return ManageCart.instance;
    }

    ManageCart.instance = this;
    this.addEndpoint = '/cart/add.js';
    this.updateEndpoint = '/cart/update.js';
    this.eventHandler = new EventHandler();
    this.messages = new ManageCartMessages_ManageCartMessages();
    this.manageFees = new ManageFees_ManageFees();
    this.cartRequest = {};
  }
  /**
   * Stages an item in cart request
   * @param {object} variant
   */


  ManageCart_createClass(ManageCart, [{
    key: "stage",
    value: function stage(variant, key) {
      var item = {
        id: variant.id,
        // Quantity requested by customer
        quantity: variant.quantity,
        variant: variant
      }; // If we're using the update endpoint we will want to disregard
      // what is currently in the cart, as we will be overriding the
      // in cart value.

      if (key === 'updated') {
        variant.inCart = 0;
      }

      var variantIssue = this._checkVariantAvailability(variant, key); // Error message is logged and we abort staging to ensure that
      // this item doesn't make it into the final cart request


      if (variantIssue.error) {
        var quantity;

        switch (variantIssue.reason) {
          // If the request exceeds the remaining limit or available stock
          // we don't want to stop the request, but we want to ensure that
          // the messaging is logged appropriately. The above availability
          // check will log the message, and then we will update the request
          // quantity to the remaining limit. This only applies to cart
          // updates.
          case 'exceeds_limit':
            var quantityDifference = variant.remaining - variant.inCart;

            if (quantityDifference < 0) {
              item.quantity = variant.remaining;
              variant.quantity = variant.remaining;
            }

            break;

          case 'insufficient_stock':
            quantity = variant.inventoryQuantity - variant.inCart; // Ensure the request is a positive value

            quantity = quantity < 0 ? 0 : quantity;
            item.quantity = quantity;
            variant.quantity = quantity;
            break;

          default:
            // Return false if error on any other type of request to
            // ensure the item doesn't make it into the final cart
            // request object.
            return false;
        }
      }

      var requiredFees = this.manageFees.checkFeeRequirements(variant, key);

      if (requiredFees && requiredFees.id !== undefined) {
        item.fees = requiredFees;
      }

      this.cartRequest[variant.id] = item;
    }
    /**
     * Restages cart request items given new quantity requirements
     * @param {object} cartRequest current cart request
     * @param {integer} quantity new quantity
     */

  }, {
    key: "restageAll",
    value: function restageAll(cartRequest, key) {
      var _this = this;

      var quantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      if (isNaN(quantity)) {
        return this._handleFail();
      }

      this._clearRequest();

      Object.values(cartRequest).map(function (r) {
        r.variant.quantity = quantity;

        _this.stage(r.variant, key);
      });
    }
    /**
     * Removes item from cart request staging
     * @param {integer} id
     */

  }, {
    key: "unstage",
    value: function unstage(id) {
      this.messages.remove(id);
      delete this.cartRequest[id];
    }
    /**
     * Removes all items from cart request staging
     */

  }, {
    key: "unstageAll",
    value: function unstageAll() {
      this._clearRequest();
    }
    /**
     * Stages and then submits request
     * @param {object} variant
     */

  }, {
    key: "add",
    value: function add(variant) {
      var buttonStateHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.unstageAll();
      this.stage(variant);
      this.submit('add', buttonStateHandler);
    }
    /**
     * Updates cart quantity of specific item
     * @param {object} variant
     */

  }, {
    key: "update",
    value: function update(variant) {
      var buttonStateHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var key = 'updated';
      this.unstageAll();
      this.stage(variant, key);
      this.submit('update', buttonStateHandler);
    }
    /**
     * Updates multiple items to a single quantity value
     * Also used to selectively remove items from cart
     * @param {integer} quantity
     * @param {string} key
     */

  }, {
    key: "updateAll",
    value: function updateAll(quantity) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'updated';
      var buttonStateHandler = arguments.length > 2 ? arguments[2] : undefined;

      if (!isNaN(quantity)) {
        this.restageAll(this.cartRequest, key, quantity);
      }

      this.submit('update', buttonStateHandler);
    }
    /**
     * Formats update payload and triggers removal
     * @param {object} or {array of objects} variants
     * @param {string} key cart item key
     */

  }, {
    key: "remove",
    value: function remove(variants) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'removed';

      var isArrayHasElement = function isArrayHasElement() {
        var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return isArray_default()(arr) && !arr.length;
      };

      if (!isObject_default()(variants) || isArrayHasElement(variants)) return false; // eslint-disable-line curly

      this.unstageAll(); // Ensure we're working with an array of variant objects

      Array.isArray(variants) ? this._removeAll(variants, key) : this._removeSingle(variants, key);
      this.submit('update');
    }
  }, {
    key: "_removeSingle",
    value: function _removeSingle(variant, key) {
      this._formatPayload(variant);

      this.messages.add(variant, key);
    }
    /**
     * Triggers removal of variants
     * @param {array} array of variants
     */

  }, {
    key: "_removeAll",
    value: function _removeAll(variants, key) {
      var _this2 = this;

      variants.forEach(function (variant) {
        _this2._formatPayload(variant);

        _this2.messages.add(variant, key);
      });
    }
    /**
     * Formats payload
     * @param {object} variant
     */

  }, {
    key: "_formatPayload",
    value: function _formatPayload(variant) {
      var id = variant.id,
          key = variant.key;
      var cdfKey = this.manageFees.getAssociatedCdfItemFromCart(id);
      this.cartRequest[key] = {
        id: key,
        quantity: 0
      };

      if (cdfKey) {
        this.cartRequest[key].fees = {
          id: cdfKey,
          quantity: 0
        };
      }
    }
    /**
     * Remove all items from the cart
     */

  }, {
    key: "clear",
    value: function clear() {
      Shopify.clear(function () {
        // Reload cart page
        window.location = '/cart';
      });
    }
    /**
     * Runs variant availability checks
     * @param {object} variant
     */

  }, {
    key: "_checkVariantAvailability",
    value: function _checkVariantAvailability(variant, key) {
      // Price is 0 (these items shouldn't be visible in the UI, but just in case)
      if (variant.price === 0) {
        return this.messages.add(variant, 'not_available');
      } // Current quantity is 0
      else if (typeof variant.inventoryQuantity === 'number' && variant.inventoryQuantity === 0) {
          return this.messages.add(variant, 'out_of_stock');
        } // OLOT remaining allowable is less than request quantity
        else if (typeof variant.remaining === 'number' && variant.remaining < variant.quantity + variant.inCart) {
            return this.messages.add(variant, 'exceeds_limit');
          } // Current quantity is less than request quantity
          else if (typeof variant.inventoryQuantity === 'number' && variant.inventoryQuantity < variant.quantity + variant.inCart) {
              return this.messages.add(variant, 'insufficient_stock');
            } // Product lifecycle status
            else if (variant.metafields && variant.metafields.status.wholesale_life_cycle === 'temporary_hold') {
                return this.messages.add(variant, 'not_available');
              } // Variant not available as defined by Shopify
              else if (!variant.available) {
                  return this.messages.add(variant, 'not_available');
                } // No issues


      return this.messages.add(variant, key);
    }
    /**
     * Process compiled add to cart request
     */

  }, {
    key: "submit",
    value: function submit(type, buttonStateHandler) {
      if (!Object.keys(this.cartRequest).length) {
        this._handleFail('There was nothing in your request', buttonStateHandler);
      } else if (type === 'add') {
        this._ajaxRequest(this.addEndpoint, this._formatAddRequest(this.cartRequest), buttonStateHandler);
      } else if (type === 'update') {
        this._ajaxRequest(this.updateEndpoint, this._formatUpdateRequest(this.cartRequest), buttonStateHandler);
      }
    }
    /**
     * Executes AJAX request to Shopify
     * @param {string} url endpoint to send request to
     * @param {object} data payload to send with request
     */

  }, {
    key: "_ajaxRequest",
    value: function _ajaxRequest(url, data, buttonStateHandler) {
      var _this3 = this;

      return $.ajax({
        method: 'POST',
        url: url,
        data: data,
        dataType: 'json'
      }).done(function (response) {
        // Update requests return the cart automatically, while
        // add requests only return the added item. If the response
        // contains a token, we know it is the full cart, and can
        // proceed with our success state.
        if (response.token) {
          return _this3._handleSuccess(response, buttonStateHandler);
        } // eslint-disable-line curly
        // If we recognize the response as not being a complete cart
        // we will attempt to get the full cart.


        _this3._getCart().then(function (cart) {
          return _this3._handleSuccess(cart, buttonStateHandler);
        }) // If cart couldn't be retreived we run the risk of our fee tracking
        // coming out-of-sync and must force a refresh of the page.
        .fail(function () {
          return location.reload();
        });
      }).fail(function (xhr) {
        return _this3._handleError(xhr, buttonStateHandler);
      });
    }
  }, {
    key: "_handleError",
    value: function _handleError(xhr, buttonStateHandler) {
      var errors = $.parseJSON(xhr.responseText);
      console.error(errors);

      this._handleFail('There was an error', buttonStateHandler);
    }
    /**
     * Formats staged cart request for use with Shopify's ajax api
     * @param {object} cartRequest
     */

  }, {
    key: "_formatAddRequest",
    value: function _formatAddRequest(cartRequest) {
      var request = [];
      Object.values(cartRequest).map(function (r) {
        request.push({
          id: r.id,
          quantity: r.quantity
        });

        if (r.fees) {
          request.push({
            id: r.fees.id,
            quantity: r.fees.quantity,
            properties: r.fees.properties
          });
        }
      });
      return {
        items: request
      };
    }
    /**
     * Formats staged cart request for use with Shopify's ajax api
     * @param {object} cartRequest
     */

  }, {
    key: "_formatUpdateRequest",
    value: function _formatUpdateRequest(cartRequest) {
      var request = {};
      Object.values(cartRequest).map(function (r) {
        request[r.id] = r.quantity;

        if (r.fees) {
          request[r.fees.id] = r.fees.quantity;
        }
      });
      return {
        updates: request
      };
    }
    /**
     * Reset cart request
     */

  }, {
    key: "_clearRequest",
    value: function _clearRequest() {
      this.cartRequest = {};
      this.messages.init();
    }
    /**
     * Get cart from Shopify ajax api
     */

  }, {
    key: "_getCart",
    value: function _getCart() {
      return $.ajax({
        method: 'GET',
        url: '/cart.js',
        dataType: 'json'
      });
    }
    /**
     * Handle successful request
     * @param {object} cart
     */

  }, {
    key: "_handleSuccess",
    value: function _handleSuccess(cart, buttonStateHandler) {
      this.manageFees.updateCartFeesTracking(cart); // pushMessage event must be emitted first as a result of
      // cartUpdate clearing the message logging
      // TODO: can we avoid this premature message log reset?
      // Emit `pushMessage` event only if there are items in the
      // message array.

      if (this.messages.messages.items.length > 0) {
        this.eventHandler.emit('pushMessage', this.messages.getToast());
      }

      this.eventHandler.emit('cartUpdate', cart, this.messages.get());
      this.eventHandler.emit('cartRequestComplete');

      if (buttonStateHandler) {
        enableButton(buttonStateHandler);
      }

      this._clearRequest();
    }
    /**
     * Handle failed cart request
     * @param {string} message
     */

  }, {
    key: "_handleFail",
    value: function _handleFail() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'There was an error';
      var buttonStateHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.eventHandler.emit('pushMessage', message);
      this.eventHandler.emit('cartRequestComplete');

      if (buttonStateHandler) {
        enableButton(buttonStateHandler);
      }

      this._clearRequest();
    }
  }]);

  return ManageCart;
}();
// EXTERNAL MODULE: ./node_modules/lodash/fp/getOr.js
var getOr = __webpack_require__(49);
var getOr_default = /*#__PURE__*/__webpack_require__.n(getOr);

// CONCATENATED MODULE: ./source/scripts/helpers/OrderValidator.js
function OrderValidator_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderValidator_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderValidator_createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderValidator_defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderValidator_defineProperties(Constructor, staticProps); return Constructor; }



/**
 * Accept a Shopify Cart object, packages a payload, and sends it off
 * to the Integration and returns the response.
 */

var OrderValidator_OrderValidator = /*#__PURE__*/function () {
  function OrderValidator() {
    OrderValidator_classCallCheck(this, OrderValidator);
  }

  OrderValidator_createClass(OrderValidator, [{
    key: "validateCart",
    value:
    /**
     * ValidateCart
     * @param {Shopify Cart} - A Shopify Cart, eg: /cart.js
     * @return {Boolean} A boolean if the Cart is valid.
     */
    function validateCart() {
      var cart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var items = getOr_default()({}, 'items', cart);
      var subtotal = getOr_default()(0, 'items_subtotal_price', cart);
      var formattedCart = {
        line_items: this._formatCartItems(items),
        subtotal:  false || formatMoney(subtotal, 'decimal', false)
      };
      return this._sendPayload(formattedCart);
    }
    /**
     * ValidateSku
     * @param {item} - SKU request object { sku: "12345", quantity: 5 }
     * @return {Boolean} A boolean if the Cart is valid.
     */

  }, {
    key: "validateSku",
    value: function validateSku() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._sendPayload(item, 'sku');
    }
    /**
     * Formats the cart's items into expected shape for payload.
     *
     * @param {cartItems} - Accepts a Shopify cart.items array
     * @returns [formattedCart] - Cart structured for the Integration
     * @private
     */

  }, {
    key: "_formatCartItems",
    value: function _formatCartItems() {
      var cartItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return cartItems.reduce(function (items, item) {
        items.push({
          quantity: item.quantity,
          sku: item.sku
        });
        return items;
      }, []);
    }
    /**
     * Send the payload to the Integration.
     *
     * @param structuredPayload:object A formatted object from _formattedCartItems
     * @param validationType:string 'cart' Accepts a structured cart from a local validate function
     * @return jquery.Deferred - the ajax success function
     * @private
     */

  }, {
    key: "_sendPayload",
    value: function _sendPayload() {
      var structuredPayload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var validationType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cart';
      var api = useIntegrationAPI();
      var cartItems = {};
      cartItems[validationType] = structuredPayload;
      var payload = Object.assign(cartItems, api.authPayload());
      return $.ajax({
        url: api.postValidate(validationType),
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(payload)
      });
    }
  }]);

  return OrderValidator;
}();
// CONCATENATED MODULE: ./source/scripts/helpers/CartValidator.js
function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function CartValidator_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CartValidator_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function CartValidator_createClass(Constructor, protoProps, staticProps) { if (protoProps) CartValidator_defineProperties(Constructor.prototype, protoProps); if (staticProps) CartValidator_defineProperties(Constructor, staticProps); return Constructor; }





var CartValidator_CartValidator = /*#__PURE__*/function () {
  function CartValidator(data, $el, $form) {
    CartValidator_classCallCheck(this, CartValidator);

    this.$body = $(document.body);
    this.$el = $el;
    this.$form = $form;
    this.$remainingBudgetContainer = this.$el.find('[data-cart-remaining]');
    this.$remainingBudget = this.$remainingBudgetContainer.find('[data-cart-remaining-total]');
    this.$warningRemainingAllowance = this.$el.find('[data-cart-warning="remaining"]');
    this.orderValidator = new OrderValidator_OrderValidator();
    this.manageCart = new ManageCart_ManageCart(); // Only validate cart if it contains items

    if (data.cart.items.length) {
      this.validateOrder(data.cart);
    }

    this._validateForm();
  }
  /**
   * Request cart validation from integration
   *
   * @param {cart} - Shopify cart object
   * @public
   */


  CartValidator_createClass(CartValidator, [{
    key: "validateOrder",
    value: function validateOrder(shopCart) {
      var _this = this;

      var isSubmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.requiresAdjustment = false;
      var cartValidation = this.orderValidator.validateCart(shopCart);
      return $.when(cartValidation).then(function (response) {
        var cart = response.cart,
            subtotal = response.subtotal,
            valid = response.valid; // Update the checkout button based on order validity

        _this.$body.trigger('cart:update-checkout-button', valid); // If attempting to submit the cart we will check validity
        // and move on to the checkout if valid


        if (isSubmit && valid) {
          _this.$form.trigger('submit', true);
        } // Render remaining weekly budget within cart
        // totals sidebar


        _this._renderRemainingBudget(subtotal); // Adjust line item quantities


        var _iterator = _createForOfIteratorHelper(cart),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            _this._adjustLineItem(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (_this.requiresAdjustment) {
          _this.manageCart.updateAll();

          _this.requiresAdjustment = false;
        }
      });
    }
    /**
     * Show/validate remaining weekly budget
     *
     * @param {validationObject} - Response from integration
     * @private
     */

  }, {
    key: "_renderRemainingBudget",
    value: function _renderRemainingBudget(subtotalObject) {
      var remaining = subtotalObject.remaining,
          valid = subtotalObject.valid;

      if (remaining) {
        var remainingDollars = formatMoney(remaining);
        var remainingClass = valid ? 'visible' : 'visible error';
        this.$remainingBudgetContainer.addClass(remainingClass);
        this.$remainingBudget.html(remainingDollars);
      }

      if (!valid) {
        this.$warningRemainingAllowance.addClass('active');
      }
    }
    /**
     * Force adjust quantity of line items based
     * on remaining allowable purchase quantity
     *
     * @param {validationItem} - Item object from order validation
     * @private
     */

  }, {
    key: "_adjustLineItem",
    value: function _adjustLineItem(item) {
      var remaining = item.remaining,
          sku = item.sku,
          valid = item.valid;
      var $item = this.$el.find("[data-product-list-item-sku=\"".concat(sku, "\"]"));

      if (typeof remaining === 'number') {
        $item.trigger('product-item:update-remaining', remaining);
      }

      if (!valid) {
        $item.trigger('product-list-item:stage-product', [true, remaining]);
        this.requiresAdjustment = true;
      }
    }
    /**
     * Validates that customer has checked required terms
     * and conditions boxes before allowing them to
     * proceed.
     *
     * @private
     */

  }, {
    key: "_validateForm",
    value: function _validateForm() {
      this.forms = new Forms["a" /* default */](this.$form);
    }
    /**
     * Unload class components
     *
     * @public
     */

  }, {
    key: "unload",
    value: function unload() {
      if (this.forms) {
        this.forms.unload();
      }
    }
  }]);

  return CartValidator;
}();
// CONCATENATED MODULE: ./source/scripts/helpers/Images.js
function Images_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Images_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Images_createClass(Constructor, protoProps, staticProps) { if (protoProps) Images_defineProperties(Constructor.prototype, protoProps); if (staticProps) Images_defineProperties(Constructor, staticProps); return Constructor; }

var Images = /*#__PURE__*/function () {
  function Images() {
    Images_classCallCheck(this, Images);
  }

  Images_createClass(Images, [{
    key: "preload",
    value:
    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */
    function preload(images, size) {
      if (typeof images === 'string') {
        images = [images];
      }

      for (var i = 0; i < images.length; i++) {
        this.loadImage(this.getSizedImageUrl(images[i], size));
      }
    }
    /**
     * Loads and caches an image in the browsers cache.
     *
     * @param {string} path - An image url
     */

  }, {
    key: "loadImage",
    value: function loadImage(path) {
      return new Image().src = path;
    }
    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */

  }, {
    key: "getSizedImageUrl",
    value: function getSizedImageUrl() {
      var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var size = arguments.length > 1 ? arguments[1] : undefined;

      if (!size) {
        return null;
      }

      if (size === 'master') {
        return this.removeProtocol(src);
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
        return this.removeProtocol("".concat(prefix[0], "_").concat(size).concat(suffix));
      }

      console.warn("No ".concat(size, " found for '").concat(src));
      return null;
    }
  }, {
    key: "removeProtocol",
    value: function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  }]);

  return Images;
}();
// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(0);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./source/scripts/helpers/InfiniteScroll.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || InfiniteScroll_unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function InfiniteScroll_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return InfiniteScroll_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return InfiniteScroll_arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return InfiniteScroll_arrayLikeToArray(arr); }

function InfiniteScroll_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function InfiniteScroll_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function InfiniteScroll_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function InfiniteScroll_createClass(Constructor, protoProps, staticProps) { if (protoProps) InfiniteScroll_defineProperties(Constructor.prototype, protoProps); if (staticProps) InfiniteScroll_defineProperties(Constructor, staticProps); return Constructor; }


var InfiniteScroll_InfiniteScroll = /*#__PURE__*/function () {
  function InfiniteScroll(options) {
    InfiniteScroll_classCallCheck(this, InfiniteScroll);

    this.$el = jquery_default()(options.el);
    this.$itemsContainer = this.$el.find(options.itemsContainer);
    this.$button = this.$el.find('[data-pagination-infinite]');
    this.$buttonContainer = this.$button.parent();
    this.currentPage = 1;
    this.pageDisplayed = 1;
    this.maxPage = parseInt(this.$button.attr('data-pagination-pages'), 10);
    this.itemsContainerSelector = options.itemsContainer;
    this.callbacks = options.callbacks;
    this.productSet = [];
    this.nextProductSet = [];
    this.firstLoad = true;
    this.loadingNext = false;

    this._bindEvents();

    if (this.pageDisplayed < this.maxPage) {
      this._stageNextProductSet();
    }
  }

  InfiniteScroll_createClass(InfiniteScroll, [{
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;

      this.$button.on('click.scroll', function (event) {
        event.preventDefault();

        _this._displayProductSet(); // Check if next set is still loading - if yes, wait to stage


        if (_this.loadingNext) {
          _this._toggleButton();

          jquery_default.a.when(_this.loadingNext).then(_this._stageNextProductSet.bind(_this));
        } else {
          _this._stageNextProductSet();
        }
      });
    }
  }, {
    key: "_stageNextProductSet",
    value: function _stageNextProductSet() {
      var _this2 = this;

      var nextUrl = this.$button.attr('href');

      var fetchProducts = this._fetchProductSet(nextUrl);

      if (this.firstLoad) {
        this._toggleButton(true);
      } else {
        return;
      }

      fetchProducts.then(function () {
        _this2.firstLoad = false;

        _this2._stageNextProductSet();
      });
    }
  }, {
    key: "_fetchProductSet",
    value: function _fetchProductSet(nextUrl) {
      var _this3 = this;

      if (!this.firstLoad) {
        this.loadingNext = new jquery_default.a.Deferred();
      }

      return jquery_default.a.get(nextUrl).done(function (response) {
        _this3._scrollComplete(response);

        if (_this3.loadingNext) {
          _this3.loadingNext.resolve();

          _this3.loadingNext = false;
        }
      }).fail(function (response) {
        _this3._scrollError(response);
      }).always(function (response) {
        _this3._toggleButton(false);
      });
    }
  }, {
    key: "_displayProductSet",
    value: function _displayProductSet() {
      this.pageDisplayed++; // NOTE: Memoize button to be added back after content is inserted

      this.$button.detach();
      this.$itemsContainer.append(this.productSet);
      this.callbacks.onSuccess(this.productSet);
      this.productSet = this.nextProductSet;
      this.nextProductSet = []; // NOTE: Insert the button back, if not on last page of results

      if (this.pageDisplayed < this.maxPage) {
        this.$buttonContainer.append(this.$button);
      }
    }
  }, {
    key: "_scrollComplete",
    value: function _scrollComplete(response) {
      var el = document.createElement('html');
      el.innerHTML = response;
      var storageArray = this.firstLoad ? this.productSet : this.productSet.length ? this.nextProductSet : this.productSet;

      this._storeProductSet(el, storageArray);

      this.currentPage++;

      if (this.currentPage >= this.maxPage) {
        return;
      }

      this._updatePaginationButtonUrl(el);
    }
  }, {
    key: "_scrollError",
    value: function _scrollError(response) {
      console.warn('Infinite scroll error');
      console.log(response.message, response.error, response.event);

      this._toggleButton(false);
    }
  }, {
    key: "_storeProductSet",
    value: function _storeProductSet(el, storageArray) {
      var collection = el.querySelector(this.itemsContainerSelector);
      storageArray.push.apply(storageArray, _toConsumableArray(collection.querySelectorAll('[data-product-item]')));
    }
  }, {
    key: "_updatePaginationButtonUrl",
    value: function _updatePaginationButtonUrl(el) {
      var nextUrl = el.querySelector('[data-pagination-infinite]').href;
      this.$button.attr('href', nextUrl);
    }
  }, {
    key: "_toggleButton",
    value: function _toggleButton(disable) {
      this.$button.toggleClass('processing', disable).attr('disabled', disable);
    }
  }, {
    key: "unload",
    value: function unload() {
      this.$button.off('.scroll');
    }
  }]);

  return InfiniteScroll;
}();
// CONCATENATED MODULE: ./source/scripts/helpers/LazyLoader.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function LazyLoader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LazyLoader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LazyLoader_createClass(Constructor, protoProps, staticProps) { if (protoProps) LazyLoader_defineProperties(Constructor.prototype, protoProps); if (staticProps) LazyLoader_defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Allows a callback to be run once, when a target intersects the viewport.
 * @constructor
 * @param {HTMLElement} target Element to track
 * @param {Function} callback Function to execute when target enters viewport (only executed once)
 * @param {Object} [options] options with which to construct the IntersectionObserver
 * @param {string} [options.rootMargin='30%'] A string which specifies a set of offsets to add to the root's bounding_box when calculating intersections.
 * @param {number} [options.threshold=0] Ratio of intersection required to trigger callback
 */
var LazyLoader = /*#__PURE__*/function () {
  function LazyLoader(target, callback, options) {
    LazyLoader_classCallCheck(this, LazyLoader);

    var defaultOptions = {
      rootMargin: '30%',
      threshold: 0
    };
    this.callback = callback;
    this._runCallback = this._runCallback.bind(this);
    this.observer = new IntersectionObserver(this._runCallback, _objectSpread(_objectSpread({}, defaultOptions), options));
    this.observer.observe(target);
  }
  /**
   * Runs the callback if first entry becomes intersecting, then unloads the LazyLoader
   * @_runCallback
   * @param {IntersectionObserverEntry[]} entries Entry to check - all but the
   * first element will be ignored.
   */


  LazyLoader_createClass(LazyLoader, [{
    key: "_runCallback",
    value: function _runCallback(entries) {
      // do nothing unless target moved into state of intersection
      if (entries[0].isIntersecting === true) {
        this.unload();
        this.callback();
      }
    }
    /**
     * Disconnects IntersectionObserver if active
     * @unload
     */

  }, {
    key: "unload",
    value: function unload() {
      this.observer.disconnect();
    }
  }]);

  return LazyLoader;
}();
// CONCATENATED MODULE: ./source/scripts/helpers/StoreFrontAPI.js
/*
  Helper to utilize and access the Shopify StoreFront API and query graphql.

  @param {object} query - A graphql query.
  @param {number} variable - Additional variables to pass to the query.
  @param {string} token - Your StoreFront API access token.
  @param {sting} version - Override to use specific version of graphql endpoint

  @return {Promise} A jQuery Deferred promise will be returned
*/
function storeFront(token, query, variable) {
  var version = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "2020-07";
  var payload = query; // NOTE: If variable, we can assume there is data to pass into query

  if (variable) {
    payload = {
      query: query,
      variables: {
        variable: variable
      }
    };
  }

  return $.ajax({
    data: payload,
    dataType: 'json',
    headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': token
    },
    method: 'post',
    url: "//".concat(Shopify.shop, "/api/").concat(version, "/graphql")
  });
}
// CONCATENATED MODULE: ./source/scripts/helpers/cdf.js
function cdf_createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = cdf_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function cdf_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return cdf_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return cdf_arrayLikeToArray(o, minLen); }

function cdf_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var settings = {
  cdfContainer: '[data-cart-cdf-container]',
  cdfLineSelector: '[data-cart-cdf]',
  cdfQuantitySelector: '[data-cart-cdf-quantity]',
  visibleClass: 'visible'
};
/**
 * Performs aesthetic updates of CDF lines in the subtotal area
 *
 * @param {cart} object = cart object
 */

var CDFupdateQuantities = function CDFupdateQuantities(cart) {
  var cdfContainer = document.querySelector(settings.cdfContainer);
  var cdfContainerVisibleClass = settings.visibleClass;
  var cdfLines = document.querySelectorAll(settings.cdfLineSelector);
  var cdfLineVisibleClass = settings.visibleClass;
  var feeItems = cart.items.filter(function (item) {
    return item.product_type.toLowerCase() === 'fee';
  }).map(function (item) {
    return {
      sku: item.sku,
      quantity: item.quantity
    };
  });
  var cdfLineQuantities = {};
  var hasCDF = false;

  var _iterator = cdf_createForOfIteratorHelper(feeItems),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;

      if (!cdfLineQuantities[item.sku]) {
        cdfLineQuantities[item.sku] = 0;
      }

      cdfLineQuantities[item.sku] += item.quantity;

      if (cdfLineQuantities[item.sku] > 0) {
        hasCDF = true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = cdf_createForOfIteratorHelper(cdfLines),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var cdfLine = _step2.value;
      var sku = cdfLine.dataset.cartCdf;
      var quantity = cdfLineQuantities[sku] || 0;
      cdfContainer.classList.toggle(cdfContainerVisibleClass, hasCDF);
      cdfLine.classList.toggle(cdfLineVisibleClass, quantity > 0);
      cdfLine.querySelector(settings.cdfQuantitySelector).innerHTML = quantity;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};
/**
 * Calculates the number of cdf products in the cart
 *
 * @param {cart} object = cart object
 */

var CDFQuantityTotal = function CDFQuantityTotal(cart) {
  var cdfCount = 0;
  var cdfProducts = [];
  cart.items.forEach(function (item) {
    for (var property in item.properties) {
      if (property.toLowerCase() === 'sku') {
        cdfProducts.push(item.quantity);
      }
    }
  });

  if (cdfProducts.length) {
    cdfCount = cdfProducts.reduce(function (total, amount) {
      return total + amount;
    });
  }

  return cdfCount;
};
// CONCATENATED MODULE: ./source/scripts/helpers/flickityTouchFix.js
// This is a helper class to fix a touch issue that came up in flickity
// on iOS devices as of version 13. It should smooth out some of the scroll
// and swipe issues that flickity is having on that version of iOS.
var flickityTouchFix = function flickityTouchFix() {
  var touchingSlider = false;
  var touchStartCoordsX = 0;

  var onTouchStart = function onTouchStart(e) {
    if (e.target.closest && e.target.closest('.flickity-slider')) {
      touchingSlider = true;
      touchStartCoordsX = e.touches[0].pageX;
    } else {
      touchingSlider = false;
    }
  };

  var onTouchMove = function onTouchMove(e) {
    if (!(touchingSlider && e.cancelable)) {
      return;
    }

    if (Math.abs(e.touches[0].pageX - touchStartCoordsX) > 10) {
      e.preventDefault();
    }
  };

  document.body.addEventListener('touchstart', onTouchStart);
  document.body.addEventListener('touchmove', onTouchMove, {
    passive: false
  });
};
// CONCATENATED MODULE: ./source/scripts/helpers/getCart.js

/**
 * Get cart from Shopify ajax api
 */

var getCart_getCart = function getCart() {
  var async = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return jquery_default.a.ajax({
    method: 'GET',
    url: '/cart.js',
    dataType: 'json',
    async: async
  });
};
// CONCATENATED MODULE: ./source/scripts/helpers/getHeaderOffset.js
/**
 * Get the offset of the header
 *
 * @param {HTMLElement} header
 * @param {Boolean} withAnnouncementBar
 * @returns {number}
 */
function getHeaderOffset(header) {
  var withAnnouncementBar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _header$getBoundingCl = header.getBoundingClientRect(),
      bottom = _header$getBoundingCl.bottom;

  var offset = bottom > 0 ? bottom : 0;

  if (withAnnouncementBar) {
    offset += parseInt(header.style.top, 10) || 0;
  }

  return offset;
}


// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(388);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./source/scripts/helpers/graphql/productsByCustomerTypeCheck.js
function productsByCustomerTypeCheck_toConsumableArray(arr) { return productsByCustomerTypeCheck_arrayWithoutHoles(arr) || productsByCustomerTypeCheck_iterableToArray(arr) || productsByCustomerTypeCheck_unsupportedIterableToArray(arr) || productsByCustomerTypeCheck_nonIterableSpread(); }

function productsByCustomerTypeCheck_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function productsByCustomerTypeCheck_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return productsByCustomerTypeCheck_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return productsByCustomerTypeCheck_arrayLikeToArray(o, minLen); }

function productsByCustomerTypeCheck_iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function productsByCustomerTypeCheck_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return productsByCustomerTypeCheck_arrayLikeToArray(arr); }

function productsByCustomerTypeCheck_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



/*
  Helper to filter products there are not allowed by current customer's licence type.
  @param {string} customerLicenceType - Customer's licence type[cpr|gcs|ftn|...].
  @param {string} token - Your StoreFront API access token.
  @return {array} A array of variant objects[{id: 1, ...}, ...].
*/

var productsByCustomerTypeCheck_filterByCustomerType = function filterByCustomerType(customerLicenceType, tokenProductStorefront) {
  var query = "\n    query($ids: [ID!]!) {\n      nodes(ids: $ids) {\n        ...on ProductVariant {\n          title\n          product {\n              tags\n          }\n        }\n      }\n    }\n  ";
  return $.when(getCart_getCart(false)).then(function () {
    var cart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ids = cart.items.filter(function (item) {
      return item.product_type.toLowerCase() !== 'fee';
    }).map(function (item) {
      return btoa("gid://shopify/ProductVariant/".concat(item.id));
    });
    var params = {
      query: query,
      variables: {
        ids: ids
      }
    };
    return productsByCustomerTypeCheck_storeFrontRequest(params, tokenProductStorefront).then(function (response) {
      return filterVariantsByProductCustomerType(response.data.data.nodes, customerLicenceType, cart);
    }).catch(function (error) {
      // handle error
      console.log(error);
    });
  }).fail(function () {
    return location.reload();
  });
};

var productsByCustomerTypeCheck_storeFrontRequest = function storeFrontRequest(params, tokenProductStorefront) {
  var url = "https://".concat(Shopify.shop, "/api/2020-07/graphql.json");
  var headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Shopify-Storefront-Access-Token': tokenProductStorefront
  };
  return axios_default()({
    url: url,
    headers: headers,
    method: 'post',
    data: JSON.stringify(params)
  });
};

var filterVariantsByProductCustomerType = function filterVariantsByProductCustomerType(nodes, customerLicenceType, cart) {
  var variants = [];
  var tagValues = [];
  nodes.forEach(function (node) {
    node.product.tags.forEach(function (tag) {
      // ignore if variant has no `customer_type` tag.
      if (!tag.startsWith('customer_type')) {
        return;
      } // decode and split `customer_type` tag.
      // e.g.
      // input: customer_type::1000132=|1000140=|1000157=ftn"
      // output: ["1000132=", "1000140=", "1000157=ftn"]


      tagValues.push(tag.split('::')[1].split('|'));
    });
  });
  tagValues.forEach(function (tagValue) {
    variants.push(filterVariantsByCustomerType(tagValue, customerLicenceType, cart));
  }); // make sure there are not duplicate items in array.

  return productsByCustomerTypeCheck_toConsumableArray(new Set(variants.flat()));
};

var filterVariantsByCustomerType = function filterVariantsByCustomerType(tagValue, customerLicenceType, cart) {
  var unsupportedSKUS = [];
  var supportedSKUS = [];
  tagValue.forEach(function (tag) {
    // tag is an array containing sku and customer_type
    // e.g. "1234=cpr"
    var tagDecoded = tag.split('=');
    var sku = tagDecoded[0];
    var variantCustomerType = tagDecoded[1].toUpperCase();
    var customerLicence = customerLicenceType.toUpperCase(); // return if `customer_type` doesn't exists for variant

    if (variantCustomerType === '') return;

    if (variantCustomerType === customerLicence) {
      cart.items.filter(function (item) {
        if (item.sku === sku) {
          supportedSKUS.push(item);
        }
      });
    }

    if (variantCustomerType !== customerLicence) {
      cart.items.filter(function (item) {
        if (item.sku === sku) {
          unsupportedSKUS.push(item);
        }
      });
    }
  });
  return unsupportedSKUS.filter(function (unsupportedSKU) {
    var isSupportedSku = supportedSKUS.find(function (supportedSKU) {
      return supportedSKU.sku == unsupportedSKU.sku;
    });

    if (isSupportedSku) {
      return false;
    }

    return true;
  });
};
// CONCATENATED MODULE: ./source/scripts/helpers/localStorage.js
var localStorage = {
  announcementBannerDismiss: 'ldb-announcement-banner-dismiss'
};
var sessionTimer = {
  key: 'bccs-cst',
  pristineFlag: '-pris'
}; // NOTE: Helpers for working with LocalStorage

var deleteLS = function deleteLS(key) {
  return window.localStorage.removeItem(key);
};
var getLS = function getLS(key) {
  return window.localStorage.getItem(key);
};
var setLS = function setLS(key, value) {
  return window.localStorage.setItem(key, value);
};
// CONCATENATED MODULE: ./source/scripts/helpers/makeIDsUnique.js
/**
 * Updates element IDs to ensure they are unique within the document by checking for conflicts.
 * Also checks associated labels and updates the `for` attribute if required.
 * @param {NodeList} idEls Elements to check for ID uniqueness within the document
 * @param {NodeList} labels Labels to update if element with associated ID is updated.
 */
function makeIDsUnique(idEls, labels) {
  idEls.forEach(function (idEl) {
    var oldId = idEl.getAttribute('id');
    var duplicateCount = document.querySelectorAll("[id$=\"".concat(oldId, "\"]")).length;

    if (duplicateCount > 0) {
      var newId = "".concat(duplicateCount).concat(oldId);
      idEl.setAttribute('id', newId); // update label

      if (labels) {
        labels.forEach(function (label) {
          if (label.matches("[for=\"".concat(oldId, "\"]"))) {
            label.setAttribute('for', newId);
          }
        });
      }
    }
  });
}
// CONCATENATED MODULE: ./source/scripts/helpers/numberInputValidation.js
function numberInputValidation(event) {
  var which = event.which;
  var isShortcut = event.altKey || event.ctrlKey || event.metaKey;
  var allowedKeys = [8, 9, 37, 38, 39, 40]; // delete, tab, return, arrows
  //Bail if allowed key or shortcut

  if (allowedKeys.indexOf(which) !== -1 || isShortcut) {
    return true;
  } // Return true if input is number keys or number pad


  return which >= 48 && which <= 57 || which >= 96 && which <= 105;
}
// CONCATENATED MODULE: ./source/scripts/helpers/scrollLeft.js
function scrollLeft($el) {
  var $container = $el.parent();
  $container.animate({
    scrollLeft: $el.offset().left - $el.width() / 2 - $container.width() / 2
  });
}
// CONCATENATED MODULE: ./source/scripts/helpers/shippingRates.js
/**
 * Shipping rates table; used to validate shipping price
 * This must match the rates table in the shopify-scripts/shipping.rb
 */
var SHIPPING_RATES = {
  zone_1: [{
    range: [0, 999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [1000, 1999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [2000, 2999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [3000, 3999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [4000, 4999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [5000, 5999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [6000, 6999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [7000, 7999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [8000, 8999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [9000, 9999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [10000, 19999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [20000, 29999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [30000, 49999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [50000, 74999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [75000, 99999],
    rates: {
      beverage: 95,
      default: 425
    }
  }, {
    range: [100000, 299999],
    rates: {
      beverage: 95,
      default: 175
    }
  }, {
    range: [300000, 9999999],
    rates: {
      beverage: 86,
      default: 110
    }
  }],
  zone_2: [{
    range: [0, 999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [1000, 1999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [2000, 2999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [3000, 3999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [4000, 4999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [5000, 5999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [6000, 6999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [7000, 7999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [8000, 8999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [9000, 9999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [10000, 19999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [20000, 29999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [30000, 49999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [50000, 74999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [75000, 99999],
    rates: {
      beverage: 110,
      default: 450
    }
  }, {
    range: [100000, 299999],
    rates: {
      beverage: 110,
      default: 350
    }
  }, {
    range: [300000, 9999999],
    rates: {
      beverage: 99,
      default: 215
    }
  }],
  zone_3: [{
    range: [0, 999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [1000, 1999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [2000, 2999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [3000, 3999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [4000, 4999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [5000, 5999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [6000, 6999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [7000, 7999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [8000, 8999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [9000, 9999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [10000, 19999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [20000, 29999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [30000, 49999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [50000, 74999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [75000, 99999],
    rates: {
      beverage: 126,
      default: 520
    }
  }, {
    range: [100000, 299999],
    rates: {
      beverage: 126,
      default: 375
    }
  }, {
    range: [300000, 9999999],
    rates: {
      beverage: 113,
      default: 250
    }
  }],
  zone_4: [{
    range: [0, 999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [1000, 1999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [2000, 2999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [3000, 3999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [4000, 4999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [5000, 5999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [6000, 6999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [7000, 7999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [8000, 8999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [9000, 9999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [10000, 19999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [20000, 29999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [30000, 49999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [50000, 74999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [75000, 99999],
    rates: {
      beverage: 150,
      default: 700
    }
  }, {
    range: [100000, 299999],
    rates: {
      beverage: 150,
      default: 400
    }
  }, {
    range: [300000, 9999999],
    rates: {
      beverage: 135,
      default: 400
    }
  }]
};
// EXTERNAL MODULE: ./node_modules/@knitagency/bccs-utils/dist/index.min.js
var index_min = __webpack_require__(389);

// CONCATENATED MODULE: ./source/scripts/helpers/use-integration-api.js


function useIntegrationAPI() {
  var apiConfig = getLiquidVars('[data-integration]');
  var _apiConfig$integratio = apiConfig.integrationConfig,
      environment = _apiConfig$integratio.environment,
      customerId = _apiConfig$integratio.customerId,
      domain = _apiConfig$integratio.domain,
      hmac = _apiConfig$integratio.hmac;
  return new index_min["a" /* IntegrationAPI */]({
    environment: environment,
    customerId: customerId,
    domain: domain,
    hmac: hmac
  });
}
// CONCATENATED MODULE: ./source/scripts/helpers/index.js

























/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Forms; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var jquery_validation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(808);
/* harmony import */ var jquery_validation__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(jquery_validation__WEBPACK_IMPORTED_MODULE_1__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var Forms = /*#__PURE__*/function () {
  function Forms($el, validationRules) {
    var selector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.form-field-input';

    _classCallCheck(this, Forms);

    this.$el = $el;
    this.filledClass = 'form-field-filled';
    this.fieldSelector = selector;
    this.validationRules = validationRules || null;
    this._toggleFilled = this._toggleFilled.bind(this);
    this.$el.on('focus.forms', this.fieldSelector, this._toggleFilled);
    this.$el.on('blur.forms', this.fieldSelector, this._toggleFilled);

    this._checkFilled();

    if (this.validationRules) {
      this._initValidator();
    }
  }

  _createClass(Forms, [{
    key: "unload",
    value: function unload() {
      this.$el.off('.forms');

      if (this.validator) {
        this.validator.destroy();
      }
    }
  }, {
    key: "_checkFilled",
    value: function _checkFilled() {
      var _this = this;

      this.$el.find(this.fieldSelector).each(function (i, el) {
        if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).hasClass(_this.filledClass)) return;

        _this._toggleFilled(null, el);
      });
    }
  }, {
    key: "_toggleFilled",
    value: function _toggleFilled() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var $el = event ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.currentTarget) : jquery__WEBPACK_IMPORTED_MODULE_0___default()(el);
      var value = $el.val();
      var isFilled = value && value.length > 0 ? true : false;
      $el.toggleClass(this.filledClass, isFilled);
    }
  }, {
    key: "_initValidator",
    value: function _initValidator() {
      jquery__WEBPACK_IMPORTED_MODULE_0___default.a.validator.messages.max = '';
      jquery__WEBPACK_IMPORTED_MODULE_0___default.a.validator.messages.required = '';
      this.validator = this.$el.validate(this.validationRules);
    }
  }]);

  return Forms;
}();



/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ Glossary_Glossary; });

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(0);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./source/scripts/globals/scroll-link.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var scroll_link_ScrollLink = /*#__PURE__*/function () {
  function ScrollLink(options) {
    _classCallCheck(this, ScrollLink);

    this.options = jquery_default.a.extend({
      selector: '[data-scroll]',
      duration: 1000,
      easing: 'swing',
      delay: 0,
      offset: 0,
      updateHash: true
    }, options);

    this._bindEvents();
  }

  _createClass(ScrollLink, [{
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;

      jquery_default()(this.options.selector).on('click', function (e) {
        e.preventDefault();
        setTimeout(function () {
          _this._scrollToContent(jquery_default()(e.currentTarget));
        }, _this.options.delay);
      });
    }
  }, {
    key: "_scrollToContent",
    value: function _scrollToContent(target) {
      var duration = this.options.duration;
      var easing = this.options.easing;
      var scrollTarget = jquery_default()(target).attr('data-scroll') || target;

      if (scrollTarget === '#') {
        scrollTarget = 'body';
      }

      jquery_default()('html, body').animate({
        scrollTop: jquery_default()(scrollTarget).offset().top + this.options.offset
      }, duration, easing);

      if (this.options.updateHash) {
        if (history && history.replaceState) {
          history.replaceState({}, scrollTarget, scrollTarget);
        } else {
          window.location.hash = scrollTarget;
        }
      }
    }
  }, {
    key: "scrollToContent",
    value: function scrollToContent(target) {
      var _this2 = this;

      setTimeout(function () {
        _this2._scrollToContent(target);
      }, this.options.delay);
    }
  }]);

  return ScrollLink;
}();


// CONCATENATED MODULE: ./source/scripts/templates/Glossary.js
function Glossary_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var Glossary_Glossary = function Glossary() {
  Glossary_classCallCheck(this, Glossary);

  new scroll_link_ScrollLink({
    duration: 500
  });
};



/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);

var eventHandlers = [];
var previousBreakpoint = null;
jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('resize', function (event) {
  var currentBreakpoint = getBreakpoint();

  if (previousBreakpoint !== currentBreakpoint) {
    eventHandlers.forEach(function (eventHandler) {
      eventHandler(event, {
        previous: previousBreakpoint,
        current: currentBreakpoint
      });
    });
  }

  previousBreakpoint = currentBreakpoint;
});

function getBreakpoint() {
  return window.getComputedStyle(document.documentElement, ':after').getPropertyValue('content').replace(/"/g, '');
}

function isBreakpoint(breakpoint) {
  return getBreakpoint() === breakpoint;
}

function onBreakpointChange(eventHandler) {
  if (eventHandlers.indexOf(eventHandler) === -1) {
    eventHandlers.push(eventHandler);
  }
}

function offBreakpointChange(eventHandler) {
  var index = eventHandlers.indexOf(eventHandler);

  if (index !== -1) {
    eventHandlers.splice(index, 1);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  isBreakpoint: isBreakpoint,
  onBreakpointChange: onBreakpointChange,
  offBreakpointChange: offBreakpointChange
});

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RichText; });
/* harmony import */ var _pixelunion_grouped_content__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(392);
/* harmony import */ var _pixelunion_grouped_content__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_pixelunion_grouped_content__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var fitvids__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(393);
/* harmony import */ var fitvids__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fitvids__WEBPACK_IMPORTED_MODULE_1__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var RichText = /*#__PURE__*/function () {
  function RichText($el) {
    _classCallCheck(this, RichText);

    this.$el = $el;

    this._initExternalLinks();

    if (this.$el.length) {
      this.groupedContent = new _pixelunion_grouped_content__WEBPACK_IMPORTED_MODULE_0___default.a($el.get(0), {
        layout: 'tabs',
        intelliparse: false
      });
      fitvids__WEBPACK_IMPORTED_MODULE_1___default()();
    }
  }

  _createClass(RichText, [{
    key: "unload",
    value: function unload() {
      if (this.groupedContent) {
        this.groupedContent.unload();
      }
    }
    /**
     * Open links within an RTE field in a new window if they point to external domains
     *
     * @private
     */

  }, {
    key: "_initExternalLinks",
    value: function _initExternalLinks() {
      var anchors = this.$el.find('a[href^="http"]').filter(function (i, el) {
        return el.href.indexOf(location.hostname) === -1;
      });
      anchors.attr('target', '_blank');
    }
  }]);

  return RichText;
}();



/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductListItem_ProductListItem; });

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(0);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/scriptjs/dist/script.js
var script = __webpack_require__(24);
var script_default = /*#__PURE__*/__webpack_require__.n(script);

// EXTERNAL MODULE: ./node_modules/just-debounce/index.js
var just_debounce = __webpack_require__(32);
var just_debounce_default = /*#__PURE__*/__webpack_require__.n(just_debounce);

// EXTERNAL MODULE: ./source/scripts/Layout.js
var Layout = __webpack_require__(4);

// EXTERNAL MODULE: ./source/scripts/Dropdown.js
var Dropdown = __webpack_require__(94);

// EXTERNAL MODULE: ./node_modules/@pixelunion/rimg-shopify/dist/index.es.js
var index_es = __webpack_require__(161);

// EXTERNAL MODULE: ./node_modules/@pixelunion/shopify-asyncview/dist/index.es.js
var dist_index_es = __webpack_require__(163);

// EXTERNAL MODULE: ./source/scripts/components/Modal.js
var Modal = __webpack_require__(58);

// EXTERNAL MODULE: ./source/scripts/components/ProductDetails.js + 3 modules
var ProductDetails = __webpack_require__(167);

// EXTERNAL MODULE: ./source/scripts/components/RichText.js
var RichText = __webpack_require__(47);

// EXTERNAL MODULE: ./source/scripts/helpers/index.js + 24 modules
var helpers = __webpack_require__(2);

// CONCATENATED MODULE: ./source/scripts/components/ProductQuickshop.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }









var ProductQuickshop_ProductQuickshop = /*#__PURE__*/function () {
  function ProductQuickshop(options) {
    _classCallCheck(this, ProductQuickshop);

    this.options = options;
    this.el = options.el;
    this.sectionId = options.sectionId;
    this.modalClass = options.modalClass;
    this.type = options.type;
    this.isLoaded = false;
    this.isOpen = false;
    this.loaded = false;
    this.collection = null;
    this.loader = null;
    this.modal = null;
    this.productDetails = null;
    this.quickshopContainer = null;
    this.richText = null;
  }

  _createClass(ProductQuickshop, [{
    key: "open",
    value: function open() {
      var _this = this;

      var loader = !this.isLoaded && this.loader ? this.loader : this.load();
      loader.then(function () {
        var _this$options = _this.options,
            sectionId = _this$options.sectionId,
            url = _this$options.url,
            trigger = _this$options.trigger;
        var modalCallbacks = {
          onClose: function onClose() {
            return _this.close();
          }
        };
        _this.modal = new Modal["a" /* default */](modalCallbacks);

        _this.modal.open("#".concat(sectionId, " [data-product-quickshop-url=\"").concat(url, "\"]"), _this.modalClass, trigger);

        index_es["a" /* default */].watch(_this.quickshopContainerOuter);

        _this.productDetails.onQuickshopOpen();

        _this.isOpen = true;
      });
    }
  }, {
    key: "close",
    value: function close() {
      var _this2 = this;

      if (this.isLoaded || this.loader) {
        var loader = this.loader || Promise.resolve();
        return loader.then(function () {
          if (!_this2.isOpen) {
            return;
          }

          _this2.modal.unload();

          _this2.isOpen = false;
        });
      }

      return Promise.resolve();
    }
  }, {
    key: "unload",
    value: function unload() {
      var _this3 = this;

      if (this.isLoaded || this.loader) {
        return this.close().then(function () {
          if (_this3.productDetails) {
            _this3.productDetails.unload();
          }

          if (_this3.richText) {
            _this3.richText.unload();
          }
        });
      }

      return Promise.resolve();
    }
  }, {
    key: "load",
    value: function load() {
      var _this4 = this;

      // If we're already loaded, return true
      if (this.isLoaded) {
        return Promise.resolve(true);
      } // If we're currently loading, return the existing promise


      if (this.loader) {
        return this.loader;
      }

      var _this$options2 = this.options,
          url = _this$options2.url,
          hash = _this$options2.hash;
      this.loader = dist_index_es["a" /* default */].load(url, {
        view: '_quickshop'
      }, {
        hash: hash
      }).then(function (response) {
        var data = response.data,
            html = response.html;

        _this4._renderProductModal(data, html);

        _this4.el.setAttribute('data-loaded', true);

        _this4.quickshopContainerOuter = _this4.el.appendChild(_this4.quickshopContainer);
        _this4.isLoaded = true;
      }).then(function () {
        _this4.loader = null;
        return true;
      }).catch(function () {
        _this4.loader = null;
        return false;
      });
      return this.loader;
    }
  }, {
    key: "_addCollection",
    value: function _addCollection() {
      var $collection = jquery_default()("#".concat(this.sectionId)).find('[data-product-collection-handle]');

      if ($collection.length) {
        this.collection = $collection.attr('data-product-collection-handle');
      }
    }
  }, {
    key: "_renderProductModal",
    value: function _renderProductModal() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var html = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var context = data.context,
          settings = data.settings,
          product = data.product,
          restrictions = data.restrictions,
          volume_equivalencies = data.volume_equivalencies,
          exclusivity = data.exclusivity,
          variant_availabilities = data.variant_availabilities,
          badges = data.badges,
          cs = data.cs,
          cdfData = data.cdfData;
      this.quickshopContainer = document.createElement('div');
      this.quickshopContainer.innerHTML = html;
      var formAreaEl = this.quickshopContainer.querySelector('[data-product-form-area]');
      Object(helpers["t" /* makeIDsUnique */])(formAreaEl.querySelectorAll('select[id], input[id]'), formAreaEl.querySelectorAll('label[for]'));
      this._onATCError = this._onATCError.bind(this);
      this._onATCSuccess = this._onATCSuccess.bind(this);
      this._onATCClose = this._onATCClose.bind(this);

      this._addCollection();

      this.productDetails = new ProductDetails["a" /* default */]({
        $el: jquery_default()(this.el),
        $details: jquery_default()(this.quickshopContainer).find('[data-product-details]'),
        $detailsLink: jquery_default()(this.quickshopContainer).find('[data-product-details-link]'),
        $formArea: jquery_default()(formAreaEl),
        $gallery: jquery_default()(this.quickshopContainer).find('[data-product-gallery]'),
        atcCallbacks: {
          onError: this._onATCError,
          onSuccess: this._onATCSuccess,
          onClose: this._onATCClose
        },
        badges: badges,
        caseSizes: cs,
        cdfData: cdfData,
        collection: this.collection,
        context: context,
        exclusivities: exclusivity,
        isQuickshop: true,
        product: product,
        restrictions: restrictions,
        settings: settings,
        type: this.type,
        useHistory: false,
        variantAvailabilities: variant_availabilities,
        volumeEquivalencies: volume_equivalencies
      });
      var descriptionEl = this.quickshopContainer.querySelector('[data-product-description]');
      this.richText = descriptionEl ? new RichText["a" /* default */](descriptionEl) : null;
    }
  }, {
    key: "_onATCClose",
    value: function _onATCClose() {
      var trigger = this.options.trigger;
      trigger.focus();
    }
  }, {
    key: "_onATCError",
    value: function _onATCError() {
      this.close();
    }
  }, {
    key: "_onATCSuccess",
    value: function _onATCSuccess() {
      this.close();
    }
  }]);

  return ProductQuickshop;
}();


// CONCATENATED MODULE: ./source/scripts/components/ProductListItem.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ProductListItem_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ProductListItem_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ProductListItem_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductListItem_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductListItem_defineProperties(Constructor, staticProps); return Constructor; }









var ProductListItem_ProductListItem = /*#__PURE__*/function () {
  function ProductListItem($el, sectionId) {
    ProductListItem_classCallCheck(this, ProductListItem);

    this.$el = $el;
    this.sectionId = sectionId; // Note: this is defined in the constructor as it can be redefined prior to
    // user interaction. The mouseenter event then becomes destructive,
    // overwriting values set dynamically.

    this.remainingAvailable = false; // Note: these event listeners are declared outside of the normal flow, as
    // they can be called prior to the mouseenver event that initializes this
    // class

    this.$el.on('product-item:update-remaining', this._updateRemainingAvailable.bind(this));
    this.$el.on('product-list-item:stage-product', this._stageProduct.bind(this)); // NOTE: Binding because an event is driving this class

    this.$el.on('mouseenter.product-list-item touchstart.product-list-item', this._init());
  }

  ProductListItem_createClass(ProductListItem, [{
    key: "_init",
    value: function _init() {
      var _this = this;

      // Unbind initialization trigger
      this.$el.off('mouseenter.product-list-item touchstart.product-list-item'); // Init product item

      this.$body = jquery_default()(document.body);
      this.productQuickshop = null;
      this.quickBuySettings = null;
      this.variantId = this.$el.data('product-list-item-id');
      this.variantTitle = this.$el.data('product-list-item-title');
      this.variantSku = this.$el.data('product-list-item-sku');
      this.events = [];
      this.$window = jquery_default()(window);
      this.$html = jquery_default()('html');
      this.$actions = this.$el.find('[data-product-item-actions]');
      this.$atcButton = this.$el.find('[data-quick-buy]') || false;
      this.data = Object(helpers["q" /* getLiquidVars */])('[data-product-item-data]', this.$el[0]);
      this.manageCart = new helpers["g" /* ManageCart */]();
      this.orderValidator = new helpers["h" /* OrderValidator */]();
      var productQuickshopEl = this.$el[0].querySelector('[data-product-quickshop]');

      if (productQuickshopEl) {
        this.productQuickshop = new ProductQuickshop_ProductQuickshop({
          el: productQuickshopEl,
          type: 'product-item',
          modalClass: 'quickshop-full',
          sectionId: this.sectionId,
          url: productQuickshopEl.dataset.productQuickshopUrl,
          hash: productQuickshopEl.dataset.productQuickshopHash,
          trigger: this.$el.find('[data-product-item-trigger]')[0]
        });

        this._openQuickShop = function (e) {
          e.preventDefault();

          _this.productQuickshop.open();
        };

        this._loadQuickShop = function () {
          return _this.productQuickshop.load();
        };
      }

      if (this.$actions.length) {
        this._setSortByQueryParameters();

        if (this.$html.hasClass('no-touch') && this.$el.is('[data-product-grid-item]')) {
          this._setHeights();

          this.events.push(this.$el.on('mouseenter.product-list-item', this._actionsToggle.bind(this)), this.$el.on('mouseleave.product-list-item', this._actionsToggle.bind(this)), this.$window.on('resize.product-list-item', this._onWindowResize.bind(this)));
        } // $scripts checks existence of script in header before attempting to inject


        script_default()(jquery_default()('[data-scripts]').data('shopify-api-url'), function () {
          _this.events.push(_this.$el.on('click.product-list-item', '[data-product-list-item-checkbox]', _this._stageProduct.bind(_this)), _this.$el.on('click.product-list-item', '[data-product-item-cart-remove]', _this._removeProduct.bind(_this)), _this.$el.on('change.product-list-item', '[data-product-list-item-quantity]', _this._editProductQuantity.bind(_this)), _this.$el.on( // NOTE: keyDown used to fire prior to submission event.
          'keydown.product-list-item', '[data-product-list-item-quantity]', _this._quantityKeyEvent.bind(_this)), _this.$el.on('click.product-list-item', '[data-quick-buy]', _this._addToCart.bind(_this)), _this.$el.on('product-item:update-cart', _this._handleQuantityUpdateResponse.bind(_this)), _this.$el.on('product-item:add-to-cart', _this._addToCart.bind(_this)), _this.$el.on('product-item:update-remaining', _this._updateRemainingAvailable.bind(_this)));

          if (_this.productQuickshop) {
            _this.events.push(_this.$el.on('focusin.product-list-item, mouseover.product-list-item', '[data-quickshop-full]', _this._loadQuickShop), _this.$el.on('click.product-list-item', '[data-quickshop-full]', _this._openQuickShop));
          }
        });

        if (this.$el.find('[data-quick-buy]').length) {
          this._initQuickBuy();
        }

        this._initDropdown();
      }
    }
  }, {
    key: "_onWindowResize",
    value: function _onWindowResize() {
      this._resetHeights();

      this._setHeights();
    }
  }, {
    key: "_resetHeights",
    value: function _resetHeights() {
      this.$el.height('auto');
      this.$el.find('[data-product-item-info]').height('auto');
      this.$el.find('[data-product-item-actions]').height('auto');
    }
  }, {
    key: "_setHeights",
    value: function _setHeights() {
      var height = this.$el.height();
      var infoHeight = this.$el.find('[data-product-item-info]').height();
      this.actionsHeight = this.$el.find('[data-product-item-actions]').height();
      this.$el.height(height);
      this.$el.find('[data-product-item-info]').height(infoHeight);
    }
    /**
     * Make Shopify aware of releavent collection search info
     *  - tag
     *  - vendor
     *  - pagination
     *  - sorting criteria
     *
     * @private
     */

  }, {
    key: "_setSortByQueryParameters",
    value: function _setSortByQueryParameters() {
      Shopify.queryParams = {};

      if (location.search.length) {
        for (var i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          var aKeyValue = aCouples[i].split('='); // Reset the page number when we apply (i.e. don't add it to params)

          if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    }
    /**
     * Prepare default set of data for atc requests
     */

  }, {
    key: "_formatVariantData",
    value: function _formatVariantData() {
      var _this$_getCdfInformat = this._getCdfInformation(this.variantSku),
          cdf = _this$_getCdfInformat.cdf,
          consumerUnits = _this$_getCdfInformat.consumerUnits,
          caseSize = _this$_getCdfInformat.caseSize;

      var inCart = this.data.cart_item ? this.data.cart_item.quantity : 0;
      return {
        available: !(this.data.availability.is_sold_out || this.data.availability.is_unavailable),
        caseSize: caseSize,
        cdf: cdf,
        consumerUnits: consumerUnits,
        id: this.variantId,
        quantity: 1,
        inCart: inCart,
        remaining: this.remainingAvailable,
        inventoryQuantity: this.data.vq ? this.data.vq : false,
        sku: this.variantSku,
        title: this.variantTitle
      };
    }
  }, {
    key: "_stageProduct",
    value: function _stageProduct(event) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var remaining = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var target = event.currentTarget;

      if (!force) {
        this.$el.toggleClass('productlist--item-active', target.checked);
      }

      if (target.checked || force) {
        var quantity = force ? remaining : 1;
        var data = Object.assign(this._formatVariantData(), {
          quantity: quantity
        });
        this.manageCart.stage(data);
      } else {
        this.manageCart.unstage(this.variantId);
      }
    }
  }, {
    key: "_initQuickBuy",
    value: function _initQuickBuy() {
      try {
        this.quickBuySettings = JSON.parse(this.$el.find('[data-quick-buy-settings]').text());
      } catch (error) {
        return console.warn("Quick buy: invalid QuickBuy data found. ".concat(error.message));
      }
    }
  }, {
    key: "_initDropdown",
    value: function _initDropdown() {
      this.$dropdown = this.$el.find('[data-product-list-item-dropdown]');

      if (this.$dropdown.length) {
        this.dropdown = new Dropdown["a" /* default */](this.$dropdown[0]);
      }
    }
    /**
     * Add a product to the cart.
     *
     * @param {object} event - event triggering the add to cart.
     * @param {boolean} performValidation - toggles OLOT validation.
     */

  }, {
    key: "_addToCart",
    value: function () {
      var _addToCart2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event, performValidation) {
        var buttonHTMLElement, data, _yield$this$_validate, sku, remaining, valid;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();
                buttonHTMLElement = this.$atcButton;
                Object(helpers["j" /* disableButton */])(buttonHTMLElement);
                data = this._formatVariantData();

                if (!performValidation) {
                  _context.next = 13;
                  break;
                }

                _context.next = 7;
                return this._validateSku();

              case 7:
                _yield$this$_validate = _context.sent;
                sku = _yield$this$_validate.sku;
                remaining = _yield$this$_validate.remaining;
                valid = _yield$this$_validate.valid;
                data = Object.assign(data, {
                  remaining: remaining
                });

                if (remaining === 0) {
                  this.$body.trigger('cart:search-sku', [sku, remaining, valid]);
                }

              case 13:
                this.manageCart.add(data, buttonHTMLElement);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _addToCart(_x, _x2) {
        return _addToCart2.apply(this, arguments);
      }

      return _addToCart;
    }()
  }, {
    key: "_validateSku",
    value: function _validateSku() {
      return jquery_default.a.when(this.orderValidator.validateSku({
        sku: "".concat(this.variantSku),
        quantity: 1
      }));
    }
    /**
     * Get CDF information based on current variant's SKU
     * @param {string} sku of parent product
     */

  }, {
    key: "_getCdfInformation",
    value: function _getCdfInformation(sku) {
      var cdf = false;
      var consumerUnits = 1;
      var caseSize = 1;

      if (this.data.cdfData && this.data.cdfData[sku]) {
        cdf = this.data.cdfData[sku].cdf_sku;
        consumerUnits = parseInt(this.data.cdfData[sku].consumer_units, 10);
        caseSize = parseInt(this.data.cdfData[sku].case_size, 10);
      }

      return {
        cdf: cdf,
        consumerUnits: consumerUnits,
        caseSize: caseSize
      };
    }
  }, {
    key: "_removeProduct",
    value: function _removeProduct(event) {
      event.preventDefault();
      var key = event.target.dataset.productItemCartRemove;

      if (key) {
        this.manageCart.remove(Object.assign(this._formatVariantData(), {
          key: key
        }));
      } else {
        this.manageCart.stage(Object.assign(this._formatVariantData(), {
          quantity: 0
        }));
        this.manageCart.updateAll(0, 'removed');
      }
    }
    /**
     * Updates allowable variant quantity limit
     *
     * @param {remaining} - Number of units allowed
     * @returns Updated variant quantity attribute
     */

  }, {
    key: "_updateRemainingAvailable",
    value: function _updateRemainingAvailable(_event, remaining) {
      if (typeof remaining === 'number') {
        this.remainingAvailable = remaining;
      }
    }
  }, {
    key: "_editProductQuantity",
    value: function _editProductQuantity(event) {
      var $target = jquery_default()(event.currentTarget);
      var currentQuantity = parseInt($target.attr('data-product-list-item-quantity'), 10);
      var requestedQuantity = parseInt($target.val(), 10); // If no change, abort

      if (requestedQuantity === currentQuantity) {
        return;
      } // If invalid requestedQuantity revert to the currentQuantity.


      if (isNaN(requestedQuantity)) {
        return $target.val(currentQuantity);
      }

      var data = Object.assign(this._formatVariantData(), {
        quantity: requestedQuantity
      });
      this.manageCart.update(data);
    }
    /**
     * Capture the event from the input and route accordingly.
     *
     * @param DOM generated event
     * @private
     */

  }, {
    key: "_quantityKeyEvent",
    value: function _quantityKeyEvent(event) {
      var _this2 = this;

      // NOTE: Set up default actions for valid event inputs
      var delay = 120; // NOTE: in milliseconds;

      var defaultEventActions = function defaultEventActions() {
        _this2.$body.trigger('cart:disable-button');

        jquery_default()(event.currentTarget).trigger('change');
      }; // NOTE: Filter event based on the contents of the event


      if (event.code === 'Enter') {
        event.preventDefault();
        defaultEventActions();
      } // NOTE: Only accept non-numerical inputs


      if (Object(helpers["u" /* numberInputValidation */])(event)) {
        // NOTE: Ensure keystrokes are debounced for better UX
        just_debounce_default()(function () {
          defaultEventActions();
        }, delay, true);
      } else {
        return false;
      }
    }
  }, {
    key: "_actionsToggle",
    value: function _actionsToggle(event) {
      if (!Layout["a" /* default */].isBreakpoint('L')) {
        return;
      }

      var open = event.type === 'mouseenter';

      if (open) {
        this._showActions();
      }

      if (!open) {
        this._hideActions();
      }
    }
  }, {
    key: "_showActions",
    value: function _showActions() {
      var _this3 = this;

      if (this.$el.revealer('isVisible')) {
        return this._hideActions();
      } // Start animation


      this.$el.revealer('show').one('revealer-animating.product-item', function () {
        _this3.$el.find('[data-product-item-actions]').height(_this3.actionsHeight);
      });
    }
  }, {
    key: "_hideActions",
    value: function _hideActions() {
      var _this4 = this;

      this.$el.revealer('hide').one('revealer-animating', function () {
        _this4.$el.off('revealer-animating.product-item');

        _this4.$el.find('[data-product-item-actions]').height(0);
      }).one('revealer-hide', function () {
        _this4.$el.off('revealer-hide.product-item');

        _this4.$el.find('[data-product-item-actions]').removeAttr('style');
      });
    }
  }, {
    key: "_handleQuantityUpdateResponse",
    value: function _handleQuantityUpdateResponse(event, quantity) {
      var $quantity = this.$el.find('[data-product-list-item-quantity]');
      $quantity.attr('data-product-list-item-quantity', quantity);
      $quantity.val(quantity);
    }
  }, {
    key: "getGramEquivalency",
    value: function getGramEquivalency() {
      return this.data.ge;
    }
  }, {
    key: "unload",
    value: function unload() {
      this.events.forEach(function ($el) {
        return $el.off('.product-list-item');
      });

      if (this.productQuickshop) {
        this.productQuickshop.unload();
      }

      if (this.dropdown) {
        this.dropdown.unload();
      }
    }
  }]);

  return ProductListItem;
}();



/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Modal; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var just_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32);
/* harmony import */ var just_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(just_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _pixelunion_vanilla_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(384);
/* harmony import */ var _pixelunion_vanilla_modal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_pixelunion_vanilla_modal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shopify_theme_a11y__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }






var Modal = /*#__PURE__*/function () {
  function Modal() {
    var callbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Modal);

    this.$body = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body);
    this.$window = jquery__WEBPACK_IMPORTED_MODULE_0___default()(window);
    this.modal = null;
    this.$modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-modal-container]');
    this.$modalInner = this.$modal.find('[data-modal-inner]');
    this.trigger = null; // Extend default vanilla-modal callbacks back to instantiator of Modal

    this.defaultCallbacks = {
      onOpen: function onOpen() {},
      onClose: function onClose() {},
      onBeforeOpen: function onBeforeOpen() {},
      onBeforeClose: function onBeforeClose() {}
    };
    this.callbacks = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, this.defaultCallbacks, callbacks);
    this._onOpen = this._onOpen.bind(this);
    this._onBeforeOpen = this._onBeforeOpen.bind(this);
    this._onClose = this._onClose.bind(this);
    this._onBeforeClose = this._onBeforeClose.bind(this);
    this._closeEsc = this._closeEsc.bind(this);
    this.position = this.position.bind(this);
    this.modalOptions = {
      loadClass: '',
      class: 'modal-loaded',
      onOpen: this._onOpen,
      onClose: this._onClose,
      onBeforeOpen: this._onBeforeOpen,
      onBeforeClose: this._onBeforeClose,
      transitions: false
    };
  }

  _createClass(Modal, [{
    key: "unload",
    value: function unload() {
      if (!this.modal || !this.modal.isOpen) {
        return;
      }

      this.modal.destroy();
    }
    /**
     * Open a modal with contents from selector
     *
     * @param selector
     * @param handle
     */

  }, {
    key: "open",
    value: function open(selector) {
      var handle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'general';
      var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this._addModalClass(handle);

      this.modal = new _pixelunion_vanilla_modal__WEBPACK_IMPORTED_MODULE_2___default.a(this.modalOptions);
      this.modal.open(selector);
      this.trigger = trigger;
      window.addEventListener('keydown', this.closeEsc);
    }
  }, {
    key: "close",
    value: function close() {
      this.modal.close();
      window.removeEventListener('keydown', this.closeEsc);
    }
  }, {
    key: "_closeEsc",
    value: function _closeEsc(e) {
      if (e.key === 'Escape') {
        this.close();
      }
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.modal && this.modal.isOpen;
    }
    /**
     * Update the vertical positioning of modal
     */

  }, {
    key: "position",
    value: function position() {
      var windowHeight = window.innerHeight;
      var modalHeight = this.$modalInner.outerHeight();
      var modalPadding = parseInt(this.$modal.css('padding-top'), 10) * 2;
      var offset = (windowHeight - modalPadding - modalHeight) / 2;
      var marginTop = offset > 0 ? offset : 0;
      this.$modalInner.css({
        marginTop: marginTop
      });
    }
    /**
     * Add a class to the modal for individual styling
     * @param handle
     * @private
     */

  }, {
    key: "_addModalClass",
    value: function _addModalClass(handle) {
      this.$modal.addClass("modal--".concat(handle));
    }
    /**
     * Remove modal class based on the handle
     * @private
     */

  }, {
    key: "_removeModalClass",
    value: function _removeModalClass() {
      var modalClass = this.$modal.attr('class').match(/modal--[\w-]*\b/);

      if (!modalClass) {
        return;
      }

      this.$modal.removeClass(modalClass[0]);
    }
  }, {
    key: "_onClose",
    value: function _onClose() {
      this._removeModalClass();

      this.$body.removeClass('scroll-lock modal-visible');
      this.$window.off('resize.modal');
      this.$modalInner.css({
        marginTop: ''
      });
      this.callbacks.onClose();
      Object(_shopify_theme_a11y__WEBPACK_IMPORTED_MODULE_3__[/* removeTrapFocus */ "a"])();

      if (this.activeElement) {
        this.activeElement.focus();
      }
    }
  }, {
    key: "_onOpen",
    value: function _onOpen() {
      var _this = this;

      this.activeElement = document.activeElement;
      this.position();
      this.$body.addClass('scroll-lock modal-visible');
      this.$window.on('resize.modal', just_debounce__WEBPACK_IMPORTED_MODULE_1___default()(function () {
        return _this.position();
      }, 16, true, true));
      this.callbacks.onOpen();
      Object(_shopify_theme_a11y__WEBPACK_IMPORTED_MODULE_3__[/* trapFocus */ "b"])(this.$modal[0]);
    }
  }, {
    key: "_onBeforeClose",
    value: function _onBeforeClose() {
      this.callbacks.onBeforeClose();
    }
  }, {
    key: "_onBeforeOpen",
    value: function _onBeforeOpen() {
      this.callbacks.onBeforeOpen();
    }
  }]);

  return Modal;
}();



/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Accordion; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var Accordion = /*#__PURE__*/function () {
  function Accordion($el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Accordion);

    this.$el = $el;
    this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, {
      activeClass: 'accordion--active',
      autoCollapse: false,
      content: '[data-accordion-content]',
      eligibleClass: 'has-accordion'
    }, options);
  }

  _createClass(Accordion, [{
    key: "toggle",
    value: function toggle($block) {
      var open = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (open || !$block.hasClass(this.options.activeClass)) {
        if (this.options.autoCollapse) this.closeOpen();

        this._open($block);
      } else {
        this._close($block);
      }
    }
  }, {
    key: "closeOpen",
    value: function closeOpen() {
      var _this = this;

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.$el.find(".".concat(this.options.activeClass))).each(function (i, block) {
        var $block = jquery__WEBPACK_IMPORTED_MODULE_0___default()(block);

        if ($block.hasClass(_this.options.activeClass)) {
          _this._close($block);
        }
      });
    }
  }, {
    key: "openAll",
    value: function openAll() {
      var _this2 = this;

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.$el.find(".".concat(this.options.eligibleClass))).each(function (i, block) {
        _this2._open(jquery__WEBPACK_IMPORTED_MODULE_0___default()(block), 0);
      });
    }
  }, {
    key: "_open",
    value: function _open($block) {
      $block.addClass(this.options.activeClass);
    }
  }, {
    key: "_close",
    value: function _close($block) {
      $block.removeClass(this.options.activeClass);
    }
  }]);

  return Accordion;
}();



/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicenceSwitcherModal; });
/* harmony import */ var lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49);
/* harmony import */ var lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);
/* harmony import */ var _CustomerLicence__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }






var LicenceSwitcherModal = /*#__PURE__*/function () {
  function LicenceSwitcherModal() {
    _classCallCheck(this, LicenceSwitcherModal);

    if (!!LicenceSwitcherModal.instance) {
      return LicenceSwitcherModal.instance;
    }

    LicenceSwitcherModal.instance = this;
    this.selectors = {
      defaultLicence: '[data-default-licence]',
      hideDefaultLicence: '[data-hide-option]',
      loaderElement: '[data-licence-switcher-loader]',
      modalContents: '[data-licence-switcher-content]',
      openButton: '[data-licence-switcher-toggle]',
      renderedLicences: '[data-select-licence]',
      selectLicences: '[data-select-licences]',
      submitButton: '[data-licence-switcher-submit]',
      switcherModal: '[data-licence-switcher-modal]'
    };
    this.$licenceSwitcherModal = $(this.selectors.switcherModal);
    this.$submitButton = this.$licenceSwitcherModal.find(this.selectors.submitButton); // NOTE: Bind events

    this.$submitButton.on('click.setLicence', this._onSubmit.bind(this));
    this._closeModal = this._closeModal.bind(this); // NOTE: Determine if Customer has active_licence

    var customerJSON = Object(_helpers__WEBPACK_IMPORTED_MODULE_2__[/* getLiquidVars */ "q"])('[data-scripts]');
    var hasActiveLicence = lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_0___default()(false, 'customer.active_tag', customerJSON);
    var isModalVisible = this.$licenceSwitcherModal.is(':visible');
    this.activeLicenceNumber = null;

    if (hasActiveLicence && isModalVisible) {
      this._init();
    }
  }

  _createClass(LicenceSwitcherModal, [{
    key: "openModal",
    value: function openModal() {
      var modalOptions = {
        clickOutside: false,
        onClose: this._closeModal
      };
      this.modal = new _components_Modal__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](modalOptions);
      this.modal.open(this.selectors.switcherModal, 'licence-switcher');

      this._init();
    }
  }, {
    key: "_closeModal",
    value: function _closeModal() {
      this._toggleLoaderContent();

      this._toggleFallbackLicence('show');

      this._removeRenderedLicences();

      this.modal.unload();
    }
  }, {
    key: "_init",
    value: function _init() {
      this._fetchResults();
    }
  }, {
    key: "_fetchResults",
    value: function _fetchResults() {
      var _this = this;

      var api = new _CustomerLicence__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]();
      $.when(api.fetchLicences()).then(function (data, textStatus, _jqXHR) {
        var isJobRunning = lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_0___default()(true, 'data.running', data);
        var licences = lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_0___default()([], 'data.licences', data);

        if (textStatus === 'success') {
          _this._processFetchedLicences(isJobRunning, licences);
        } else {
          return false;
        }
      }).fail(function () {
        var retryDelay = 5000;
        setTimeout(function () {
          return _this._fetchResults();
        }, retryDelay);
      });
    }
    /*
      Processes the a "successful" (HTTP 200) response when fetching licences.
       @param {boolean} isJobRunning Integration background job still running?
      @param {array} licences Returned array from Integration of licence objects.
    */

  }, {
    key: "_processFetchedLicences",
    value: function _processFetchedLicences() {
      var isJobRunning = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var licences = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return isJobRunning === false ? this._renderResults(licences) : this._fetchResults();
    }
    /*
      Renders the returned licences from fetchLicences.
       @param {object} licences Object returned from Integration endpoint
    */

  }, {
    key: "_renderResults",
    value: function _renderResults() {
      var licences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      // NOTE: Check there are licences to render, returned array may be empty.
      if (licences.length) {
        /*
          NOTE: Get active licence here as we remove the dom further down the pipeline. We memoize it now, and pass to `renderLicences` to conditionally render content.
        */
        this.activeLicenceNumber = $("".concat(this.selectors.defaultLicence)).val();

        this._toggleFallbackLicence();

        this._renderLicences(licences);
      }

      this._toggleLoaderContent();
    }
    /*
      This method hides the default Liquid rendered licence <option> element. Hiding <option> cross-browser is troublesome, and options aren't effected by CSS. This solution implementation moves the option element out of the <select> element before render, and can move it back afterwards.
       @param {string} action `hide` || `show` to control displaying the element.
    */

  }, {
    key: "_toggleFallbackLicence",
    value: function _toggleFallbackLicence() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'hide';
      var element = this.selectors.defaultLicence;

      switch (action) {
        case 'show':
          $(element).prependTo(this.selectors.selectLicences);
          break;

        case 'hide':
          $(element).prependTo(this.selectors.hideDefaultLicence);
          break;
      }
    }
    /*
      Removes licences rendered by `_renderLicence`. Used in with _closeModal.
    */

  }, {
    key: "_removeRenderedLicences",
    value: function _removeRenderedLicences() {
      $("".concat(this.selectors.selectLicences, " ").concat(this.selectors.renderedLicences)).remove();
    }
    /*
      Toggle loader and modal contents, loader is displayed by default.
    */

  }, {
    key: "_toggleLoaderContent",
    value: function _toggleLoaderContent() {
      $(this.selectors.loaderElement).toggle();
      $(this.selectors.modalContents).toggle();
    }
  }, {
    key: "_renderLicences",
    value: function _renderLicences() {
      var _this2 = this;

      var licences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      licences.map(function (licence) {
        return _this2._renderLicence(licence);
      });
    }
  }, {
    key: "_renderLicence",
    value: function _renderLicence() {
      var licence = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _licence$address = licence.address,
          address = _licence$address === void 0 ? '' : _licence$address,
          _licence$name = licence.name,
          name = _licence$name === void 0 ? '' : _licence$name,
          _licence$licence_numb = licence.licence_number,
          licence_number = _licence$licence_numb === void 0 ? 0 : _licence$licence_numb; // NOTE: Set `selected` attribute on licence that's currently active.

      var selectedAttr = this.activeLicenceNumber === licence_number ? "selected" : '';
      return $(this.selectors.selectLicences).append("\n      <option\n        value=\"".concat(licence_number, "\"\n        ").concat(selectedAttr, "\n        data-select-licence\n      >\n        Licence ").concat(licence_number, ", ").concat(name, ", ").concat(address, "\n      </option>"));
    }
    /*
      When submit button is trigger within the modal.
       @param {object} event Event object.
    */

  }, {
    key: "_onSubmit",
    value: function _onSubmit(event) {
      event.preventDefault();
      this.$submitButton.addClass('processing');
      var selectedLicence = $("".concat(this.selectors.selectLicences, " option:selected")).val();
      var api = new _CustomerLicence__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]();
      $.when(api.setLicence(selectedLicence)).then(function (_data, textStatus, _jqXHR) {
        if (textStatus === 'success') {
          location.reload();
        }
      });
    }
    /*
      Enable the licence switcher modal open toggle
       TODO: think about moving this into StaticHeader/NavMobile
      What would that look like? Would it be less DRY?
    */

  }, {
    key: "enableOpenButton",
    value: function enableOpenButton() {
      var $switcherToggles = $(this.selectors.openButton);
      $switcherToggles.removeClass('disabled');
      $switcherToggles.removeAttr('disabled');
    }
  }]);

  return LicenceSwitcherModal;
}();



/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchForm; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var SearchForm = /*#__PURE__*/function () {
  function SearchForm($container) {
    _classCallCheck(this, SearchForm);

    this.$body = jquery__WEBPACK_IMPORTED_MODULE_0___default()('body');
    this.$container = $container;
    this.$form = this.$container.find('[data-live-search-form]');
    this.submitHandler = this.submitHandler.bind(this);
    this.events = [this.$form.on('submit.search-form', this.submitHandler)];
  }

  _createClass(SearchForm, [{
    key: "unload",
    value: function unload() {
      this.events.forEach(function ($el) {
        return $el.off('.search-form');
      });
    }
  }, {
    key: "submitHandler",
    value: function submitHandler(event) {
      event.preventDefault();
      var $form = jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.currentTarget).clone();
      var $terms = $form.find('[name=q]');
      $form.css({
        position: 'absolute',
        left: -1000,
        bottom: -1000,
        visibility: 'hidden'
      });
      var terms = $terms.val(); // Adds `*` after each word in search terms, doesn't add to last word

      if (terms.indexOf(' ') > 0) {
        terms = terms.split(' ').join('* ').trim();
      } // Adds `*` at the end of the search terms


      terms = "".concat(terms, "*"); // Update value

      $terms.val(terms); // Forms must be in the browser context in order to submit

      this.$body.append($form);
      $form.submit();
    }
  }]);

  return SearchForm;
}();



/***/ }),

/***/ 831:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 833:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 862:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 863:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 903:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticSectionFooter; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Accordion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59);
/* harmony import */ var _Forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }






var StaticSectionFooter = /*#__PURE__*/function () {
  function StaticSectionFooter(section) {
    _classCallCheck(this, StaticSectionFooter);

    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.Accordion = new _Accordion__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](this.$el);
    this.forms = new _Forms__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"](this.$el); // Handle Accordion interaction when window size changes

    this.layoutHandler = this.onBreakpointChange.bind(this);
    _Layout__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].onBreakpointChange(this.layoutHandler);

    this._bindEvents();

    this._externalLinks();
  }

  _createClass(StaticSectionFooter, [{
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;

      this.$el.on('click.footer', '[data-accordion-trigger]', function (event) {
        event.preventDefault();

        _this._toggleAccordion(jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.currentTarget).parent());
      });
    }
  }, {
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.$el.off('.footer');
      this.forms.unload();
      delete this.Accordion;
    }
  }, {
    key: "onSectionBlockSelect",
    value: function onSectionBlockSelect(block) {
      var $block = jquery__WEBPACK_IMPORTED_MODULE_0___default()(block.el);

      if ($block.hasClass('has-accordion')) {
        this._toggleAccordion($block, true);
      }
    }
  }, {
    key: "onSectionBlockDeselect",
    value: function onSectionBlockDeselect(block) {
      var $block = jquery__WEBPACK_IMPORTED_MODULE_0___default()(block.el);

      if ($block.hasClass('has-accordion')) {
        this._toggleAccordion($block, false);
      }
    }
  }, {
    key: "_toggleAccordion",
    value: function _toggleAccordion($block) {
      if (_Layout__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isBreakpoint('L')) {
        return;
      }

      this.Accordion.toggle($block);
    }
  }, {
    key: "onBreakpointChange",
    value: function onBreakpointChange(event, breakpoints) {
      if (_Layout__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isBreakpoint('L')) {
        this.Accordion.openAll();
      } else if (breakpoints.previous === 'L' && !_Layout__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isBreakpoint('L')) {
        this.Accordion.closeOpen();
      }
    }
  }, {
    key: "_externalLinks",
    value: function _externalLinks() {
      this.$el.find('a[href^="http"]').not("a[href^=\"".concat(location.hostname, "\"]")).attr('target', '_blank');
    }
  }]);

  return StaticSectionFooter;
}();



/***/ }),

/***/ 904:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticArticle; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_RichText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47);
/* harmony import */ var _Forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }





var StaticArticle = /*#__PURE__*/function () {
  function StaticArticle(section) {
    _classCallCheck(this, StaticArticle);

    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.$commentForm = this.$el.find('[data-articlecomments-form]');
    this.richText = new _components_RichText__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](this.$el);

    if (this.$commentForm.length) {
      this.commentForm = new _Forms__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"](this.$commentForm);
    }
  }

  _createClass(StaticArticle, [{
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.richText.unload();

      if (this.commentForm) {
        this.commentForm.unload();
      }
    }
  }]);

  return StaticArticle;
}();



/***/ }),

/***/ 905:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticBlog; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_RichText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var StaticBlog = /*#__PURE__*/function () {
  function StaticBlog(section) {
    _classCallCheck(this, StaticBlog);

    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.richText = new _components_RichText__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](this.$el);
  }

  _createClass(StaticBlog, [{
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.richText.unload();
    }
  }]);

  return StaticBlog;
}();



/***/ }),

/***/ 906:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticCart; });
/* harmony import */ var scriptjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24);
/* harmony import */ var scriptjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(scriptjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var just_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32);
/* harmony import */ var just_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(just_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49);
/* harmony import */ var lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _pixelunion_shopify_asyncview__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(163);
/* harmony import */ var _CheckboxMaster__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(164);
/* harmony import */ var _Dropdown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94);
/* harmony import */ var _Search__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95);
/* harmony import */ var _components_InlineSearch__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97);
/* harmony import */ var _components_Modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58);
/* harmony import */ var _components_ProductListItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48);
/* harmony import */ var _components_RelatedProducts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(168);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }














var StaticCart = /*#__PURE__*/function () {
  function StaticCart(section) {
    var _this = this;

    _classCallCheck(this, StaticCart);

    this.section = section;
    this.$el = $(section.el);
    this.sectionId = this.$el.attr('id');
    this.settings = section.data.settings;
    this.cart = section.data.cart;
    this.cartCurrentPage = 1;
    this.cartPages = section.data.cart_page_count;
    this.data = Object(_helpers__WEBPACK_IMPORTED_MODULE_11__[/* getLiquidVars */ "q"])('[data-scripts]');
    this.integrationData = Object(_helpers__WEBPACK_IMPORTED_MODULE_11__[/* getLiquidVars */ "q"])('[data-integration]');
    this.licenceType = this.integrationData.integrationConfig.licenceType;
    this.tokenProductStorefront = this.settings.token_pact;
    var liquidData = Object(_helpers__WEBPACK_IMPORTED_MODULE_11__[/* getLiquidVars */ "q"])('[data-features]');
    this._orderLimitFeatureFlag = lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_2___default()(false, 'tf.ol', liquidData);
    this._pactFeatureFlag = lodash_fp_getOr__WEBPACK_IMPORTED_MODULE_2___default()(false, 'tf.pact', liquidData);
    this.$window = $(window);
    this.$body = $(document.body);
    this.$el = $(section.el);
    this.$header = $('.site-header-wrapper');
    this.$cartForm = this.$el.find('[data-cart-form]');
    this.$cannabisWeight = this.$el.find('[data-cart-weight-cannabis]');
    this.$shippingWeight = this.$el.find('[data-cart-weight-shipping]');
    this.$total = this.$el.find('[data-cart-total]');
    this.$itemCount = this.$el.find('[data-cart-total-count]');
    this.$items = this.$el.find('[data-cart-items]');
    this.$searchField = this.$el.find('[data-live-search]');
    this.$headerDropdown = this.$el.find('[data-cart-dropdown]');
    this.$checkoutButton = this.$el.find('[data-cart-checkout-button]');
    this.$sidebarSubtotal = this.$el.find('[data-cart-total-subtotal]');
    this.$empty = this.$el.find('[data-cart-empty]');
    this.$productList = this.$el.find('[data-product-list]');
    this.$removeItems = this.$el.find('[data-cart-items-remove]');
    this.$continueShoppingEl = this.$el.find('[data-continue-shopping]'); // Cart items

    this.productItems = {};
    this.visibleCartItems = {}; // Add current cart items to visible items tracking object

    this._formatCartItemsForTracking(this.cart.items); // Grid utils


    this.$utils = this.$el.find('[data-product-list-utils]');
    this.$utilsDefault = this.$utils.find('[data-product-list-utils-default]');
    this.$utilsSelected = this.$utils.find('[data-product-list-utils-selected]'); // Product form containers

    this.$titleTotalSmall = this.$el.find('.cart-title-total--small');
    this.$titleTotalLarge = this.$el.find('.cart-title-total--large');
    this.$titleTotalContents = this.$el.find('[data-cart-title-total]'); // Restriction elements

    this.restrictions = section.data.restrictions;
    this.$warningQuantity = this.$el.find('[data-cart-warning="quantity"]');
    this.$warningOrderLimit = this.$el.find('[data-cart-warning="total"]');
    this.$warningRemainingAllowance = this.$el.find('[data-cart-warning="remaining"]');
    this.$remainingBudgetContainer = this.$el.find('[data-cart-remaining]');

    this._moveTitleTotal();

    this.eventHandler = new _helpers__WEBPACK_IMPORTED_MODULE_11__[/* EventHandler */ "d"]();
    var $scripts = $('[data-scripts]');
    scriptjs__WEBPACK_IMPORTED_MODULE_0___default()($scripts.data('shopify-api-url'), function () {
      _this._bindEvents();

      _this.manageCart = new _helpers__WEBPACK_IMPORTED_MODULE_11__[/* ManageCart */ "g"](); // Inline search for adding product to the cart

      _this.searchSettings = $.extend({
        addTo: 'cart'
      }, _this.settings.live_search);
      _this.inlineSearch = new _components_InlineSearch__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"]({
        $el: _this.$searchField,
        $header: _this.$el
      }, _this.searchSettings); // Additional search executed to grab specific product on add to cart

      _this.search = new _Search__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"]({
        view: 'cart-item',
        type: 'product'
      });

      _this.search.on('complete', _this._searchComplete.bind(_this));
    });
    this.relatedProducts = new _components_RelatedProducts__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"](section);
    this.headerDropdown = new _Dropdown__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"](this.$headerDropdown[0]);

    this._loadCartItems('items');
    /**
     * NOTE: Cart Validate is coupled to the DOM and must be run after
     * the _loadCartItems function. If run before it may not always validate items properly.
     */
    // NOTE: If OLOT feature flag enabled, validate Cart


    if (this._orderLimitFeatureFlag) {
      this.cartValidator = new _helpers__WEBPACK_IMPORTED_MODULE_11__[/* CartValidator */ "c"](section.data, this.$el, this.$cartForm);
    }
  }

  _createClass(StaticCart, [{
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.$el.off('.cart-page');
      this.$window.off('.cart-page');
      this.$headerDropdown.off('.cart-page');
      this.$cartForm.off('.cart-page');
      this.cartValidator.unload();
      this.inlineSearch.unload();
      this.headerDropdown.unload();
      this.checkboxMaster.unload();

      for (var item in this.productItems) {
        item.unload();
      }

      if (this.modal) {
        this.modal.unload();
      }
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this2 = this;

      this.$headerDropdown.on('click.cart-page', '[data-cart-items-remove]', function (event) {
        event.preventDefault();

        _this2.manageCart.clear();
      });
      this.$window.on('resize.cart-page', just_debounce__WEBPACK_IMPORTED_MODULE_1___default()(function () {
        return _this2._moveTitleTotal();
      }, 20));
      this.eventHandler.on('cartUpdate', this._updateCart.bind(this));
      this.$body.on('cart:disable-button', this._disableCheckoutButton.bind(this));
      this.$body.on('cart:search-sku', this._executeSearch.bind(this));
      this.$el.on('click.cart-page', '[data-product-list-remove]', function (event) {
        event.preventDefault();
        var buttonHTMLElement = $(event.currentTarget);
        Object(_helpers__WEBPACK_IMPORTED_MODULE_11__[/* disableButton */ "j"])(buttonHTMLElement);

        _this2.manageCart.updateAll(0, 'removed', buttonHTMLElement);
      });
      this.$el.on('click.cart-page', '[data-product-list-quantity]', function (event) {
        event.preventDefault();

        _this2._adjustMultipleQuantities();
      });
      this.$body.on('cart:update-checkout-button', this._updateCheckoutButton.bind(this));
      this.$cartForm.on('submit.cart-page', function (event) {
        var validationPassed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        // We want to remove PACT items from the cart prior to Order Limits
        // validation so we do not send 'not available' items in the Order Limits
        // payload's requests.
        if (_this2._pactFeatureFlag) {
          _this2._removeVariantsByCustomerType();
        }

        if (!_this2._orderLimitFeatureFlag) {
          // NOTE: When disabled, set to true to allow checkout.
          validationPassed = true;
        }

        if (!validationPassed) {
          event.preventDefault();

          _this2.cartValidator.validateOrder(_this2.cart, true);
        } else {
          $('<input />').attr('type', 'hidden').attr('name', 'checkout').appendTo(_this2.$cartForm);
        }
      });
      this.$continueShoppingEl.on('click', function (event) {
        event.preventDefault();
        window.location.href = _this2._continueShoppingRedirectLocation(document.referrer);
      });
    }
    /**
     * Formats the cart's items for tracking purposes
     *
     * @param {cartItems} - Accepts a Shopify cart.items array
     * @returns {visibleCartItems} - Object of formatted cart items
     * @private
     */

  }, {
    key: "_formatCartItemsForTracking",
    value: function _formatCartItemsForTracking() {
      var cartItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var updatingItems = JSON.parse(JSON.stringify(this.visibleCartItems));

      var _iterator = _createForOfIteratorHelper(cartItems),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var productType = item.product_type.toLowerCase();
          var quantity = item.quantity,
              sku = item.sku;

          if (productType !== 'fee') {
            this._addCartItemToTracking(item.id, quantity, sku);
          }

          if (updatingItems[item.id] || productType === 'fee') {
            delete updatingItems[item.id];
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      for (var _i = 0, _Object$entries = Object.entries(updatingItems); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        this._addCartItemToTracking(key, 0, value.sku);
      }
    }
    /**
     * Add cart item to tracking object
     *
     * @param id - Variant id
     * @param quantity - Variant quantity in cart
     * @param sku - Variant sku
     * @private
     */

  }, {
    key: "_addCartItemToTracking",
    value: function _addCartItemToTracking(id, quantity) {
      var sku = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      this.visibleCartItems[id] = {
        quantity: quantity,
        sku: sku
      };
    }
    /**
     * Remove cart item from tracking object
     *
     * @param id - Variant id
     * @private
     */

  }, {
    key: "_removeCartItemFromTracking",
    value: function _removeCartItemFromTracking(id) {
      delete this.visibleCartItems[id];
    }
  }, {
    key: "_onCheckboxMasterChange",
    value: function _onCheckboxMasterChange(state) {
      this.$el.toggleClass('product-selected', state != 'empty');
      this.$utilsDefault.toggleClass('active', state == 'empty');
      this.$utilsSelected.toggleClass('active', state != 'empty');

      if (state == 'empty') {
        this.$productItems.removeClass('productlist--item-active');
        this.manageCart.unstageAll();
      }
    }
  }, {
    key: "_moveTitleTotal",
    value: function _moveTitleTotal() {
      if (!this.$titleTotalContents.length) {
        return;
      }

      if (this.$window.outerWidth() >= 480) {
        if (!$.contains(this.$titleTotalLarge[0], this.$titleTotalContents[0])) {
          var $form = this.$titleTotalContents.detach();
          this.$titleTotalLarge.append($form);
        }
      } else if (!$.contains(this.$titleTotalSmall[0], this.$titleTotalContents[0])) {
        var _$form = this.$titleTotalContents.detach();

        this.$titleTotalSmall.append(_$form);
      }
    }
  }, {
    key: "_updateCart",
    value: function _updateCart(cart, messages) {
      var _this3 = this;

      this.cart = cart;

      this._resetFlags();

      this._flagSummaryErrors(messages);

      messages.items.map(function (item) {
        if (item.error) {
          _this3._flagError(item.id);
        } else {
          _this3._flagSuccess(item.id);
        }
      }); // Uncheck all checkboxes

      if (this.checkboxMaster) {
        this.checkboxMaster.clear();
      }

      this._getWeight(cart);

      this._formatCartItemsForTracking(cart.items);

      this._removeProducts(messages.items);

      this._updateProducts(messages.items);

      this._updateTotals(cart);

      this._updateCheckoutButton(null, cart); // Update CDF lines in subtotal area


      Object(_helpers__WEBPACK_IMPORTED_MODULE_11__[/* CDFupdateQuantities */ "b"])(cart); // NOTE: Update the remaining item values when quick adding a new product

      this.cartValidator.validateOrder(cart, false);

      if (Object.keys(this.visibleCartItems).length) {
        this.$empty.revealer('hide');
      } else {
        this.$empty.revealer('show');
      }

      if (this.modal) {
        this.modal.close();
      }

      if (this.cart.items.length === 0) {
        this.$removeItems.prop('disabled', true).addClass('disabled');
      } else {
        this.$removeItems.prop('disabled', false).removeClass('disabled');
      }
    }
  }, {
    key: "_flagError",
    value: function _flagError(key) {
      var $item = this.$items.find("[data-product-list-item-id=\"".concat(key, "\"]"));
      var $quantity = $item.find('[data-product-list-item-quantity]');
      $item.addClass('productlist--item-warning');
      $quantity.attr('data-product-list-item-quantity', $quantity.val());
    }
  }, {
    key: "_flagSuccess",
    value: function _flagSuccess(key) {
      this.$items.find("[data-product-list-item-id=\"".concat(key, "\"]")).addClass('productlist--item-success');
    }
  }, {
    key: "_flagSummaryErrors",
    value: function _flagSummaryErrors(messages) {
      // Exceeds OLOT SKU quantity limits
      var exceedsLimit = messages.items.filter(function (item) {
        return item.reason === 'exceeds_limit';
      });

      if (exceedsLimit.length) {
        this.$warningQuantity.addClass('active');
      }
    }
  }, {
    key: "_resetFlags",
    value: function _resetFlags() {
      this.$sidebarSubtotal.removeClass('error');
      this.$warningOrderLimit.removeClass('active');
      this.$warningQuantity.removeClass('active');
      this.$warningRemainingAllowance.removeClass('active');
      this.$remainingBudgetContainer.removeClass('error');
      this.$items.find('[data-product-list-item]').removeClass('productlist--item-warning productlist--item-success');
    }
  }, {
    key: "_updateProducts",
    value: function _updateProducts(items) {
      var _this4 = this;

      var _loop = function _loop() {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
            key = _Object$entries2$_i[0],
            value = _Object$entries2$_i[1];

        var $product = _this4.$items.find("[data-product-list-item-id=\"".concat(key, "\"]"));

        if ($product.length) {
          // Item already exists in the cart
          $product.trigger('product-item:update-cart', value.quantity);
        } else {
          // Newly added item
          var error = items.reduce(function (_obj, item) {
            if (item.sku === value.sku) {
              return item.error;
            }
          }, false);

          _this4._executeSearch(null, value.sku, false, error);
        }
      };

      for (var _i2 = 0, _Object$entries2 = Object.entries(this.visibleCartItems); _i2 < _Object$entries2.length; _i2++) {
        _loop();
      }

      this._updateWeight();
    }
  }, {
    key: "_executeSearch",
    value: function _executeSearch(_event, sku) {
      var remaining = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var valid = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      this.search.execute(sku, {
        remaining: remaining,
        valid: valid
      });
    }
  }, {
    key: "_searchComplete",
    value: function _searchComplete(response, onCompletePayload) {
      var remaining = onCompletePayload.remaining,
          valid = onCompletePayload.valid;
      var $product = $(response.product);
      var variantId = $product.data('product-listItem-id');
      var id = variantId;
      var quantity = 0;

      if (!this.productItems[variantId]) {
        this.productItems[variantId] = new _components_ProductListItem__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"]($product);
        this.$items.append($product);
      } // Update max purchasable quantity


      if (remaining || remaining === 0) {
        $product.trigger('product-item:update-remaining', remaining);
      }

      if (valid) {
        this._flagError(variantId);
      } else {
        this._flagSuccess(variantId);
      } // Loop through cart items and find added search item


      var addedCartItem = this.cart.items.find(function (cartItem) {
        return cartItem.product_id === response.item.id;
      });

      if (addedCartItem) {
        id = addedCartItem.id;
        quantity = addedCartItem.quantity;

        this._updateWeight();
      } // Track item


      this._addCartItemToTracking(id, quantity); // Select the added search item


      var $addedItem = this.$el.find("#updates_".concat(id)); // Update appended product input value to visually display initial requested amount

      $addedItem.val(quantity);
      $addedItem.attr('data-product-list-item-quantity', quantity); // Redefine product items

      this.$productItems = this.$el.find('[data-product-list-item]'); // Re-establish checkbox hooks

      if (this.checkboxMaster) {
        this.checkboxMaster.init();
      }
    }
  }, {
    key: "_removeProducts",
    value: function _removeProducts(items) {
      var _this5 = this;

      var _loop2 = function _loop2(i) {
        var _items$i = items[i],
            id = _items$i.id,
            reason = _items$i.reason;

        if (reason !== 'removed') {
          return "continue";
        } // Remove item from tracking


        _this5._removeCartItemFromTracking(id); // Unbind removed product


        _this5.productItems[id].unload();

        delete _this5.productItems[id]; // Find product element

        var $product = _this5.$el.find("[data-product-list-item-id=\"".concat(id, "\"]")); // Remove item from cart visually


        $product.height($product.height());
        setTimeout(function () {
          $product.addClass('removing-from-cart').one('trend', function () {
            $product.find('[data-product-list-item-checkbox]')[0].checked = false;
            $product.remove();

            _this5.checkboxMaster.handleSlaveChange();
          });
        }, 20);
      };

      for (var i = 0; i < items.length; i++) {
        var _ret = _loop2(i);

        if (_ret === "continue") continue;
      }
    }
  }, {
    key: "_getWeight",
    value: function _getWeight(cart) {
      var precision = 2; // NOTE: Precision to rounded to.

      var radix = 10; // NOTE: Value to round to.

      var cannabisWeight = 0;
      var shippingWeight = 0;

      var _iterator2 = _createForOfIteratorHelper(cart.items),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          var productType = item.product_type.toLowerCase();
          var _item$properties = item.properties,
              _item$properties$case = _item$properties.case_size,
              case_size = _item$properties$case === void 0 ? 1 : _item$properties$case,
              _item$properties$cons = _item$properties.consumer_units,
              consumer_units = _item$properties$cons === void 0 ? 1 : _item$properties$cons,
              gram_equivalency = _item$properties.gram_equivalency;

          if (productType === 'cannabis' && item.properties && gram_equivalency) {
            var gramEq = parseFloat(gram_equivalency);
            var caseSize = parseInt(case_size, radix);
            var consumerUnits = parseInt(consumer_units, radix);
            var equiv = gramEq * caseSize * consumerUnits;
            var lineItemWeight = equiv * item.quantity;
            cannabisWeight = cannabisWeight + lineItemWeight;
          } // NOTE: Converting to proper units.


          var itemWeight = item.grams * item.quantity / 1000;
          shippingWeight = shippingWeight + itemWeight;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      shippingWeight = shippingWeight === 0 ? 0 : shippingWeight; // NOTE: Ensure that returned value is guarded against repeating decimals.

      this.cannabisWeight = cannabisWeight.toFixed(precision);
      this.shippingWeight = shippingWeight.toFixed(precision);
    }
  }, {
    key: "_updateWeight",
    value: function _updateWeight() {
      this.$cannabisWeight.text(this.cannabisWeight);
      this.$shippingWeight.text(this.shippingWeight);
    }
  }, {
    key: "_updateTotals",
    value: function _updateTotals(cart) {
      this.$total.text(Shopify.formatMoney(cart.total_price, this.data.settings.money_format));
      var cdfCount = Object(_helpers__WEBPACK_IMPORTED_MODULE_11__[/* CDFQuantityTotal */ "a"])(cart);
      var cartTotal = cart.item_count - cdfCount;
      this.$itemCount.text(cartTotal);
    }
  }, {
    key: "_updateCheckoutButton",
    value: function _updateCheckoutButton(_event) {
      var valid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var cart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.cart;

      if (this.data.checkout_disabled) {
        return false;
      }

      if (cart.item_count === 0 || !valid) {
        this._disableCheckoutButton();
      } else if (cart.original_total_price > this.data.settings.cart_total_limit) {
        this.$sidebarSubtotal.addClass('error');
        this.$warningOrderLimit.addClass('active');

        this._disableCheckoutButton();
      } else {
        this._enableCheckoutButton();
      }
    }
    /**
     * Check and see if the browsers previous page is within allowed routes, otherwise return the fallback URL.
     *
     * @param {src} - String of url to compare to
     */

  }, {
    key: "_continueShoppingRedirectLocation",
    value: function _continueShoppingRedirectLocation() {
      var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var newLocation = false;
      var fallbackUrl = this.settings.continue_shopping_fallback_url;
      var allowableRoutes = ['/collections/', '/products/'];
      allowableRoutes.map(function (route) {
        return src.includes(route) ? newLocation = src : null;
      });
      return newLocation === false ? fallbackUrl : newLocation;
    }
  }, {
    key: "_enableCheckoutButton",
    value: function _enableCheckoutButton() {
      if (this.$checkoutButton.is('[data-cart-checkout-button="checkout-locked"]')) {
        return false;
      }

      this.$checkoutButton.prop('disabled', false).removeClass('disabled');
    }
  }, {
    key: "_disableCheckoutButton",
    value: function _disableCheckoutButton() {
      this.$checkoutButton.prop('disabled', true).addClass('disabled');
    }
  }, {
    key: "_adjustMultipleQuantities",
    value: function _adjustMultipleQuantities() {
      var count = this.$items[0].querySelectorAll('[data-form-checkbox-slave]:checked').length;
      var quantityModalContainer = '[data-cart-quantities-modal]';
      $(quantityModalContainer).find('[data-cart-quantities-modal-count]').text(count);
      var modalCallbacks = {
        onOpen: this._openQuantityModal.bind(this),
        onBeforeClose: this._closeQuantityModal.bind(this)
      };
      this.modal = new _components_Modal__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"](modalCallbacks);
      this.modal.open(quantityModalContainer, 'cart-quantities-adjust');
    }
  }, {
    key: "_openQuantityModal",
    value: function _openQuantityModal() {
      var _this6 = this;

      this.modal.$modal.on('click.cart-page', '[data-cart-quantities-submit]', function () {
        var quantity = _this6.modal.$modal.find('[data-cart-quantities-modal-form-input] input').val();

        _this6.manageCart.updateAll(parseInt(quantity, 10));
      });
      this.modal.$modal.on('click.cart-page', '[data-cart-quantities-cancel]', this.modal.close.bind(this));
    }
  }, {
    key: "_closeQuantityModal",
    value: function _closeQuantityModal() {
      this.checkboxMaster.clear();
      this.modal.$modal.off('.cart-page');
      this.modal.unload();
    }
  }, {
    key: "_loadCartItems",
    value: function _loadCartItems(context) {
      var _this7 = this;

      // Load cart item content
      var $items = _pixelunion_shopify_asyncview__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].load('/cart', {
        view: context
      }).then(function (response) {
        var items = _this7.$items[0]; // Inject content

        var content = response.html.content;

        if (_this7.cartCurrentPage > 1) {
          content = items.innerHTML + content;
        }

        items.innerHTML = content; // Bind events to new items
        // NOTE: IE11 fix, read more at top of CheckboxMaster.js

        var productItems = [].slice.call(items.querySelectorAll('[data-product-list-item]'));
        productItems.forEach(function (item) {
          var variantId = item.dataset.productListItemId;
          _this7.productItems[variantId] = new _components_ProductListItem__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"]($(item), _this7.sectionId);
        });
      }); // Return a resolved Promise so done callback can be executed externally

      return $.when($items).done(function () {
        _this7.cartCurrentPage++; // Define product items

        _this7.$productItems = _this7.$el.find('[data-product-list-item]');

        if (_this7.checkboxMaster) {
          _this7.checkboxMaster.unload();
        }

        _this7.checkboxMasterOptions = {
          onChange: _this7._onCheckboxMasterChange.bind(_this7)
        };
        _this7.checkboxMaster = new _CheckboxMaster__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"](_this7.$productList[0], _this7.checkboxMasterOptions);

        if (_this7.cartCurrentPage <= _this7.cartPages) {
          _this7._loadCartItems("items-".concat(_this7.cartCurrentPage));
        }
      });
    }
    /**
     * Formats update payload and triggers removal
     * @param {string} key cart item key
     */

  }, {
    key: "_removeVariantsByCustomerType",
    value: function () {
      var _removeVariantsByCustomerType2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var variants;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(_helpers__WEBPACK_IMPORTED_MODULE_11__[/* filterByCustomerType */ "k"])(this.licenceType, this.tokenProductStorefront);

              case 2:
                variants = _context.sent;
                this.manageCart.remove(variants, 'pact_unavailable');

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _removeVariantsByCustomerType() {
        return _removeVariantsByCustomerType2.apply(this, arguments);
      }

      return _removeVariantsByCustomerType;
    }()
  }]);

  return StaticCart;
}();



/***/ }),

/***/ 907:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticCollection; });
/* harmony import */ var _components_Modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58);
/* harmony import */ var _components_ProductList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var StaticCollection = /*#__PURE__*/function () {
  function StaticCollection(section) {
    var _this = this;

    _classCallCheck(this, StaticCollection);

    this.section = section;
    this.$el = $(section.el);
    this.$body = $(document.body);
    this.$focusItem = null;
    this.sortContent = '[data-productgrid-sort-content]';
    this.$sortOpen = this.$el.find('[data-productgrid-sort-open]');
    this.$sortTrigger = this.$el.find('[data-productgrid-trigger-sort]');
    this.$sortTriggerButton = this.$el.find('[data-productgrid-trigger-sort-button]');
    this.$sortTriggerModal = this.$el.find('[data-productgrid-modal-sort]');
    this.$sortOptions = this.$el.find('[data-productgrid-sort-options]');
    this.$gridViewToggle = this.$el.find('[data-collection-grid-view]');
    this.$listViewToggle = this.$el.find('[data-collection-list-view]');
    this.$gridContainer = this.$el.find('.productgrid--outer');
    this._openSorting = this._openSorting.bind(this);
    this._changeSorting = this._changeSorting.bind(this);
    this._changeSortingButton = this._changeSortingButton.bind(this);
    this._showSortModal = this._showSortModal.bind(this);
    this._onModalClose = this._onModalClose.bind(this);
    this._toggleListView = this._toggleListView.bind(this);
    this._toggleGridView = this._toggleGridView.bind(this);
    var modalCallbacks = {
      onClose: this._onModalClose
    };
    this.events = [this.$sortOpen.on('click.collection', this._openSorting), this.$sortOptions.on('click.collection', 'a', function (event) {
      event.preventDefault();

      _this._triggerChangeSorting(event.currentTarget);
    }), this.$sortTrigger.on('change.collection', this._changeSorting), this.$sortTriggerButton.on('click.collection', this._changeSortingButton), this.$sortTriggerModal.on('click.collection', this._showSortModal), this.$gridViewToggle.on('click.collection', this._toggleGridView), this.$listViewToggle.on('click.collection', this._toggleListView), this.$body.on('touchstart.collection, click.collection', function (event) {
      _this._handleDocumentClick(event.target);
    })];
    var options = {
      sectionId: this.$el.attr('id')
    }; // Product items

    this.productList = new _components_ProductList__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]('[data-product-list]', options);

    this._setSortByQueryParameters();

    this.modal = new _components_Modal__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](modalCallbacks);
  }

  _createClass(StaticCollection, [{
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.events.forEach(function ($el) {
        return $el.off('.collection');
      });
      this.modal.unload();
    }
    /**
     * Open Sort by modal (on mobile)
     *
     * @param event
     * @private
     */

  }, {
    key: "_showSortModal",
    value: function _showSortModal(event) {
      event.preventDefault();
      this.$focusItem = $(event.currentTarget);
      this.modal.open(this.sortContent, 'productgrid-sort');
    }
    /**
     * Make Shopify aware of releavent collection search info
     *  - tag
     *  - vendor
     *  - pagination
     *  - sorting criteria
     *
     * @private
     */

  }, {
    key: "_setSortByQueryParameters",
    value: function _setSortByQueryParameters() {
      Shopify.queryParams = {};

      if (location.search.length) {
        for (var i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          var aKeyValue = aCouples[i].split('='); // Reset the page number when we apply (i.e. don't add it to params)

          if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    }
    /**
     * Sort by opens a modal on mobile, this handles button events
     *
     * @param event
     * @private
     */

  }, {
    key: "_changeSortingButton",
    value: function _changeSortingButton(event) {
      var activeClass = 'utils-sortby--modal-button--active';
      $(event.currentTarget).addClass(activeClass).parent().siblings().find(".".concat(activeClass)).removeClass(activeClass);

      this._changeSorting(event);
    }
  }, {
    key: "_handleDocumentClick",
    value: function _handleDocumentClick(target) {
      var $parent = $(target).closest('[data-productgrid-sort-custom]');

      if ($parent.length) {
        return;
      }

      this.$sortOptions.revealer('hide');
    }
    /**
     * Open custom collection sorting select
     *
     * @param event
     * @private
     */

  }, {
    key: "_openSorting",
    value: function _openSorting() {
      this.$sortOptions.revealer('show');
    }
  }, {
    key: "_triggerChangeSorting",
    value: function _triggerChangeSorting(target) {
      var $target = $(target);
      var value = $target.data('productgrid-sort-value');

      this._changeSorting(null, value);
    }
    /**
     * Change sorting of collection
     *
     * @param event
     * @private
     */

  }, {
    key: "_changeSorting",
    value: function _changeSorting(event, value) {
      var $target;

      if (event) {
        event.preventDefault();
        $target = $(event.currentTarget);
      }

      var newSort = event ? $target.val() : value;
      Shopify.queryParams.sort_by = newSort;
      location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
    }
    /**
     * Return focus to last used button (if found) on modal close
     *
     * @private
     */

  }, {
    key: "_onModalClose",
    value: function _onModalClose() {
      if (this.$focusItem) {
        this.$focusItem.focus();
        this.$focusItem = null;
      }
    }
    /**
     * Toggle grid view
     *
     */

  }, {
    key: "_toggleGridView",
    value: function _toggleGridView(event) {
      Shopify.queryParams.view = 'grid';
      location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
    }
    /**
     * Toggle list view
     *
     */

  }, {
    key: "_toggleListView",
    value: function _toggleListView(event) {
      Shopify.queryParams.view = 'list';
      location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
    }
  }]);

  return StaticCollection;
}();



/***/ }),

/***/ 908:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticGiftcard; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var scriptjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24);
/* harmony import */ var scriptjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(scriptjs__WEBPACK_IMPORTED_MODULE_1__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var StaticGiftcard = /*#__PURE__*/function () {
  function StaticGiftcard(section) {
    var _this = this;

    _classCallCheck(this, StaticGiftcard);

    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.$qrCode = this.$el.find('[data-giftcard-qr]');
    this.$giftCardCode = this.$el.find('[data-giftcard-code]');
    scriptjs__WEBPACK_IMPORTED_MODULE_1___default()(jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-scripts]').data('shopify-qrcode'), function () {
      _this.QRCode = new QRCode(_this.$qrCode[0], {
        text: _this.$qrCode.attr('data-giftcard-qr'),
        width: 120,
        height: 120
      });
    });

    this._bindEvents();
  }

  _createClass(StaticGiftcard, [{
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this2 = this;

      this.$el.on('click', '[data-giftcard-print]', function () {
        window.print();
      }); // Auto-select gift card code on click, based on ID passed to the function

      this.$el.on('click', '[data-giftcard-code]', function () {
        _this2._selectText();
      });
    }
  }, {
    key: "_selectText",
    value: function _selectText() {
      var text = this.$giftCardCode[0];
      var range = '';

      if (document.body.createTextRange) {
        // ms method
        range = document.body.createTextRange();
        range.moveToElementText(text);
        range.select();
      } else if (window.getSelection) {
        // moz, opera, webkit method
        var selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  }]);

  return StaticGiftcard;
}();



/***/ }),

/***/ 909:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticFilters; });
/* harmony import */ var _components_Modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var StaticFilters = /*#__PURE__*/function () {
  function StaticFilters(section) {
    _classCallCheck(this, StaticFilters);

    this.$el = $(section.el);
    this.context = section.data.context;
    this.filter_settings = section.data.filters;
    this.$advandedTags = this.$el.find('[data-tag-advanced] a');
    this.$filterGroups = this.$el.find('[data-filter-group]');
    this.$additionalTags = this.$el.find('[data-filter-toggle]');
    this.$gridContainer = $('[data-product-grid-wrapper]');
    this.$filtersTrigger = this.$gridContainer.find('[data-productgrid-trigger-filters]');
    this.filtersContent = '[data-productgrid-filters-content]';
    this.$allTags = this.$el.find("".concat(this.filtersContent, " .filter-item a:not([data-filter-toggle])"));
    this._showFiltersModal = this._showFiltersModal.bind(this);
    this._toggleTags = this._toggleTags.bind(this);
    this._activateTag = this._activateTag.bind(this);
    this._advancedTags = this._advancedTags.bind(this);
    var modalCallbacks = {
      onOpen: this._onModalOpen,
      onClose: this._onModalClose
    };
    this.events = [this.$advandedTags.on('click.filters', this._advancedTags), this.$additionalTags.on('click.filters', this._toggleTags), this.$allTags.on('click.filters', this._activateTag), this.$filtersTrigger.on('click.filters', this._showFiltersModal)];
    this.modal = new _components_Modal__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](modalCallbacks);

    this._setupHiddenTags();
  }

  _createClass(StaticFilters, [{
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.events.forEach(function ($el) {
        return $el.off('.filters');
      });
    }
    /**
     * Hides tag filters
     *
     * @private
     */

  }, {
    key: "_setupHiddenTags",
    value: function _setupHiddenTags() {
      var limit = this.filter_settings.limit;
      this.$filterGroups.each(function (i, filterGroup) {
        var filters = filterGroup.querySelectorAll('[data-tag-advanced]');

        if (filters.length > limit) {
          filters.forEach(function (filter, index) {
            if (index > limit - 1) {
              filter.classList.add('filter-item--hidden');
              filter.setAttribute('data-hidden-default', '');
            }
          });
        }
      });
    }
    /**
     * Expand / Collapse additional tags in the sidebar
     *
     * @param event
     * @private
     */

  }, {
    key: "_toggleTags",
    value: function _toggleTags(event) {
      event.preventDefault();
      var $trigger = $(event.currentTarget);
      var $items = $trigger.parent().siblings('[data-hidden-default]');
      var siblingsVisible = $trigger.data('filter-toggle');
      $items.toggleClass('filter-item--hidden', siblingsVisible);
      $trigger.data('filter-toggle', !siblingsVisible).text(!siblingsVisible ? this.context.see_less : this.context.see_more);

      if (this.modal.isOpen()) {
        this.modal.position();
      }
    }
    /**
     * Style a tag as active after click, before page transition
     *
     * @param event
     * @private
     */

  }, {
    key: "_activateTag",
    value: function _activateTag(event) {
      $(event.currentTarget).addClass('filter-link--active');
    }
    /**
     * Used by advanced tags to concatenate tag searches
     *
     * @param event
     * @private
     */

  }, {
    key: "_advancedTags",
    value: function _advancedTags(event) {
      var $target = $(event.currentTarget).parent();
      var tagGroup = $target.attr('data-group');
      var $activeGroup = $(".filter-item--active[data-group=\"".concat(tagGroup, "\"]"));

      if (!$target.hasClass('filter-item--active') && $activeGroup.length) {
        var tagHandle = $target.attr('data-handle');
        event.preventDefault();
        $target.siblings().removeClass('filter-item--active');
        location.href = location.href // swap tag
        .replace($activeGroup.attr('data-handle'), tagHandle) // go back to page 1
        .replace(/(&page=\d+)|(page=\d+&)|(\?page=\d+$)/, '');
      }
    }
    /**
     * Open Tags/Filters modal (on mobile)
     *
     * @param event
     * @private
     */

  }, {
    key: "_showFiltersModal",
    value: function _showFiltersModal(event) {
      event.preventDefault();
      this.$focusItem = $(event.currentTarget);
      this.modal.open(this.filtersContent, 'productgrid-filters');
    }
  }]);

  return StaticFilters;
}();



/***/ }),

/***/ 910:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticProduct; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var scriptjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24);
/* harmony import */ var scriptjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(scriptjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _Forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21);
/* harmony import */ var _components_RichText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47);
/* harmony import */ var _components_ProductDetails__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(167);
/* harmony import */ var _components_RelatedProducts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(168);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }









var StaticProduct = /*#__PURE__*/function () {
  function StaticProduct(section) {
    var _this = this;

    _classCallCheck(this, StaticProduct);

    this.postMessage = section.postMessage;
    this.richText = null;
    this.reviewForm = null;
    this.flickity = null;
    this.flickityOptions = null;
    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.$product = this.$el.find('[data-product-wrapper]'); // History

    this.isThemeEditor = window.Shopify && window.Shopify.designMode;
    this.useHistory = !this.isThemeEditor && history.replaceState && section.data.settings.use_history;
    this.$gallery = this.$product.find('[data-product-gallery]'); // Product form sticky handler

    this.$productDetails = this.$product.find('[data-product-main-sticky]');
    this.positionDetails = this._positionDetails.bind(this); // Product details

    this.$details = this.$product.find('[data-product-details]'); // Product info

    this.$info = this.$product.find('[data-product-info]'); // Product form containers

    this.$formRegular = this.$product.find('[data-product-form-regular]');
    this.$formAlt = this.$product.find('[data-product-form-alt]'); // Product form area

    this.$formArea = this.$product.find('[data-product-form-area]'); // Related Products

    this.$relatedProducts = this.$el.find('[data-related-products]'); // Product reviews

    this.$productReviews = this.$el.find('[data-product-reviews]');

    if (this.$info.length) {
      this.richText = new _components_RichText__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"](this.$info);
    }

    if (this.$relatedProducts.length) {
      this.relatedProducts = new _components_RelatedProducts__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"](section);
    }

    if (this.$productReviews.length) {
      this.reviewForm = new _Forms__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"](this.$productReviews, null, '.spr-form-input');
    } // Instantiate ProductDetails after Shopify API is loaded


    scriptjs__WEBPACK_IMPORTED_MODULE_1___default()(jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-scripts]').data('shopify-api-url'), function () {
      var options = {
        $formArea: _this.$formArea,
        $gallery: _this.$gallery,
        $details: _this.$details,
        $el: _this.$product,
        context: section.data.context,
        settings: section.data.settings,
        restrictions: section.data.restrictions,
        volumeEquivalencies: section.data.volume_equivalencies,
        exclusivities: section.data.exclusivity,
        variantAvailabilities: section.data.variant_availabilities,
        badges: section.data.badges,
        cdfData: section.data.cdfData,
        product: section.data.product,
        useHistory: _this.useHistory,
        caseSizes: section.data.cs
      };
      _this.productDetails = new _components_ProductDetails__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"](options);
    }); // Handle layout changes

    this.onLayoutChange = function () {
      return _this._layout();
    };

    _Layout__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].onBreakpointChange(this.onLayoutChange); // Initial positioning

    this._layout();

    this._bindEvents();
  }

  _createClass(StaticProduct, [{
    key: "_bindEvents",
    value: function _bindEvents() {
      this.$el.on('click', '[data-print-product-details]', function () {
        return window.print();
      });
    }
  }, {
    key: "onSectionUnload",
    value: function onSectionUnload() {
      _Layout__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].offBreakpointChange(this.layoutHandler);
      this.productDetails.unload();

      if (this.richText) {
        this.richText.unload();
      }

      if (this.relatedProducts) {
        this.relatedProducts.unload();
      }

      if (this.reviewForm) {
        this.reviewForm.unload();
      }
    }
  }, {
    key: "_layout",
    value: function _layout() {
      this._positionDetails();
    }
  }, {
    key: "_positionDetails",
    value: function _positionDetails() {
      var isSticky = false;

      if (_Layout__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].isBreakpoint('L')) {
        var detailsHeight = this.$productDetails.outerHeight(true);
        var infoHeight = this.$info.outerHeight(true) + this.$gallery.outerHeight(true);
        var windowHeight = document.documentElement.clientHeight; // If product form is smaller than product description and the
        // viewport window, make product form sticky

        isSticky = detailsHeight < infoHeight && detailsHeight < windowHeight;
      }

      this.$productDetails.toggleClass('product-details-sticky', isSticky);
    }
  }]);

  return StaticProduct;
}();



/***/ }),

/***/ 911:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticSearch; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_ProductList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96);
/* harmony import */ var _components_SearchForm__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }





var StaticSearch = /*#__PURE__*/function () {
  function StaticSearch(section) {
    _classCallCheck(this, StaticSearch);

    this.section = section;
    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.$searchField = this.$el.find('[data-live-search]');
    this.options = {
      sectionId: this.$el.attr('id')
    };
    this.productList = new _components_ProductList__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]('[data-product-list]', this.options);
    this.searchForm = new _components_SearchForm__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"](this.$searchField);
  }

  _createClass(StaticSearch, [{
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.searchForm.unload();
      this.productList.unload();
    }
  }]);

  return StaticSearch;
}();



/***/ }),

/***/ 912:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticPageContact; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var StaticPageContact = /*#__PURE__*/function () {
  function StaticPageContact(section) {
    _classCallCheck(this, StaticPageContact);

    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.$contactContents = this.$el.find('[data-template-contact]');
    this.$subjectDropdown = this.$el.find('[data-contact-subject-options]');

    if (this.$contactContents.length) {
      new _Forms__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](this.$contactContents);
    }

    this._bindEvents();
  }

  _createClass(StaticPageContact, [{
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;

      this.$subjectDropdown.on('change', function () {
        _this._showSubjectFields();
      });
    }
  }, {
    key: "_showSubjectFields",
    value: function _showSubjectFields() {
      var $subjectField = this.$subjectDropdown.val();
      var $orderField = this.$el.find('[data-contact-subject-order]');

      if ($subjectField === 'Order') {
        $orderField.revealer('show');
      } else {
        $orderField.revealer('hide');
      }
    }
  }]);

  return StaticPageContact;
}();



/***/ }),

/***/ 913:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticPageFaq; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Accordion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var StaticPageFaq = /*#__PURE__*/function () {
  function StaticPageFaq(section) {
    _classCallCheck(this, StaticPageFaq);

    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.$accordionToggle = this.$el.find('[data-accordion-toggle]');
    this.Accordion = new _Accordion__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](this.$el, {
      activeClass: 'active',
      content: '[data-accordion-content]'
    });
    this.events = [this.$accordionToggle.on('click.static-page-faq', this._toggleFaq.bind(this))];
  }

  _createClass(StaticPageFaq, [{
    key: "_toggleFaq",
    value: function _toggleFaq(event) {
      var $target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.currentTarget);
      var $faq = $target.closest('[data-accordion-content]');
      this.Accordion.toggle($faq);
    }
  }, {
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.events.forEach(function ($el) {
        return $el.off('.static-page-faq');
      });
    }
  }]);

  return StaticPageFaq;
}();



/***/ }),

/***/ 914:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticPageStoreLocations; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Accordion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var StaticPageStoreLocations = /*#__PURE__*/function () {
  function StaticPageStoreLocations(section) {
    _classCallCheck(this, StaticPageStoreLocations);

    this.section = section;
    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.weekdays = section.data.weekdays;
    this.store_blocks = section.data.store_blocks;
    this.$cityDropdown = this.$el.find('#store_locations_cities');
    this.$cityName = this.$el.find('[data-store-locations-city-name]');
    this.$accordionToggle = this.$el.find('[data-accordion-toggle]');
    this.$displayToday = this.$el.find('[data-store-locations-hours-block-id]');
    this.Accordion = new _Accordion__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](this.$el, {
      activeClass: 'active',
      content: '[data-accordion-content]'
    });
    this.events = [this.$accordionToggle.on('click.static-page-store-locations', this._toggleHours.bind(this)), this.$cityDropdown.on('change.static-page-store-locations', this._citySelector.bind(this))];

    this._getToday();
  }

  _createClass(StaticPageStoreLocations, [{
    key: "_citySelector",
    value: function _citySelector() {
      // Get city name from option value and scroll down to block with same city name ID
      if (this.$cityDropdown.prop('selectedIndex') !== 0) {
        window.location.hash = this.$cityDropdown.val();
        jquery__WEBPACK_IMPORTED_MODULE_0___default()('html, body').animate({
          scrollTop: jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.$cityDropdown.val()).offset().top
        }, 500);
      }
    }
  }, {
    key: "_getToday",
    value: function _getToday() {
      var _this = this;

      // Display today's day
      var nowDay = this.weekdays[new Date().getDay()]; // Loop through blocks and display hours for today's day

      jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(this.store_blocks, function (blockId, hoursObj) {
        _this.$el.find("[data-store-locations-hours-block-id=".concat(blockId, "]")).text(nowDay + ' | ' + hoursObj[nowDay.toLowerCase()]);
      });
    }
  }, {
    key: "_toggleHours",
    value: function _toggleHours(event) {
      var $target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.currentTarget);
      var $hours = $target.closest('[data-accordion-content]');
      this.Accordion.toggle($hours);
    }
  }, {
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.events.forEach(function ($el) {
        return $el.off('.static-page-store-locations');
      });
    }
  }]);

  return StaticPageStoreLocations;
}();



/***/ }),

/***/ 915:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DynamicBlogPosts; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var just_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32);
/* harmony import */ var just_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(just_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }






var DynamicBlogPosts = /*#__PURE__*/function () {
  function DynamicBlogPosts(section) {
    _classCallCheck(this, DynamicBlogPosts);

    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.$window = jquery__WEBPACK_IMPORTED_MODULE_0___default()(window);
    this.flickity = null;
    this.$blogPosts = this.$el.find('[data-blog-posts]'); // Activate flickity on mobile

    this._mobileSlider = this._mobileSlider.bind(this);
    _Layout__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].onBreakpointChange(this._mobileSlider);

    this._mobileSlider();
  }
  /**
   * Unbind events when section is re-drawn
   */


  _createClass(DynamicBlogPosts, [{
    key: "onSectionUnload",
    value: function onSectionUnload() {
      _Layout__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].offBreakpointChange(this._mobileSlider);

      this._destroyFlickity();
    }
  }, {
    key: "_initFlickity",
    value: function _initFlickity() {
      this.flickity = new flickity__WEBPACK_IMPORTED_MODULE_2___default.a(this.$blogPosts[0], {
        cellSelector: '.article--excerpt-wrapper',
        contain: true,
        freeScroll: true,
        percentPosition: false,
        prevNextButtons: false,
        pageDots: false,
        setGallerySize: false
      });

      this._bindSlider();
    }
  }, {
    key: "_destroyFlickity",
    value: function _destroyFlickity() {
      if (!this.flickity) {
        return;
      }

      this.$window.off('.blog-posts');
      this.$blogPosts.off('.blog-posts');
      this.flickity.destroy();
      this.flickity = null;
    }
  }, {
    key: "_mobileSlider",
    value: function _mobileSlider() {
      // If is Large layout, attempt to destroy flickity
      if (_Layout__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isBreakpoint('L')) {
        this._destroyFlickity();

        return;
      } // Is XS/S/M, and flickity is init'd -- do nothing


      if (this.flickity) {
        return;
      } // Is XS/S/M, and flickity is not init'd


      this._initFlickity();
    }
  }, {
    key: "_bindSlider",
    value: function _bindSlider() {
      var _this = this;

      var $slider = this.$blogPosts.find('.flickity-slider');
      this.$window.on('resize.blog-posts', just_debounce__WEBPACK_IMPORTED_MODULE_1___default()(function () {
        _this.$blogPosts.trigger('heightUpdate.blog-posts');
      }));
      this.flickity.on('cellSelect', function () {
        _this.$blogPosts.trigger('heightUpdate.blog-posts');
      });
      this.$blogPosts.on('heightUpdate.blog-posts', function () {
        if (!_this.flickity) {
          return;
        }

        $slider.height(Math.ceil(_this.flickity.maxCellHeight));
      }); // Sets the Slider to the height of the first slide

      this.$blogPosts.trigger('heightUpdate.blog-posts');
    }
  }]);

  return DynamicBlogPosts;
}();



/***/ }),

/***/ 916:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticHighlightsBanners; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var just_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32);
/* harmony import */ var just_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(just_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }






var StaticHighlightsBanners = /*#__PURE__*/function () {
  function StaticHighlightsBanners(section) {
    _classCallCheck(this, StaticHighlightsBanners);

    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.$window = jquery__WEBPACK_IMPORTED_MODULE_0___default()(window);
    this.$carousel = this.$el.find('.highlights-banners');
    this.slides = '.highlights-banners-block';
    this.flickity = null;
    this.flickityOptions = null;

    if (this.$carousel.find(this.slides).length > 1) {
      this._initSlider();
    }
  }

  _createClass(StaticHighlightsBanners, [{
    key: "_initSlider",
    value: function _initSlider() {
      this.flickityOptions = {
        autoPlay: 0,
        accessibility: true,
        cellAlign: 'left',
        cellSelector: this.slides,
        imagesLoaded: false,
        pageDots: false,
        prevNextButtons: false,
        setGallerySize: false,
        contain: true
      };

      this._bindFlickity();
    }
  }, {
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this._destroyFlickity();
    }
  }, {
    key: "_bindFlickity",
    value: function _bindFlickity() {
      var _this = this;

      if (_Layout__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isBreakpoint('L') === false && this.flickity === null) {
        this.flickity = new flickity__WEBPACK_IMPORTED_MODULE_2___default.a(this.$carousel[0], this.flickityOptions);
      }

      this.$window.on('resize', just_debounce__WEBPACK_IMPORTED_MODULE_1___default()(function () {
        if (_Layout__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isBreakpoint('L') === false && _this.flickity === null) {
          _this._bindFlickity();
        } else if (_Layout__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isBreakpoint('L') && _this.flickity) {
          _this._destroyFlickity();
        }
      }));
    }
  }, {
    key: "_destroyFlickity",
    value: function _destroyFlickity() {
      if (!this.flickity) {
        return;
      }

      this.flickity.destroy();
      this.flickity = null;
    }
  }]);

  return StaticHighlightsBanners;
}();



/***/ }),

/***/ 917:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticSlideshow; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var just_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32);
/* harmony import */ var just_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(just_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }







var StaticSlideshow = /*#__PURE__*/function () {
  function StaticSlideshow(section) {
    _classCallCheck(this, StaticSlideshow);

    this.el = section.el;
    this.settings = section.data;
    this.$window = jquery__WEBPACK_IMPORTED_MODULE_0___default()(window);
    this.carousel = this.el.querySelector('.slideshow');
    this.slides = '.slideshow-slide';
    this.container = this.el.querySelector('.slideshow-height-fullscreen');
    this.isFullscreen = !!this.container;
    this.selectBlockOnLoad = true;
    this.continueAutoplay = true;
    this.stopAutoplay = false;
    this.autoplayTimeout = 0;
    this.flickity = null;
    this.flickityOptions = null;

    if (this.carousel && this.carousel.querySelectorAll(this.slides).length > 1) {
      this._initSlider();
    }
  }

  _createClass(StaticSlideshow, [{
    key: "_initSlider",
    value: function _initSlider() {
      this.flickityOptions = {
        autoPlay: this.settings.enable_autoplay ? this.settings.autoplay_duration * 1000 : false,
        setGallerySize: !this.isFullscreen,
        pauseAutoPlayOnHover: false,
        accessibility: true,
        adaptiveHeight: true,
        cellAlign: 'left',
        cellSelector: this.slides,
        imagesLoaded: true,
        contain: true,
        wrapAround: true,
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 65,
          y2: 45,
          x3: 20
        }
      };
      this.flickity = new flickity__WEBPACK_IMPORTED_MODULE_2___default.a(this.carousel, this.flickityOptions);

      this._bindEvents();
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;

      this._slideshowHeight();

      this._positionDots();

      this._changeArrrowColors();

      this.$window.on('resize.slideshow', just_debounce__WEBPACK_IMPORTED_MODULE_1___default()(function () {
        _this._slideshowHeight();

        _this._positionDots();

        _this._changeArrrowColors();
      }));
      this.flickity.on('select', function () {
        _this._slideshowHeight();

        _this._positionDots();

        _this._changeArrrowColors();

        _this.selectBlockOnLoad = false;

        if (_this.settings.enable_autoplay && !_this.stopAutoplay) {
          _this.flickity.pausePlayer();

          if (_this.continueAutoplay) {
            _this.autoplayTimeout = 0;
          } else {
            _this.autoplayTimeout = 10000;
          }

          _this.continueAutoplay = true;
          setTimeout(function () {
            _this.flickity.playPlayer();
          }, _this.autoplayTimeout);
        }
      });
      this.flickity.on('dragStart', function () {
        _this.continueAutoplay = false;
      });
    }
  }, {
    key: "_positionDots",
    value: function _positionDots() {
      var pageDots = this.el.querySelector('.flickity-page-dots');

      if (_Layout__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isBreakpoint('XS') && !this.isFullscreen) {
        var content = this.flickity.selectedElement.querySelector('.slideshow-slide-content');
        var height = this.flickity.selectedElement.querySelector('.slideshow-background').offsetHeight;
        var dotGutter = 5;
        var top = 'auto';

        if (content) {
          top = "".concat(height + dotGutter, "px");
        } else {
          var pageDotsHeight = pageDots.offsetHeight;
          var dotBottomGutter = 20; // If no content, and mobile, offset by height of dots, and the bottom gutter

          top = "".concat(height - (pageDotsHeight + dotBottomGutter), "px");
        }

        pageDots.style.top = top;
      }
    }
  }, {
    key: "_changeArrrowColors",
    value: function _changeArrrowColors() {
      var currentColor = this.flickity.selectedElement.querySelector('.slideshow-background').dataset;
      var dots = this.el.querySelectorAll('.flickity-page-dots .dot');

      if (_Layout__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].isBreakpoint('XS') && !this.isFullscreen) {
        currentColor = currentColor.themecolor;
      } else {
        currentColor = currentColor.slidecolor;
      }

      this.el.querySelector('.flickity-prev-next-button.previous svg').style.fill = currentColor;
      this.el.querySelector('.flickity-prev-next-button.next svg').style.fill = currentColor;

      for (var i = 0; i < dots.length; i++) {
        dots[i].style.background = currentColor;
      }
    }
  }, {
    key: "_slideshowHeight",
    value: function _slideshowHeight() {
      var headerHeight = Object(_helpers__WEBPACK_IMPORTED_MODULE_4__[/* getHeaderOffset */ "o"])(document.querySelector('.site-header-wrapper'));

      if (this.isFullscreen) {
        this.el.querySelector('.flickity-viewport').style.height = "calc(100vh - ".concat(headerHeight, "px)");
        this.container.style.height = "calc(100vh - ".concat(headerHeight, "px)");
      }
    }
  }, {
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this._destroyFlickity();

      this.$window.off('.slideshow');
    }
  }, {
    key: "_destroyFlickity",
    value: function _destroyFlickity() {
      if (!this.flickity) {
        return;
      }

      this.flickity.destroy();
    }
  }, {
    key: "onSectionBlockSelect",
    value: function onSectionBlockSelect(block) {
      var _this2 = this;

      setTimeout(function () {
        _this2.flickity.resize();
      }, 100);

      if (this.settings.enable_autoplay) {
        var $slides = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.slides);
        var $slide = jquery__WEBPACK_IMPORTED_MODULE_0___default()(block.el);
        var slideIndex = $slides.index($slide);
        this.stopAutoplay = true;
        this.flickity.pausePlayer();

        if (!$slide.hasClass('is-selected') && !this.selectBlockOnLoad) {
          this.flickity.select(slideIndex, false, false);
        } else if (this.selectBlockOnLoad) {
          this.flickity.select(slideIndex, false, true);
        }
      }
    }
  }, {
    key: "onSectionBlockDeselect",
    value: function onSectionBlockDeselect() {
      if (this.settings.enable_autoplay) {
        this.stopAutoplay = false;
        this.flickity.playPlayer();
      }
    }
  }]);

  return StaticSlideshow;
}();



/***/ }),

/***/ 918:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DynamicPromoBlocks; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var DynamicPromoBlocks = /*#__PURE__*/function () {
  function DynamicPromoBlocks(section) {
    _classCallCheck(this, DynamicPromoBlocks);

    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.content = '[data-promo-block-content]';
    this.expandedClass = 'promo-block--expanded';
    this.compressBlocks = section.data.compress_blocks; // Revert navigation to original state on breakpoint change

    this.layoutHandler = this.onBreakpointChange.bind(this);
    _Layout__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].onBreakpointChange(this.layoutHandler);
    this._blockInteraction = this._blockInteraction.bind(this);
    this.$el.on('click.promo-block', this.content, this._blockInteraction);
  }
  /**
   * Remove block's toggled state and attributes when leaving mobile
   */


  _createClass(DynamicPromoBlocks, [{
    key: "onBreakpointChange",
    value: function onBreakpointChange() {
      var _this = this;

      if (!_Layout__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].isBreakpoint('XS')) {
        this.$el.find(".".concat(this.expandedClass)).each(function (i, content) {
          _this._collapse(content);
        });
      }
    }
    /**
     * Unbind events when section is re-drawn
     */

  }, {
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.$el.off('.promo-block');
      _Layout__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].offBreakpointChange(this.layoutHandler);
    }
    /**
     * Callback to open block on mobile from the TE
     *
     * @param block
     */

  }, {
    key: "onSectionBlockSelect",
    value: function onSectionBlockSelect(block) {
      if (!_Layout__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].isBreakpoint('XS')) {
        return;
      }

      this._expand(block.el.querySelector(this.content));
    }
    /**
     * Callback to close block on mobile from the TE
     *
     * @param block
     */

  }, {
    key: "onSectionBlockDeselect",
    value: function onSectionBlockDeselect(block) {
      if (!_Layout__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].isBreakpoint('XS')) {
        return;
      }

      this._collapse(block.el.querySelector(this.content));
    }
    /**
     * Expand a block on first click, then allow it to behave as normal
     *
     * @param event
     * @private
     */

  }, {
    key: "_blockInteraction",
    value: function _blockInteraction(event) {
      var content = event.currentTarget;
      var clicked = content.getAttribute('data-clicked'); // On second click, or on desktop, don't interfere with block

      if (clicked || !_Layout__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].isBreakpoint('XS') || !this.compressBlocks) {
        return;
      }

      event.preventDefault();
      content.setAttribute('data-clicked', 'clicked');

      this._expand(content);
    }
    /**
     * Expand promo block
     *
     * @param content
     * @private
     */

  }, {
    key: "_expand",
    value: function _expand(content) {
      var _this2 = this;

      if (!this.compressBlocks) {
        return;
      }

      var $content = jquery__WEBPACK_IMPORTED_MODULE_0___default()(content);
      $content.addClass('animating animating-in').one('trend', function () {
        $content.removeClass('animating animating-in').addClass(_this2.expandedClass).off('trend');
      });
    }
    /**
     * Collapse a block
     *
     * @param content
     * @private
     */

  }, {
    key: "_collapse",
    value: function _collapse(content) {
      var _this3 = this;

      if (!this.compressBlocks) {
        return;
      }

      var $content = jquery__WEBPACK_IMPORTED_MODULE_0___default()(content);
      $content.addClass('animating animating-out').one('trend', function () {
        $content.removeClass("animating animating-out ".concat(_this3.expandedClass)).off('trend');
        content.removeAttribute('data-clicked');
      });
    }
  }]);

  return DynamicPromoBlocks;
}();



/***/ }),

/***/ 919:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DynamicMenuList; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Accordion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }





var DynamicMenuList = /*#__PURE__*/function () {
  function DynamicMenuList(section) {
    _classCallCheck(this, DynamicMenuList);

    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.context = section.data.context;
    this.Accordion = new _Accordion__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](this.$el); // Handle Accordion interaction when window size changes

    this.layoutHandler = this.onBreakpointChange.bind(this);
    _Layout__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].onBreakpointChange(this.layoutHandler);

    this._bindEvents();
  }

  _createClass(DynamicMenuList, [{
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;

      this.$el.on('click.menu-list', '[data-accordion-trigger]', function (event) {
        event.preventDefault();

        _this._toggleAccordion(jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.currentTarget).parent());
      });
      this.$el.on('click.menu-list', '[data-menulist-toggle]', function (event) {
        event.preventDefault();

        _this._toggleList(event.currentTarget);
      });
    }
  }, {
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.$el.off('.menu-list');
      delete this.Accordion;
    }
  }, {
    key: "onSectionBlockSelect",
    value: function onSectionBlockSelect(block) {
      this._toggleAccordion(jquery__WEBPACK_IMPORTED_MODULE_0___default()(block.el), true);
    }
  }, {
    key: "onSectionBlockDeselect",
    value: function onSectionBlockDeselect(block) {
      this._toggleAccordion(jquery__WEBPACK_IMPORTED_MODULE_0___default()(block.el), false);
    }
  }, {
    key: "_toggleAccordion",
    value: function _toggleAccordion($block) {
      if (_Layout__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].isBreakpoint('L')) {
        return;
      }

      this.Accordion.toggle($block);
    }
  }, {
    key: "_toggleList",
    value: function _toggleList(el) {
      var $trigger = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el);
      var $items = $trigger.parent().siblings('[data-hidden-default]');
      var siblingsVisible = $trigger.data('menulist-toggle');
      $items.toggleClass('menulist--menu-item-hidden', siblingsVisible);
      $trigger.data('menulist-toggle', !siblingsVisible).text(!siblingsVisible ? this.context.see_less : this.context.see_more);
    }
  }, {
    key: "onBreakpointChange",
    value: function onBreakpointChange(event, breakpoints) {
      if (_Layout__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].isBreakpoint('L')) {
        this.Accordion.openAll();
      } else if (breakpoints.previous === 'L' && !_Layout__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].isBreakpoint('L')) {
        this.Accordion.closeOpen();
      }
    }
  }]);

  return DynamicMenuList;
}();



/***/ }),

/***/ 920:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DynamicFeaturedCollection; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_ProductListItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48);
/* harmony import */ var _components_ProductRowScroller__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(165);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }





var DynamicFeaturedCollection = /*#__PURE__*/function () {
  function DynamicFeaturedCollection(section) {
    var _this = this;

    _classCallCheck(this, DynamicFeaturedCollection);

    this.section = section;
    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.sectionId = this.$el.attr('id'); // Product items

    this.productItems = [];
    var $productItems = this.$el.find('[data-product-item]');
    $productItems.each(function (i, productItem) {
      _this.productItems.push(new _components_ProductListItem__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](jquery__WEBPACK_IMPORTED_MODULE_0___default()(productItem), _this.sectionId));
    });
    this.ProductRowScroller = new _components_ProductRowScroller__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"](section.el.querySelector('[data-product-row]'));
  }

  _createClass(DynamicFeaturedCollection, [{
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.productItems.forEach(function (productItem) {
        productItem.unload();
      });
      this.ProductRowScroller.unload();
    }
  }]);

  return DynamicFeaturedCollection;
}();



/***/ }),

/***/ 921:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StaticSectionHeader; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var scriptjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24);
/* harmony import */ var scriptjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(scriptjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
/* harmony import */ var _components_InlineSearch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97);
/* harmony import */ var _components_SearchForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }







var StaticSectionHeader = /*#__PURE__*/function () {
  function StaticSectionHeader(section) {
    var _this = this;

    _classCallCheck(this, StaticSectionHeader);

    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.settings = section.data.settings;
    this.headerSearch = null;
    this.$scripts = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-scripts]');
    this.$searchField = this.$el.find('[data-live-search]');
    this.forms = new _Forms__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"](this.$el);

    if (this.settings.live_search.enable) {
      scriptjs__WEBPACK_IMPORTED_MODULE_1___default()(this.$scripts.data('shopify-api-url'), function () {
        _this.headerSearch = new _components_InlineSearch__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]({
          $el: _this.$searchField,
          $header: _this.$el
        }, _this.settings.live_search);
      });
    } else {
      this.headerSearch = new _components_SearchForm__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"](this.$searchField);
    }
  }

  _createClass(StaticSectionHeader, [{
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.headerSearch.unload();
      this.forms.unload();
    }
  }]);

  return StaticSectionHeader;
}();



/***/ }),

/***/ 922:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DynamicRichText; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_RichText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var DynamicRichText = /*#__PURE__*/function () {
  function DynamicRichText(section) {
    var _this = this;

    _classCallCheck(this, DynamicRichText);

    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.rte = [];
    this.$el.find('[data-rte]').each(function (i, el) {
      _this.rte.push(new _components_RichText__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](jquery__WEBPACK_IMPORTED_MODULE_0___default()(el)));
    });
  }
  /**
   * Unbind events when section is re-drawn
   */


  _createClass(DynamicRichText, [{
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.rte.forEach(function (richTextArea) {
        richTextArea.unload();
      });
    }
  }]);

  return DynamicRichText;
}();



/***/ }),

/***/ 923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DynamicNewsletter; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var DynamicNewsletter = /*#__PURE__*/function () {
  function DynamicNewsletter(section) {
    _classCallCheck(this, DynamicNewsletter);

    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(section.el);
    this.forms = new _Forms__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](this.$el);
  }

  _createClass(DynamicNewsletter, [{
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.forms.unload();
    }
  }]);

  return DynamicNewsletter;
}();



/***/ }),

/***/ 927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Page; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_RichText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Page = function Page() {
  _classCallCheck(this, Page);

  this.$pageContent = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-template-page]');

  if (this.$pageContent.length) {
    new _components_RichText__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](this.$pageContent);
  }
};



/***/ }),

/***/ 928:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Contact; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Contact = function Contact() {
  _classCallCheck(this, Contact);

  this.$contactContents = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-template-contact]');

  if (this.$contactContents.length) {
    new _Forms__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](this.$contactContents);
  }
};



/***/ }),

/***/ 929:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(396);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(397);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.async-iterator.js
var es_symbol_async_iterator = __webpack_require__(398);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.has-instance.js
var es_symbol_has_instance = __webpack_require__(399);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.is-concat-spreadable.js
var es_symbol_is_concat_spreadable = __webpack_require__(400);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(401);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.match.js
var es_symbol_match = __webpack_require__(402);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.replace.js
var es_symbol_replace = __webpack_require__(403);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.search.js
var es_symbol_search = __webpack_require__(404);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.species.js
var es_symbol_species = __webpack_require__(405);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.split.js
var es_symbol_split = __webpack_require__(406);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(407);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-string-tag.js
var es_symbol_to_string_tag = __webpack_require__(408);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.unscopables.js
var es_symbol_unscopables = __webpack_require__(409);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(410);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.copy-within.js
var es_array_copy_within = __webpack_require__(411);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__(412);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__(413);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(414);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(415);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__(416);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat.js
var es_array_flat = __webpack_require__(417);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat-map.js
var es_array_flat_map = __webpack_require__(418);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(419);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(420);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(422);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(423);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(131);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(424);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.last-index-of.js
var es_array_last_index_of = __webpack_require__(425);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(426);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.of.js
var es_array_of = __webpack_require__(427);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__(428);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce-right.js
var es_array_reduce_right = __webpack_require__(429);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(430);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__(431);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.species.js
var es_array_species = __webpack_require__(432);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__(433);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat.js
var es_array_unscopables_flat = __webpack_require__(434);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat-map.js
var es_array_unscopables_flat_map = __webpack_require__(435);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array-buffer.constructor.js
var es_array_buffer_constructor = __webpack_require__(436);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(438);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.has-instance.js
var es_function_has_instance = __webpack_require__(440);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(441);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.to-string-tag.js
var es_json_to_string_tag = __webpack_require__(442);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(182);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.acosh.js
var es_math_acosh = __webpack_require__(443);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.asinh.js
var es_math_asinh = __webpack_require__(444);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.atanh.js
var es_math_atanh = __webpack_require__(445);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.cbrt.js
var es_math_cbrt = __webpack_require__(446);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.clz32.js
var es_math_clz32 = __webpack_require__(447);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.cosh.js
var es_math_cosh = __webpack_require__(448);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.expm1.js
var es_math_expm1 = __webpack_require__(449);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.fround.js
var es_math_fround = __webpack_require__(450);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.hypot.js
var es_math_hypot = __webpack_require__(451);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.imul.js
var es_math_imul = __webpack_require__(452);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.log10.js
var es_math_log10 = __webpack_require__(453);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.log1p.js
var es_math_log1p = __webpack_require__(454);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.log2.js
var es_math_log2 = __webpack_require__(455);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.sign.js
var es_math_sign = __webpack_require__(456);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.sinh.js
var es_math_sinh = __webpack_require__(457);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.tanh.js
var es_math_tanh = __webpack_require__(458);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.to-string-tag.js
var es_math_to_string_tag = __webpack_require__(459);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.trunc.js
var es_math_trunc = __webpack_require__(460);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(461);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.epsilon.js
var es_number_epsilon = __webpack_require__(462);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-finite.js
var es_number_is_finite = __webpack_require__(463);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-integer.js
var es_number_is_integer = __webpack_require__(464);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-nan.js
var es_number_is_nan = __webpack_require__(465);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-safe-integer.js
var es_number_is_safe_integer = __webpack_require__(466);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.max-safe-integer.js
var es_number_max_safe_integer = __webpack_require__(467);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.min-safe-integer.js
var es_number_min_safe_integer = __webpack_require__(468);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.parse-float.js
var es_number_parse_float = __webpack_require__(469);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.parse-int.js
var es_number_parse_int = __webpack_require__(471);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.to-fixed.js
var es_number_to_fixed = __webpack_require__(472);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(474);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-getter.js
var es_object_define_getter = __webpack_require__(475);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-setter.js
var es_object_define_setter = __webpack_require__(476);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__(477);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.freeze.js
var es_object_freeze = __webpack_require__(478);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.from-entries.js
var es_object_from_entries = __webpack_require__(479);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(480);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(481);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-names.js
var es_object_get_own_property_names = __webpack_require__(482);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(483);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.is.js
var es_object_is = __webpack_require__(484);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.is-extensible.js
var es_object_is_extensible = __webpack_require__(485);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.is-frozen.js
var es_object_is_frozen = __webpack_require__(486);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.is-sealed.js
var es_object_is_sealed = __webpack_require__(487);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(488);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.lookup-getter.js
var es_object_lookup_getter = __webpack_require__(489);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.lookup-setter.js
var es_object_lookup_setter = __webpack_require__(490);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.prevent-extensions.js
var es_object_prevent_extensions = __webpack_require__(491);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.seal.js
var es_object_seal = __webpack_require__(492);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(493);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__(495);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(496);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.finally.js
var es_promise_finally = __webpack_require__(498);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.apply.js
var es_reflect_apply = __webpack_require__(499);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(500);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.define-property.js
var es_reflect_define_property = __webpack_require__(502);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.delete-property.js
var es_reflect_delete_property = __webpack_require__(503);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.get.js
var es_reflect_get = __webpack_require__(504);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.get-own-property-descriptor.js
var es_reflect_get_own_property_descriptor = __webpack_require__(505);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.get-prototype-of.js
var es_reflect_get_prototype_of = __webpack_require__(506);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.has.js
var es_reflect_has = __webpack_require__(507);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.is-extensible.js
var es_reflect_is_extensible = __webpack_require__(508);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.own-keys.js
var es_reflect_own_keys = __webpack_require__(509);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.prevent-extensions.js
var es_reflect_prevent_extensions = __webpack_require__(510);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.set.js
var es_reflect_set = __webpack_require__(511);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.set-prototype-of.js
var es_reflect_set_prototype_of = __webpack_require__(512);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(513);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(275);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.flags.js
var es_regexp_flags = __webpack_require__(514);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(515);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(276);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.code-point-at.js
var es_string_code_point_at = __webpack_require__(516);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.ends-with.js
var es_string_ends_with = __webpack_require__(517);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.from-code-point.js
var es_string_from_code_point = __webpack_require__(518);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(519);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(277);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(520);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.pad-end.js
var es_string_pad_end = __webpack_require__(521);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.pad-start.js
var es_string_pad_start = __webpack_require__(522);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.raw.js
var es_string_raw = __webpack_require__(523);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.repeat.js
var es_string_repeat = __webpack_require__(524);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(525);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__(526);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(527);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__(528);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(529);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim-end.js
var es_string_trim_end = __webpack_require__(530);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim-start.js
var es_string_trim_start = __webpack_require__(531);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.anchor.js
var es_string_anchor = __webpack_require__(532);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.big.js
var es_string_big = __webpack_require__(533);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.blink.js
var es_string_blink = __webpack_require__(534);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.bold.js
var es_string_bold = __webpack_require__(535);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.fixed.js
var es_string_fixed = __webpack_require__(536);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.fontcolor.js
var es_string_fontcolor = __webpack_require__(537);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.fontsize.js
var es_string_fontsize = __webpack_require__(538);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.italics.js
var es_string_italics = __webpack_require__(539);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__(540);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__(541);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.strike.js
var es_string_strike = __webpack_require__(542);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.sub.js
var es_string_sub = __webpack_require__(543);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.sup.js
var es_string_sup = __webpack_require__(544);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.float32-array.js
var es_typed_array_float32_array = __webpack_require__(545);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.float64-array.js
var es_typed_array_float64_array = __webpack_require__(547);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.int8-array.js
var es_typed_array_int8_array = __webpack_require__(548);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.int16-array.js
var es_typed_array_int16_array = __webpack_require__(549);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.int32-array.js
var es_typed_array_int32_array = __webpack_require__(550);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint8-array.js
var es_typed_array_uint8_array = __webpack_require__(551);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint8-clamped-array.js
var es_typed_array_uint8_clamped_array = __webpack_require__(552);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint16-array.js
var es_typed_array_uint16_array = __webpack_require__(553);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint32-array.js
var es_typed_array_uint32_array = __webpack_require__(554);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.copy-within.js
var es_typed_array_copy_within = __webpack_require__(555);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.every.js
var es_typed_array_every = __webpack_require__(556);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.fill.js
var es_typed_array_fill = __webpack_require__(557);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.filter.js
var es_typed_array_filter = __webpack_require__(558);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find.js
var es_typed_array_find = __webpack_require__(559);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find-index.js
var es_typed_array_find_index = __webpack_require__(560);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.for-each.js
var es_typed_array_for_each = __webpack_require__(561);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.from.js
var es_typed_array_from = __webpack_require__(562);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.includes.js
var es_typed_array_includes = __webpack_require__(563);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.index-of.js
var es_typed_array_index_of = __webpack_require__(564);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.iterator.js
var es_typed_array_iterator = __webpack_require__(565);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.join.js
var es_typed_array_join = __webpack_require__(566);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.last-index-of.js
var es_typed_array_last_index_of = __webpack_require__(567);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.map.js
var es_typed_array_map = __webpack_require__(568);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.of.js
var es_typed_array_of = __webpack_require__(569);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce.js
var es_typed_array_reduce = __webpack_require__(570);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce-right.js
var es_typed_array_reduce_right = __webpack_require__(571);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reverse.js
var es_typed_array_reverse = __webpack_require__(572);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__(573);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.slice.js
var es_typed_array_slice = __webpack_require__(574);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.some.js
var es_typed_array_some = __webpack_require__(575);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.sort.js
var es_typed_array_sort = __webpack_require__(576);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.subarray.js
var es_typed_array_subarray = __webpack_require__(577);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-locale-string.js
var es_typed_array_to_locale_string = __webpack_require__(578);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-string.js
var es_typed_array_to_string = __webpack_require__(579);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.weak-map.js
var es_weak_map = __webpack_require__(191);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.weak-set.js
var es_weak_set = __webpack_require__(580);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.aggregate-error.js
var esnext_aggregate_error = __webpack_require__(581);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.array.last-index.js
var esnext_array_last_index = __webpack_require__(583);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.array.last-item.js
var esnext_array_last_item = __webpack_require__(584);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.composite-key.js
var esnext_composite_key = __webpack_require__(585);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.composite-symbol.js
var esnext_composite_symbol = __webpack_require__(586);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.global-this.js
var esnext_global_this = __webpack_require__(587);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.delete-all.js
var esnext_map_delete_all = __webpack_require__(589);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.every.js
var esnext_map_every = __webpack_require__(590);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.filter.js
var esnext_map_filter = __webpack_require__(591);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.find.js
var esnext_map_find = __webpack_require__(592);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.find-key.js
var esnext_map_find_key = __webpack_require__(593);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.from.js
var esnext_map_from = __webpack_require__(594);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.group-by.js
var esnext_map_group_by = __webpack_require__(595);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.includes.js
var esnext_map_includes = __webpack_require__(596);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.key-by.js
var esnext_map_key_by = __webpack_require__(598);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.key-of.js
var esnext_map_key_of = __webpack_require__(599);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.map-keys.js
var esnext_map_map_keys = __webpack_require__(600);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.map-values.js
var esnext_map_map_values = __webpack_require__(601);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.merge.js
var esnext_map_merge = __webpack_require__(602);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.of.js
var esnext_map_of = __webpack_require__(603);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.reduce.js
var esnext_map_reduce = __webpack_require__(604);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.some.js
var esnext_map_some = __webpack_require__(605);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.map.update.js
var esnext_map_update = __webpack_require__(606);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.math.clamp.js
var esnext_math_clamp = __webpack_require__(607);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.math.deg-per-rad.js
var esnext_math_deg_per_rad = __webpack_require__(608);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.math.degrees.js
var esnext_math_degrees = __webpack_require__(609);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.math.fscale.js
var esnext_math_fscale = __webpack_require__(610);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.math.iaddh.js
var esnext_math_iaddh = __webpack_require__(611);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.math.imulh.js
var esnext_math_imulh = __webpack_require__(612);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.math.isubh.js
var esnext_math_isubh = __webpack_require__(613);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.math.rad-per-deg.js
var esnext_math_rad_per_deg = __webpack_require__(614);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.math.radians.js
var esnext_math_radians = __webpack_require__(615);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.math.scale.js
var esnext_math_scale = __webpack_require__(616);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.math.seeded-prng.js
var esnext_math_seeded_prng = __webpack_require__(617);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.math.signbit.js
var esnext_math_signbit = __webpack_require__(618);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.math.umulh.js
var esnext_math_umulh = __webpack_require__(619);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.number.from-string.js
var esnext_number_from_string = __webpack_require__(620);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.observable.js
var esnext_observable = __webpack_require__(621);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.promise.all-settled.js
var esnext_promise_all_settled = __webpack_require__(622);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.promise.any.js
var esnext_promise_any = __webpack_require__(624);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.promise.try.js
var esnext_promise_try = __webpack_require__(626);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.reflect.define-metadata.js
var esnext_reflect_define_metadata = __webpack_require__(627);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.reflect.delete-metadata.js
var esnext_reflect_delete_metadata = __webpack_require__(628);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.reflect.get-metadata.js
var esnext_reflect_get_metadata = __webpack_require__(629);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.reflect.get-metadata-keys.js
var esnext_reflect_get_metadata_keys = __webpack_require__(630);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.reflect.get-own-metadata.js
var esnext_reflect_get_own_metadata = __webpack_require__(631);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.reflect.get-own-metadata-keys.js
var esnext_reflect_get_own_metadata_keys = __webpack_require__(632);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.reflect.has-metadata.js
var esnext_reflect_has_metadata = __webpack_require__(633);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.reflect.has-own-metadata.js
var esnext_reflect_has_own_metadata = __webpack_require__(634);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.reflect.metadata.js
var esnext_reflect_metadata = __webpack_require__(635);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.add-all.js
var esnext_set_add_all = __webpack_require__(636);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.delete-all.js
var esnext_set_delete_all = __webpack_require__(637);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.difference.js
var esnext_set_difference = __webpack_require__(638);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.every.js
var esnext_set_every = __webpack_require__(639);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.filter.js
var esnext_set_filter = __webpack_require__(640);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.find.js
var esnext_set_find = __webpack_require__(641);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.from.js
var esnext_set_from = __webpack_require__(642);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.intersection.js
var esnext_set_intersection = __webpack_require__(643);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.is-disjoint-from.js
var esnext_set_is_disjoint_from = __webpack_require__(644);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.is-subset-of.js
var esnext_set_is_subset_of = __webpack_require__(645);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.is-superset-of.js
var esnext_set_is_superset_of = __webpack_require__(646);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.join.js
var esnext_set_join = __webpack_require__(647);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.map.js
var esnext_set_map = __webpack_require__(648);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.of.js
var esnext_set_of = __webpack_require__(649);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.reduce.js
var esnext_set_reduce = __webpack_require__(650);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.some.js
var esnext_set_some = __webpack_require__(651);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.symmetric-difference.js
var esnext_set_symmetric_difference = __webpack_require__(652);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.set.union.js
var esnext_set_union = __webpack_require__(653);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.string.at.js
var esnext_string_at = __webpack_require__(654);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.string.code-points.js
var esnext_string_code_points = __webpack_require__(655);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.string.match-all.js
var esnext_string_match_all = __webpack_require__(656);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.string.replace-all.js
var esnext_string_replace_all = __webpack_require__(658);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.symbol.dispose.js
var esnext_symbol_dispose = __webpack_require__(660);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.symbol.observable.js
var esnext_symbol_observable = __webpack_require__(661);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.symbol.pattern-match.js
var esnext_symbol_pattern_match = __webpack_require__(662);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.weak-map.delete-all.js
var esnext_weak_map_delete_all = __webpack_require__(663);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.weak-map.from.js
var esnext_weak_map_from = __webpack_require__(664);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.weak-map.of.js
var esnext_weak_map_of = __webpack_require__(665);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.weak-set.add-all.js
var esnext_weak_set_add_all = __webpack_require__(666);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.weak-set.delete-all.js
var esnext_weak_set_delete_all = __webpack_require__(667);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.weak-set.from.js
var esnext_weak_set_from = __webpack_require__(668);

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.weak-set.of.js
var esnext_weak_set_of = __webpack_require__(669);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(670);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(671);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.immediate.js
var web_immediate = __webpack_require__(672);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.queue-microtask.js
var web_queue_microtask = __webpack_require__(673);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__(674);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.to-json.js
var web_url_to_json = __webpack_require__(676);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__(289);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(0);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./source/scripts/globals/jquery.js
// jQuery plugins expect to find a global `jQuery` object, so we
// need to attach it to the window.
//
// This is in its own file because we have to attach it before any
// other imports happen, but with ES6 modules, all `import`s have
// to be at the top.

window.jQuery = jquery_default.a;
window.$ = jquery_default.a;
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(677);

// EXTERNAL MODULE: ./node_modules/scriptjs/dist/script.js
var script = __webpack_require__(24);

// EXTERNAL MODULE: ./node_modules/@pixelunion/jquery-trend/jquery.trend.js
var jquery_trend = __webpack_require__(678);

// EXTERNAL MODULE: ./node_modules/@pixelunion/jquery-revealer/jquery.revealer.js
var jquery_revealer = __webpack_require__(679);

// EXTERNAL MODULE: ./node_modules/@pixelunion/rimg-shopify/dist/index.es.js
var index_es = __webpack_require__(161);

// EXTERNAL MODULE: ./node_modules/flickity/js/index.js
var js = __webpack_require__(44);
var js_default = /*#__PURE__*/__webpack_require__.n(js);

// CONCATENATED MODULE: ./source/scripts/globals/flickity-ios-fix.js

 // This is required to fix an iOS10 bug for Flickity.
// It is our own implementation of the Flickity 2.0 fix found here: http://bit.ly/2kU4mKW

jquery_default()(window).on('dragStart', function (event) {
  var $target = jquery_default()(event.target);
  var $flickityEnabledEl = $target.closest('.flickity-enabled');

  if ($flickityEnabledEl.length) {
    var flickity = js_default.a.data($flickityEnabledEl[0]);
    window.removeEventListener('scroll', flickity);
  }
});
// EXTERNAL MODULE: ./source/scripts/licence/CustomerLicence.js
var CustomerLicence = __webpack_require__(125);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInHours/index.js + 3 modules
var differenceInHours = __webpack_require__(395);

// EXTERNAL MODULE: ./source/scripts/helpers/index.js + 24 modules
var helpers = __webpack_require__(2);

// CONCATENATED MODULE: ./source/scripts/components/CustomerSessionTimer.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



/*
  Generate timestamp string to be set in local storage.
    @param {boolean} pristine Will append flag on to generated timestamp.
    @return {string} Unix epoch timestamp with or without appended flag.
*/

var CustomerSessionTimer_generateTimestamp = function generateTimestamp() {
  var setPristine = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return "".concat(Date.now()).concat(setPristine ? helpers["w" /* sessionTimer */].pristineFlag : '');
};
/*
  Logout a session and will attempt to get URL from header account nav, and if
  not will use the default Shopify endpoint as fallback.
*/

var logoutBrowser = function logoutBrowser() {
  var logoutURL = document.querySelector('[data-account-logout]').getAttribute('href');
  window.location = logoutURL ? logoutURL : '/account/logout';
};

var CustomerSessionTimer_CustomerSessionTimer = /*#__PURE__*/function () {
  function CustomerSessionTimer() {
    _classCallCheck(this, CustomerSessionTimer);

    if (!!CustomerSessionTimer.instance) {
      return CustomerSessionTimer.instance;
    }

    CustomerSessionTimer.instance = this;
    this.customer = {
      loggedIn: document.body.classList.contains('customer--logged-in'),
      sanitizedTimestamp: 0,
      // Note: required default
      timestamp: Object(helpers["p" /* getLS */])(helpers["w" /* sessionTimer */].key)
    };
    return this._initialize();
  }

  _createClass(CustomerSessionTimer, [{
    key: "_initialize",
    value: function _initialize() {
      return this.customer.timestamp != null ? this._checkIfPreviousSession() : this._setPristineTimestamp();
    }
    /*
      Determines if the customer has logged in and the timestamp value contains a
      pristine flag.
       @return {function} If customer and depending on the presence of a pristine
        flag either set a new timestamp, or process the value.
    */

  }, {
    key: "_checkIfPreviousSession",
    value: function _checkIfPreviousSession() {
      if (!this.customer.loggedIn) {
        this._setPristineTimestamp();
      } else {
        var timestamp = this.customer.timestamp;
        var flag = helpers["w" /* sessionTimer */].pristineFlag;
        var hasPristineFlag = timestamp.includes(flag);
        return hasPristineFlag ? this._setCustomerTimestamp() : this._processReturningCustomer();
      }
    }
    /*
      Process a customers timestamp when they revisit the site. The timestamp will
      contain a pristine flag, which will be stripped and the timestamp value will
      be compared to "now".
       @return {bool} Either return true and do nothing, or destroy the session as
      session length has expired
     */

  }, {
    key: "_processReturningCustomer",
    value: function _processReturningCustomer() {
      this.customer.sanitizedTimestamp = this._sanitizeTimestamp(this.customer.timestamp, helpers["w" /* sessionTimer */].pristineFlag);

      this._updateSessionTimestamp(this.customer.sanitizedTimestamp);

      var isSessionValid = this._isSessionValid(this.customer.sanitizedTimestamp); // NOTE: Choose users path based off session length.


      if (!isSessionValid) {
        this._destroySession();
      }
    }
    /*
      Update the timestamp value.
        @param {string|integer} timestamp Updated timestamp value.
    */

  }, {
    key: "_updateSessionTimestamp",
    value: function _updateSessionTimestamp(timestamp) {
      Object(helpers["x" /* setLS */])(helpers["w" /* sessionTimer */].key, timestamp);
    }
    /*
      Remove the timestamp and then logout the user.
        @return {} Browser redirect to logout endpoint.
    */

  }, {
    key: "_destroySession",
    value: function _destroySession() {
      Object(helpers["i" /* deleteLS */])(helpers["w" /* sessionTimer */].key);
      logoutBrowser();
    }
    /*
      Removes the pristine flag and converts to a number, returns a string.
        @param {string} rawTimestamp Generated timestamp to check.
        @return {boolean} Turns true if session valid.
    */

  }, {
    key: "_sanitizeTimestamp",
    value: function _sanitizeTimestamp() {
      var rawTimestamp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var pristineFlag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var removeFlag = rawTimestamp.replace(pristineFlag, '');
      return parseInt(removeFlag, 0);
    }
    /*
      Check the session length:
        @param {date} dateToCheck Expects valid Date object.
        @return {boolean} Turns true if session valid.
    */

  }, {
    key: "_isSessionValid",
    value: function _isSessionValid() {
      var dateToCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var sessionDuration = 24; // NOTE: Set customer duration length in hours

      var sessionLength = Object(differenceInHours["a" /* default */])(Date.now(), dateToCheck);
      this.differenceInSeconds = sessionLength;
      return sessionLength <= sessionDuration;
    }
    /*
      Set pristine/guest timestamp to local storage.
        @return {} Updates browser local storage value.
    */

  }, {
    key: "_setPristineTimestamp",
    value: function _setPristineTimestamp() {
      Object(helpers["x" /* setLS */])(helpers["w" /* sessionTimer */].key, CustomerSessionTimer_generateTimestamp(true));
    }
    /*
      Set customer timestamp to local storage.
        @return {} Updates browser local storage value.
    */

  }, {
    key: "_setCustomerTimestamp",
    value: function _setCustomerTimestamp() {
      Object(helpers["x" /* setLS */])(helpers["w" /* sessionTimer */].key, CustomerSessionTimer_generateTimestamp(false));
    }
  }]);

  return CustomerSessionTimer;
}();


// EXTERNAL MODULE: ./source/scripts/licence/LicenceSwitcherModal.js
var LicenceSwitcherModal = __webpack_require__(70);

// CONCATENATED MODULE: ./source/scripts/components/Messaging.js
function Messaging_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Messaging_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Messaging_createClass(Constructor, protoProps, staticProps) { if (protoProps) Messaging_defineProperties(Constructor.prototype, protoProps); if (staticProps) Messaging_defineProperties(Constructor, staticProps); return Constructor; }




var Messaging_Messaging = /*#__PURE__*/function () {
  function Messaging() {
    Messaging_classCallCheck(this, Messaging);

    // NOTE: This file controls the toast messages
    this.$body = jquery_default()(document.body);
    this.$el = this.$body.find('[data-messaging]');
    this.$message = this.$el.find('[data-messaging-content]');
    this.timeout = null;
    this.eventHandler = new helpers["d" /* EventHandler */]();
    this.events = [this.eventHandler.on('pushMessage', this._showMessage.bind(this)), this.$el.on('click.messaging', '[data-messaging-dismiss]', this._hideMessage.bind(this)), this.$el.on('mouseenter.messaging', this._clearTimeout.bind(this))];
  }
  /**
   * Show the message in a toast.
   *
   * @private
   * @param {string} message The message to show in the toast.
   */


  Messaging_createClass(Messaging, [{
    key: "_showMessage",
    value: function _showMessage(message) {
      var _this = this;

      var timer = 5000; // if there is a previous timeout => clear it.

      if (this.timeout) {
        this._clearTimeout();
      } // Set the message to show in the toast.


      this.$message.html(message);
      this.$el.revealer('show');
      this.timeout = setTimeout(function () {
        // clear the time out.
        _this._clearTimeout(); // Timeout can be set to null as it hase been cleared from the window.


        _this.timeout = null; // Hide the message

        _this._hideMessage();
      }, timer);
    }
    /**
     * Hide the message.
     * Fires revealers hide. Once that completes checks that no new timeouts have been added
     * before clearing the message from the DOM.
     *
     * @private
     */

  }, {
    key: "_hideMessage",
    value: function _hideMessage() {
      var _this2 = this;

      this.$el.revealer('hide').one('trend', function () {
        // If there has been no new timeouts started since the revealer hide started
        // => clear the message in the toast.
        if (!_this2.timeout) {
          _this2.$message.empty();
        }
      });
    }
    /**
     * Clear the timeout.
     * Removes the timeout from the window object and sets the timeout
     * value to null.
     *
     * @private
     */

  }, {
    key: "_clearTimeout",
    value: function _clearTimeout() {
      clearTimeout(this.timeout);
    }
  }]);

  return Messaging;
}();


// CONCATENATED MODULE: ./source/scripts/Sections.js
function Sections_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Sections_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Sections_createClass(Constructor, protoProps, staticProps) { if (protoProps) Sections_defineProperties(Constructor.prototype, protoProps); if (staticProps) Sections_defineProperties(Constructor, staticProps); return Constructor; }


/*
  Commit SHA: 8b6d724 (May 7, 2019)

Pulled specific older version of this code from `empire-shopify` in Github.

*/

var Sections_Sections = /*#__PURE__*/function () {
  function Sections() {
    Sections_classCallCheck(this, Sections);

    this.handlers = {};
    this.instances = {};
    this.options = {};
    this.lazyLoader = null;
    this._onSectionEvent = this._onSectionEvent.bind(this);
    document.addEventListener('shopify:section:load', this._onSectionEvent);
    document.addEventListener('shopify:section:unload', this._onSectionEvent);
    document.addEventListener('shopify:section:select', this._onSectionEvent);
    document.addEventListener('shopify:section:deselect', this._onSectionEvent);
    document.addEventListener('shopify:block:select', this._onSectionEvent);
    document.addEventListener('shopify:block:deselect', this._onSectionEvent);
  }
  /**
   * Stop listening for section events, and unbind all handlers.
   */


  Sections_createClass(Sections, [{
    key: "unbind",
    value: function unbind() {
      document.removeEventListener('shopify:section:load', this._onSectionEvent);
      document.removeEventListener('shopify:section:unload', this._onSectionEvent);
      document.removeEventListener('shopify:section:select', this._onSectionEvent);
      document.removeEventListener('shopify:section:deselect', this._onSectionEvent);
      document.removeEventListener('shopify:block:select', this._onSectionEvent);
      document.removeEventListener('shopify:block:deselect', this._onSectionEvent); // Unload all instances

      for (var i = 0; i < this.instances.length; i++) {
        this._triggerInstanceEvent(this.instances[i], 'onSectionUnload');
      }

      this.handlers = {};
      this.options = {};
      this.lazyLoader.unload();
      this.lazyLoader = null;
      this.instances = {};
    }
    /**
     * Register a section handler.
     *
     * @param {string} type
     *        The section type to handle. The handler will be called for all
     *        sections with this type.
     *
     * @param {function} handler
     *        The handler function is passed information about a specific section
     *        instance. The handler is expected to return an object that will be
     *        associated with the section instance.
     *
     *        Section handlers are passed an object with the following parameters:
     *          {string} id
     *          An ID that maps to a specific section instance. Typically the
     *          section's filename for static sections, or a generated ID for
     *          dynamic sections.
     *
     *          {string} type
     *          The section type, as supplied when registered.
     *
     *          {Element} el
     *          The root DOM element for the section instance.
     *
     *          {Object} data
     *          Data loaded from the section script element. Defaults to an
     *          empty object.
     *
     *          {Function} postMessage
     *          A function that can be called to pass messages between sections.
     *          The function should be called with a message "name", and
     *          optionally some data.
     *
     * @param {object} options
     *
     * @param {boolean} options.lazy
     *         If true, sections will only be initialized after they intersect the viewport + 30% margin
     */

  }, {
    key: "register",
    value: function register(type, handler) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (this.handlers[type]) {
        console.warn("Sections: section handler already exists of type '".concat(type, "'."));
      } // Store the section handler


      this.handlers[type] = handler; // Store options

      this.options[type] = options; // Init sections for this type

      this._initSections(type);
    }
    /**
     * Initialize sections already on the page.
     */

  }, {
    key: "_initSections",
    value: function _initSections(type) {
      var _this = this;

      // Fetch all existing sections of our type on the page
      var dataEls = document.querySelectorAll("[data-section-type=\"".concat(type, "\"]"));
      if (!dataEls) return; // Create an instance for each section

      var _loop = function _loop(i) {
        var dataEl = dataEls[i];
        var el = dataEl.parentNode; // Get instance ID

        var idEl = el.querySelector('[data-section-id]');

        if (!idEl) {
          console.warn("Sections: unable to find section id for '".concat(type, "'."), el);
          return "continue";
        }

        var sectionId = idEl.getAttribute('data-section-id');

        if (!sectionId) {
          console.warn("Sections: unable to find section id for '".concat(type, "'."), el);
          return "continue";
        }

        if (_this.options[type] && _this.options[type].lazy) {
          if (_this.lazyLoader === null) {
            _this.lazyLoader = new helpers["f" /* LazyLoader */]();
          }

          _this.lazyLoader.add(el, function () {
            return _this._createInstance(sectionId, el);
          });
        } else {
          _this._createInstance(sectionId, el);
        }
      };

      for (var i = 0; i < dataEls.length; i++) {
        var _ret = _loop(i);

        if (_ret === "continue") continue;
      }
    }
  }, {
    key: "_onSectionEvent",
    value: function _onSectionEvent(event) {
      var el = event.target;
      var sectionId = event.detail.sectionId;
      var blockId = event.detail.blockId;
      var instance = this.instances[sectionId];

      switch (event.type) {
        case 'shopify:section:load':
          this._createInstance(sectionId, el);

          break;

        case 'shopify:section:unload':
          this._triggerInstanceEvent(instance, 'onSectionUnload', {
            el: el,
            id: sectionId
          });

          if (this.lazyLoader) {
            this.lazyLoader.remove(el);
          }

          delete this.instances[sectionId];
          break;

        case 'shopify:section:select':
          this._triggerInstanceEvent(instance, 'onSectionSelect', {
            el: el,
            id: sectionId
          });

          break;

        case 'shopify:section:deselect':
          this._triggerInstanceEvent(instance, 'onSectionDeselect', {
            el: el,
            id: sectionId
          });

          break;

        case 'shopify:block:select':
          this._triggerInstanceEvent(instance, 'onSectionBlockSelect', {
            el: el,
            id: blockId
          });

          break;

        case 'shopify:block:deselect':
          this._triggerInstanceEvent(instance, 'onSectionBlockDeselect', {
            el: el,
            id: blockId
          });

          break;
      }
    }
  }, {
    key: "_triggerInstanceEvent",
    value: function _triggerInstanceEvent(instance, eventName) {
      if (instance && instance[eventName]) {
        for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }

        instance[eventName].apply(instance, args);
      }
    }
  }, {
    key: "_postMessage",
    value: function _postMessage(name, data) {
      var _this2 = this;

      Object.keys(this.instances).forEach(function (id) {
        _this2._triggerInstanceEvent(_this2.instances[id], 'onSectionMessage', name, data);
      });
    }
  }, {
    key: "_createInstance",
    value: function _createInstance(id, el) {
      var typeEl = el.querySelector('[data-section-type]');
      if (!typeEl) return;
      var type = typeEl.getAttribute('data-section-type');
      if (!type) return;
      var handler = this.handlers[type];
      if (!handler) return console.warn("Sections: unable to find section handler for type '".concat(type, "'."));

      var data = this._loadData(el);

      var postMessage = this._postMessage.bind(this);

      this.instances[id] = handler({
        id: id,
        type: type,
        el: el,
        data: data,
        postMessage: postMessage
      });
    }
  }, {
    key: "_loadData",
    value: function _loadData(el) {
      var dataEl = el.querySelector('[data-section-data]');
      if (!dataEl) return {}; // Load data from attribute, or innerHTML

      var data = dataEl.getAttribute('data-section-data') || dataEl.innerHTML;

      try {
        return JSON.parse(data);
      } catch (error) {
        console.warn("Sections: invalid section data found. ".concat(error.message));
        return {};
      }
    }
  }]);

  return Sections;
}();


// CONCATENATED MODULE: ./source/scripts/Theme.js















































































































































































































































































// jQuery plugins

/* eslint-disable sort-imports */
// Global imports


 // eslint-disable-line no-unused-vars



 // Overrides

 // Local imports






/* eslint-enable sort-imports */
// Section imports



var Theme_initTheme = function initTheme() {
  index_es["a" /* default */].init('[data-rimg="lazy"]', {
    round: 1
  });
  var sections = new Sections_Sections();
  sections.register('static-header', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 930)).then(function (_ref) {
      var StaticSectionHeader = _ref.default;
      return new StaticSectionHeader(section);
    });
  });
  sections.register('static-footer', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 903)).then(function (_ref2) {
      var StaticSectionFooter = _ref2.default;
      return new StaticSectionFooter(section);
    });
  });
  sections.register('static-article', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 904)).then(function (_ref3) {
      var StaticArticle = _ref3.default;
      return new StaticArticle(section);
    });
  });
  sections.register('static-blog', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 905)).then(function (_ref4) {
      var StaticBlog = _ref4.default;
      return new StaticBlog(section);
    });
  });
  sections.register('static-cart', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 906)).then(function (_ref5) {
      var StaticCart = _ref5.default;
      return new StaticCart(section);
    });
  });
  sections.register('static-collection', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 907)).then(function (_ref6) {
      var StaticCollection = _ref6.default;
      return new StaticCollection(section);
    });
  });
  sections.register('static-giftcard', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 908)).then(function (_ref7) {
      var StaticGiftcard = _ref7.default;
      return new StaticGiftcard(section);
    });
  });
  sections.register('static-filters', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 909)).then(function (_ref8) {
      var StaticFilters = _ref8.default;
      return new StaticFilters(section);
    });
  });
  sections.register('static-product', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 910)).then(function (_ref9) {
      var StaticProduct = _ref9.default;
      return new StaticProduct(section);
    });
  });
  sections.register('static-search', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 911)).then(function (_ref10) {
      var StaticSearch = _ref10.default;
      return new StaticSearch(section);
    });
  });
  sections.register('static-page-contact', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 912)).then(function (_ref11) {
      var StaticPageContact = _ref11.default;
      return new StaticPageContact(section);
    });
  });
  sections.register('static-page-faq', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 913)).then(function (_ref12) {
      var StaticPageFaq = _ref12.default;
      return new StaticPageFaq(section);
    });
  });
  sections.register('static-page-store-locations', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 914)).then(function (_ref13) {
      var StaticPageStoreLocations = _ref13.default;
      return new StaticPageStoreLocations(section);
    });
  });
  sections.register('dynamic-blog-posts', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 915)).then(function (_ref14) {
      var DynamicBlogPosts = _ref14.default;
      return new DynamicBlogPosts(section);
    });
  });
  sections.register('static-highlights-banners', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 916)).then(function (_ref15) {
      var StaticHighlightsBanners = _ref15.default;
      return new StaticHighlightsBanners(section);
    });
  });
  sections.register('static-slideshow', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 917)).then(function (_ref16) {
      var StaticSlideshow = _ref16.default;
      return new StaticSlideshow(section);
    });
  });
  sections.register('dynamic-promo-blocks', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 918)).then(function (_ref17) {
      var DynamicPromoBlocks = _ref17.default;
      return new DynamicPromoBlocks(section);
    });
  });
  sections.register('dynamic-menu-list', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 919)).then(function (_ref18) {
      var DynamicMenuList = _ref18.default;
      return new DynamicMenuList(section);
    });
  });
  sections.register('dynamic-featured-collection', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 920)).then(function (_ref19) {
      var DynamicFeaturedCollection = _ref19.default;
      return new DynamicFeaturedCollection(section);
    });
  });
  sections.register('dynamic-search', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 921)).then(function (_ref20) {
      var DynamicSearch = _ref20.default;
      return new DynamicSearch(section);
    });
  });
  sections.register('dynamic-rich-text', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 922)).then(function (_ref21) {
      var DynamicRichText = _ref21.default;
      return new DynamicRichText(section);
    });
  });
  sections.register('dynamic-video', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 931)).then(function (_ref22) {
      var DynamicVideo = _ref22.default;
      return new DynamicVideo(section);
    });
  });
  sections.register('dynamic-newsletter', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 923)).then(function (_ref23) {
      var DynamicNewsletter = _ref23.default;
      return new DynamicNewsletter(section);
    });
  });
  sections.register('pxs-map', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 924)).then(function (_ref24) {
      var PXSMap = _ref24.default;
      return new PXSMap(section);
    });
  });
  sections.register('glossary', function (section) {
    return Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 383)).then(function (_ref25) {
      var Glossary = _ref25.default;
      return new Glossary(section);
    });
  });

  if (document.body.classList.contains('template-account')) {
    Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 932)).then(function (_ref26) {
      var Account = _ref26.default;
      return new Account();
    });
  }

  if (document.body.classList.contains('template-page')) {
    Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 927)).then(function (_ref27) {
      var Page = _ref27.default;
      return new Page();
    });
  }

  if (document.body.classList.contains('template-page.glossary')) {
    Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 383)).then(function (_ref28) {
      var Glossary = _ref28.default;
      return new Glossary();
    });
  }

  if (document.body.classList.contains('template-page--contact')) {
    Promise.resolve(/* import() eager */).then(__webpack_require__.bind(null, 928)).then(function (_ref29) {
      var Contact = _ref29.default;
      return new Contact();
    });
  }
};

new CustomerLicence["a" /* default */]();
new CustomerSessionTimer_CustomerSessionTimer();
new LicenceSwitcherModal["a" /* default */]('[data-licence-switcher-form]');
new helpers["g" /* ManageCart */]();
new Messaging_Messaging();
Object(helpers["l" /* flickityTouchFix */])();
Theme_initTheme();

/***/ }),

/***/ 930:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ StaticSectionHeader_StaticSectionHeader; });

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(0);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/scriptjs/dist/script.js
var script = __webpack_require__(24);
var script_default = /*#__PURE__*/__webpack_require__.n(script);

// EXTERNAL MODULE: ./source/scripts/Forms.js
var Forms = __webpack_require__(21);

// EXTERNAL MODULE: ./source/scripts/Layout.js
var Layout = __webpack_require__(4);

// EXTERNAL MODULE: ./source/scripts/helpers/index.js + 24 modules
var helpers = __webpack_require__(2);

// CONCATENATED MODULE: ./source/scripts/components/AnnouncementBanner.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var AnnouncementBanner_AnnouncementBanner = /*#__PURE__*/function () {
  function AnnouncementBanner($el) {
    _classCallCheck(this, AnnouncementBanner);

    this.$el = $el;
    var previouslyDismissed = window.sessionStorage.getItem(helpers["s" /* localStorage */].announcementBannerDismiss);
    this.events = [this.$el.on('click.announcement-banner', '[data-announcement-banner-close]', this._hide.bind(this))];

    if (!previouslyDismissed || jquery_default()(document.documentElement).hasClass('in-theme-editor')) {
      this._show();
    }
  }

  _createClass(AnnouncementBanner, [{
    key: "_show",
    value: function _show() {
      this.$el.removeClass('hidden');
    }
  }, {
    key: "_hide",
    value: function _hide() {
      this.$el.addClass('hidden');
      window.sessionStorage.setItem(helpers["s" /* localStorage */].announcementBannerDismiss, true);
    }
  }, {
    key: "unload",
    value: function unload() {
      this.events.forEach(function ($el) {
        return $el.off('.announcement-banner');
      });
    }
  }]);

  return AnnouncementBanner;
}();


// EXTERNAL MODULE: ./source/scripts/licence/LicenceSwitcherModal.js
var LicenceSwitcherModal = __webpack_require__(70);

// EXTERNAL MODULE: ./source/scripts/Dropdown.js
var Dropdown = __webpack_require__(94);

// EXTERNAL MODULE: ./source/scripts/components/InlineSearch.js + 2 modules
var InlineSearch = __webpack_require__(97);

// CONCATENATED MODULE: ./source/scripts/components/MegaNavScroller.js
function MegaNavScroller_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MegaNavScroller_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function MegaNavScroller_createClass(Constructor, protoProps, staticProps) { if (protoProps) MegaNavScroller_defineProperties(Constructor.prototype, protoProps); if (staticProps) MegaNavScroller_defineProperties(Constructor, staticProps); return Constructor; }




var MegaNavScroller_MegaNavScroller = /*#__PURE__*/function () {
  function MegaNavScroller($el) {
    var block = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    MegaNavScroller_classCallCheck(this, MegaNavScroller);

    this.$el = $el;
    this.$menuList = this.$el.find('.navmenu-meganav-items');

    this._bindEvents();

    this._addScrollClasses();

    if (block) {
      Object(helpers["v" /* scrollLeft */])(jquery_default()(block.el));
    }
  }

  MegaNavScroller_createClass(MegaNavScroller, [{
    key: "unload",
    value: function unload() {
      this.$menuList.off('.meganav');
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;

      this.$menuList.on('scroll.meganav', function () {
        return _this._addScrollClasses();
      });
    }
  }, {
    key: "_addScrollClasses",
    value: function _addScrollClasses() {
      var elScrollLeft = this.$menuList.scrollLeft();
      var scrollWidth = this.$menuList[0].scrollWidth;
      var width = this.$menuList.width();
      this.$el.toggleClass('meganav--overflows-left', elScrollLeft > 0);
      this.$el.toggleClass('meganav--overflows-right', elScrollLeft < scrollWidth - width);
    }
  }]);

  return MegaNavScroller;
}();


// CONCATENATED MODULE: ./source/scripts/components/NavDesktop.js
function NavDesktop_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NavDesktop_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function NavDesktop_createClass(Constructor, protoProps, staticProps) { if (protoProps) NavDesktop_defineProperties(Constructor.prototype, protoProps); if (staticProps) NavDesktop_defineProperties(Constructor, staticProps); return Constructor; }





var NavDesktop_NavDesktop = /*#__PURE__*/function () {
  function NavDesktop(options) {
    var _this = this;

    NavDesktop_classCallCheck(this, NavDesktop);

    this.$el = jquery_default()(options.$el);
    this.postMessage = options.postMessage;
    this.activeMenu = 'navmenu-active';
    this.activeItem = 'navmenu-item-active';
    this.navTrigger = '[data-navmenu-trigger]';
    this.subMenu = '[data-navmenu-submenu]';
    this.inlineChildren = 'navmenu-submenu-inline-children';
    this.events = [// Navmenu mouse events
    this.$el.on('mousedown.navmenu', '.navmenu-link', function (event) {
      event.preventDefault(); // Add a class to actively clicked item to prevent focus styling

      var $target = jquery_default()(event.currentTarget);

      _this.$el.find(".".concat(_this.activeItem)).removeClass(_this.activeItem);

      $target.addClass(_this.activeItem).attr('aria-expanded', true);
    }), this.$el.on('mouseup.navemenu, click.navmenu', "".concat(this.navTrigger, " > .navmenu-link-parent"), function (event) {
      // Mouseup and click fire after mousedown
      return event.preventDefault();
    }), this.$el.on('mousedown.navmenu', "".concat(this.navTrigger, " > .navmenu-link-parent"), function (event) {
      event.preventDefault();
      var $target = jquery_default()(event.currentTarget);

      if ($target.is(':focus')) {
        $target.data('clicked', true);
      }

      _this.toggleItem(event.currentTarget.parentNode);
    }), // Toggle item on touch, and click
    this.$el.on('touchend.navmenu', "".concat(this.navTrigger, " > .navmenu-link-parent"), function (event) {
      event.preventDefault();
      event.stopPropagation();

      _this.toggleItem(event.currentTarget.parentNode);
    }), // Keyboard navigation -- toggle submenus
    this.$el.on('focus.navmenu', "".concat(this.navTrigger, " > .navmenu-link-parent"), function (event) {
      event.stopPropagation();
      var $target = jquery_default()(event.currentTarget);
      var clicked = $target.data('clicked'); // Prevent focus by click to fire a subsequent toggle

      if (clicked) {
        $target.removeData('clicked');
      } else {
        _this.toggleItem(event.currentTarget.parentNode);
      }
    }), // Keyboard navigation -- close submenus when moving to a new nav item
    this.$el.on('focus.navmenu', '.navmenu-depth-1 > .navmenu-item .navmenu-link', function (event) {
      _this.closeAll(event.currentTarget);
    }), // Close items when clicking outside
    jquery_default()(document).on('touchstart.navmenu, click.navmenu', function (event) {
      _this._handleDocumentClick(event.target);
    })];
  }

  NavDesktop_createClass(NavDesktop, [{
    key: "unload",
    value: function unload() {
      this.events.forEach(function ($el) {
        return $el.off('.navmenu');
      });

      if (this.megaNav) {
        delete this.megaNav;
      }
    }
    /**
     * Open the MegaNav
     * @param $menu
     * @param block
     */

  }, {
    key: "openMegaNav",
    value: function openMegaNav($menu, block) {
      this.megaNav = new MegaNavScroller_MegaNavScroller($menu, block);
    }
    /**
     * Open a dropdown menu, or scroll to a meganav item
     *
     * @param el - Parent LI containing sub menu
     * @param block - Meganav menu block
     */

  }, {
    key: "openItem",
    value: function openItem(el) {
      var _this2 = this;

      var block = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var $el = jquery_default()(el); // Check if menu is already open

      var $menu = $el.children(this.subMenu);

      if ($menu.is(':visible')) {
        // If its not a meganav, do nothing
        if ($menu.attr('data-meganav-menu') === undefined) {
          return;
        } // If its a meganav, scroll horizontally to the item


        Object(helpers["v" /* scrollLeft */])(jquery_default()(block.el));
        return;
      } // Close previously opened items


      this.closeAll(el);
      $el.data('transitioning', true);
      var $parent = $menu.parent(this.navTrigger); // Add an active class to the menu's parent

      $parent.find('.navmenu-link-parent:first').addClass(this.activeMenu); // Show menu

      $menu.addClass('animating animating-in').one('trend', function () {
        $menu.removeClass('animating animating-in').addClass('visible').off('trend');

        _this2._inlineMenu($menu);

        $el.data('transitioning', false);
        $parent.find('> .navmenu-link').attr('aria-expanded', true); // Load MegaNavScroller if is a mega nav

        if ($menu.attr('data-meganav-menu') !== undefined) {
          _this2.openMegaNav($menu, block);
        }
      });
    }
  }, {
    key: "closeAll",
    value: function closeAll(target) {
      var _this3 = this;

      this.$el.find("".concat(this.subMenu, ".visible, ").concat(this.subMenu, ".animating-in")).parent(this.navTrigger).each(function (i, el) {
        if (target && jquery_default.a.contains(el, target)) {
          return;
        } // Close any submenus in this tree


        jquery_default()(el).find(_this3.navTrigger).each(function (idx, submenu) {
          return _this3.closeItem(submenu);
        }); // Close root-level menu item

        _this3.closeItem(el);
      });
    }
  }, {
    key: "closeItem",
    value: function closeItem(el) {
      var _this4 = this;

      var $el = jquery_default()(el);
      var $menu = $el.children("".concat(this.subMenu, ".visible, ").concat(this.subMenu, ".animating-in"));
      var $parent = $menu.parent(this.navTrigger);

      if (!$menu.length) {
        return;
      } // Menu is in the progress of being animated, try in 300ms


      if ($el.data('transitioning')) {
        setTimeout(function () {
          return _this4.closeItem(el);
        }, 300);
      } // Add an active class to the menu's parent


      $parent.find('.navmenu-link-parent:first').removeClass(this.activeMenu); // Ensure $menu is scrolled to top

      if ($menu.hasClass(this.inlineChildren)) {
        $menu.scrollTop(0);
      } // Hide menu


      $menu.addClass('animating animating-out').removeClass('animating-in').one('trend', function () {
        $menu.removeClass('animating animating-out visible').off('trend');
        $parent.find('> .navmenu-link').attr('aria-expanded', false).removeClass(_this4.activeItem); // Unload MegaNavScroller if is a mega-nav

        if ($menu.data('meganav-menu') !== undefined && _this4.megaNav) {
          _this4.megaNav.unload();

          _this4.megaNav = null;
        }
      });
    }
  }, {
    key: "toggleItem",
    value: function toggleItem(el) {
      var $el = jquery_default()(el);
      var $menu = $el.children(this.subMenu);

      if ($menu.is(':visible')) {
        this.closeItem(el);
      } else {
        this.openItem(el);
      }
    }
  }, {
    key: "_handleDocumentClick",
    value: function _handleDocumentClick(target) {
      var $parent = jquery_default()(target).parents(this.navTrigger);

      if ($parent.length) {
        return;
      }

      this.closeAll();
    }
  }, {
    key: "_menuLimits",
    value: function _menuLimits($menu) {
      var windowHeight = window.innerHeight;
      var windowWidth = window.innerWidth;
      var menuRect = $menu[0].getBoundingClientRect();
      var hasChildren = $menu.find(this.subMenu).length > 0;
      var edges = {
        bottomEdge: menuRect.bottom,
        rightEdge: menuRect.right + menuRect.width
      }; // Store bottom offset for subsequent openings

      if (!$menu.data('bottom-edge') || $menu.data('bottom-edge') !== edges.bottomEdge) {
        $menu.data('bottom-edge', edges.bottomEdge);
      } // Store child menu right edge


      if (!$menu.data('right-edge') || $menu.data('right-edge') !== edges.rightEdge) {
        $menu.data('right-edge', edges.rightEdge);
      }

      var bottomEdge = parseInt($menu.data('bottom-edge'), 10);
      var rightEdge = parseInt($menu.data('right-edge'), 10);
      return {
        childrenExceedHorizontal: rightEdge >= windowWidth && hasChildren,
        exceedsVertical: bottomEdge >= windowHeight,
        maxHeight: windowHeight - menuRect.top
      };
    }
    /**
     * Set a menu to be
     */

  }, {
    key: "_inlineMenu",
    value: function _inlineMenu($menu) {
      var _this$_menuLimits = this._menuLimits($menu),
          childrenExceedHorizontal = _this$_menuLimits.childrenExceedHorizontal,
          exceedsVertical = _this$_menuLimits.exceedsVertical,
          maxHeight = _this$_menuLimits.maxHeight; // Unset inline style if height allows, and children menu don't exceed window bounds


      if (!exceedsVertical && !childrenExceedHorizontal) {
        return this._unsetInlineMenu($menu);
      }

      return $menu.css({
        maxHeight: maxHeight
      }).addClass(this.inlineChildren);
    }
  }, {
    key: "_unsetInlineMenu",
    value: function _unsetInlineMenu($menu) {
      $menu.removeAttr('data-bottom-edge').removeAttr('data-right-edge').removeClass(this.inlineChildren).css('max-height', '');
    }
  }]);

  return NavDesktop;
}();


// EXTERNAL MODULE: ./source/scripts/Accordion.js
var Accordion = __webpack_require__(59);

// CONCATENATED MODULE: ./source/scripts/components/NavMobileSubMenus.js
function NavMobileSubMenus_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NavMobileSubMenus_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function NavMobileSubMenus_createClass(Constructor, protoProps, staticProps) { if (protoProps) NavMobileSubMenus_defineProperties(Constructor.prototype, protoProps); if (staticProps) NavMobileSubMenus_defineProperties(Constructor, staticProps); return Constructor; }




var NavMobileSubMenus_NavMobileSubMenus = /*#__PURE__*/function () {
  function NavMobileSubMenus($el) {
    NavMobileSubMenus_classCallCheck(this, NavMobileSubMenus);

    this.$el = $el;
    this.Accordion = new Accordion["a" /* default */](this.$el, {
      activeClass: 'visible',
      content: '[data-accordion-content]'
    }); // Sub menu selectors

    this.activeMenuClass = 'navmenu-link-parent-active';
    this.activeMenu = ".".concat(this.activeMenuClass);
    this.navTrigger = '[data-navmenu-trigger]';
    this.subMenu = '[data-navmenu-submenu]';

    this._bindEvents();
  }

  NavMobileSubMenus_createClass(NavMobileSubMenus, [{
    key: "unload",
    value: function unload() {
      this.$el.off('.mobile-nav');
      delete this.Accordion;
    }
  }, {
    key: "closeSubMenus",
    value: function closeSubMenus($current) {
      var _this = this;

      $current.find(this.activeMenu).each(function (index, el) {
        _this._closeSubmenu(jquery_default()(el));
      });
    }
  }, {
    key: "closeAllSubmenus",
    value: function closeAllSubmenus() {
      this.Accordion.closeOpen();
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this2 = this;

      // Prevent focus state from applying on mouse click
      this.$el.on('mousedown.mobile-nav', '.navmenu-link', function (event) {
        event.preventDefault();
      });
      this.$el.on('click.mobile-nav', "".concat(this.navTrigger, " > .navmenu-link-parent"), function (event) {
        event.preventDefault();

        _this2._toggleSubmenu(event);
      });
    }
  }, {
    key: "_selectSubMenu",
    value: function _selectSubMenu($target) {
      return $target.next(this.subMenu);
    }
  }, {
    key: "_toggleSubmenu",
    value: function _toggleSubmenu(event) {
      var $target = jquery_default()(event.currentTarget);

      if ($target.hasClass(this.activeMenuClass)) {
        this._closeSubmenu($target);
      } else {
        this._openSubmenu($target);
      }
    }
  }, {
    key: "_openSubmenu",
    value: function _openSubmenu($target) {
      var $menu = this._selectSubMenu($target);

      $target.addClass(this.activeMenuClass).attr('aria-expanded', true);
      this.Accordion.toggle($menu);
    }
  }, {
    key: "_closeSubmenu",
    value: function _closeSubmenu($target) {
      var $menu = this._selectSubMenu($target);

      $target.removeClass(this.activeMenuClass).attr('aria-expanded', false);
      this.Accordion.toggle($menu);
      this.closeSubMenus($menu);
    }
  }]);

  return NavMobileSubMenus;
}();


// CONCATENATED MODULE: ./source/scripts/components/NavMobile.js
function NavMobile_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NavMobile_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function NavMobile_createClass(Constructor, protoProps, staticProps) { if (protoProps) NavMobile_defineProperties(Constructor.prototype, protoProps); if (staticProps) NavMobile_defineProperties(Constructor, staticProps); return Constructor; }






var NavMobile_NavMobile = /*#__PURE__*/function () {
  function NavMobile(elements) {
    NavMobile_classCallCheck(this, NavMobile);

    this.$body = jquery_default()(document.body);
    this.$window = jquery_default()(window);
    this.$el = elements.$el;
    this.$toggleOpen = elements.$toggleOpen;
    this.isOpen = false;
    this.subMenus = null;
    this.$mobileNav = this.$el.find('[data-mobile-nav]');
    this.$panel = this.$el.find('[data-mobile-nav-panel]');
    this.$overlay = this.$el.find('[data-mobile-nav-overlay]');
    this.$toggleClose = this.$el.find('[data-mobile-nav-close]');
    this.$mobileNavAccount = this.$el.find('[data-mobile-nav-account]');
    this.$switcherButton = this.$mobileNavAccount.find('[data-licence-switcher-toggle]'); // Revert navigation to original state on breakpoint change

    this.layoutHandler = this.onBreakpointChange.bind(this);
    Layout["a" /* default */].onBreakpointChange(this.layoutHandler);

    this._bindEvents();

    this.licenceSwitcher = new LicenceSwitcherModal["a" /* default */]("[data-licence-switcher-modal-contents]");
  }

  NavMobile_createClass(NavMobile, [{
    key: "unload",
    value: function unload() {
      this._close();

      this.$window.off('resize.mobile-nav');
      Layout["a" /* default */].offBreakpointChange(this.layoutHandler);
    }
  }, {
    key: "onBreakpointChange",
    value: function onBreakpointChange() {
      if (Layout["a" /* default */].isBreakpoint('L') && this.isOpen) {
        this._close();
      }
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;

      this.$toggleOpen.on('click.mobile-nav', function (event) {
        event.preventDefault();

        if (!Layout["a" /* default */].isBreakpoint('L')) {
          _this._open();
        }
      });
      this.$switcherButton.on('click.mobile-nav', function () {
        if (_this.isOpen) {
          _this._close();

          _this.licenceSwitcher.openModal();
        }
      });
      this.$window.on('resize.mobile-nav', function () {
        _this.$el.find('[data-menu-toggle]').removeClass('active');

        if (_this.isOpen) {
          _this._setPanelHeight();
        }
      });
    }
  }, {
    key: "_setPanelHeight",
    value: function _setPanelHeight() {
      this.$panel.height(window.innerHeight);
    }
  }, {
    key: "_open",
    value: function _open() {
      var _this2 = this;

      this.$body.addClass('scroll-lock');
      this.isOpen = true; // Activate Submenu handler

      this.subMenus = new NavMobileSubMenus_NavMobileSubMenus(this.$panel);

      this._setPanelHeight(); // Animate in elements


      this.$mobileNav.addClass('animating animating-in').one('trend', function () {
        _this2.$mobileNav.removeClass('animating animating-in').addClass('visible').off('trend');
      }); // Event handlers

      this.events = [// Close menu when clicking on the overlay
      this.$overlay.on('click.mobile-nav', function (event) {
        return _this2._close(event);
      }), this.$toggleClose.on('click.mobile-nav', function (event) {
        return _this2._close(event);
      }), // Disable scrolling on overlay and contactbar
      this.$overlay.on('touchmove.mobile-nav', function (event) {
        return event.preventDefault();
      })];
    }
  }, {
    key: "_close",
    value: function _close() {
      var _this3 = this;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (event) {
        event.preventDefault();
      }

      this.$mobileNav.addClass('animating animating-out').one('trend', function () {
        _this3.$mobileNav.removeClass('animating animating-out').removeClass('visible').off('trend');
      });
      this.$body.removeClass('scroll-lock');
      this.isOpen = false; // Close any open drop down menus

      if (this.subMenus) {
        this.subMenus.closeSubMenus(this.$el);
        this.subMenus.closeAllSubmenus(); // Unbind Mobile sub menus

        this.subMenus.unload();
      } // Unbind events


      if (this.events) {
        this.events.forEach(function ($el) {
          return $el.off('.mobile-nav');
        });
        this.events = [];
      }
    }
  }]);

  return NavMobile;
}();


// EXTERNAL MODULE: ./source/scripts/components/SearchForm.js
var SearchForm = __webpack_require__(71);

// CONCATENATED MODULE: ./source/scripts/sections/StaticSectionHeader.js
function StaticSectionHeader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StaticSectionHeader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function StaticSectionHeader_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticSectionHeader_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticSectionHeader_defineProperties(Constructor, staticProps); return Constructor; }














var StaticSectionHeader_StaticSectionHeader = /*#__PURE__*/function () {
  function StaticSectionHeader(section) {
    var _this = this;

    StaticSectionHeader_classCallCheck(this, StaticSectionHeader);

    this.$el = jquery_default()(section.el);
    this.settings = section.data.settings;
    this.postMessage = section.postMessage;
    this.headerSearch = null;
    this.$scripts = jquery_default()('[data-scripts]');
    this.$menuToggle = this.$el.find('[data-menu-toggle]');
    this.$cartCount = this.$el.find('[data-header-cart-count]');
    this.$searchField = this.$el.find('[data-live-search]');
    this.$siteNavigation = this.$el.find('[data-site-navigation]');
    this.$desktopNavigation = this.$siteNavigation.find('ul.navmenu-depth-1');
    this.$headerTools = this.$siteNavigation.find('[data-header-actions]');
    this.$accountMenuToggle = this.$el.find('[data-account-menu-toggle]');
    this.$accountMenu = this.$el.find('[data-account-menu]');
    this.eventHandler = new helpers["d" /* EventHandler */]();
    this.navMobile = new NavMobile_NavMobile({
      $el: this.$el,
      $toggleOpen: this.$menuToggle
    });
    this.navDesktop = new NavDesktop_NavDesktop({
      $el: this.$siteNavigation,
      postMessage: this.postMessage
    });
    this.forms = new Forms["a" /* default */](this.$el);

    if (this.settings.live_search.enable) {
      script_default()(this.$scripts.data('shopify-api-url'), function () {
        _this.headerSearch = new InlineSearch["a" /* default */]({
          $el: _this.$searchField,
          $header: _this.$el
        }, _this.settings.live_search);
      });
    } else {
      this.headerSearch = new SearchForm["a" /* default */](this.$searchField);
    } // Handle Accordion interaction when window size changes


    this._headerToolsSize = this._headerToolsSize.bind(this);
    Layout["a" /* default */].onBreakpointChange(this._headerToolsSize);

    this._bindEvents();

    this._headerToolsSize();

    this.accountMenu = new Dropdown["a" /* default */]('[data-account-menu]');
    this.licenceSwitcher = new LicenceSwitcherModal["a" /* default */]('[data-account-menu] [data-licence-switcher-modal-contents]');
    var $announcementBanner = this.$el.find('[data-announcement-banner]');

    if ($announcementBanner.length) {
      this.announcementBanner = new AnnouncementBanner_AnnouncementBanner($announcementBanner);
    }
  }

  StaticSectionHeader_createClass(StaticSectionHeader, [{
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this2 = this;

      this.$accountMenu.on('click.static-header', '[data-licence-switcher-toggle]', function () {
        _this2.licenceSwitcher.openModal();
      });
      this.eventHandler.on('cartUpdate', function (data) {
        _this2.$cartCount.attr('data-header-cart-count', data.item_count).toggleClass('visible', data.item_count > 0);
      });
    }
  }, {
    key: "onSectionDeselect",
    value: function onSectionDeselect() {
      this.navDesktop.closeAll(null);
    }
  }, {
    key: "onSectionUnload",
    value: function onSectionUnload() {
      this.navMobile.unload();
      this.navDesktop.unload();
      this.forms.unload();
      this.accountMenu.unload();
      this.licenceSwitcher.unload();
      this.$accountMenu.off('.static-header');
      this.$el.off('cartcount:update');
      this.announcementBanner.unload();
      this.headerSearch.unload();
    }
  }, {
    key: "onSectionMessage",
    value: function onSectionMessage(name, data) {
      if (name === 'nav:close-all' && Layout["a" /* default */].isBreakpoint('L')) {
        this.navDesktop.closeAll(null);
      }
    }
  }, {
    key: "onSectionBlockSelect",
    value: function onSectionBlockSelect(block) {
      var _this3 = this;

      if (Layout["a" /* default */].isBreakpoint('L')) {
        setTimeout(function () {
          if (!jquery_default()(block.el).find('.navmenu-link').hasClass('navmenu-active')) {
            _this3.navDesktop.toggleItem(block.el);
          }
        }, 100);
      }
    }
  }, {
    key: "onSectionBlockDeselect",
    value: function onSectionBlockDeselect() {
      this.navDesktop.closeAll(null);
    }
  }, {
    key: "_headerToolsSize",
    value: function _headerToolsSize() {
      if (!Layout["a" /* default */].isBreakpoint('L')) {
        return;
      }

      var outerWidth = this.$headerTools.width();
      var innerWidths = [];
      this.$headerTools.find('li').each(function (index, el) {
        innerWidths.push(Math.ceil(jquery_default()(el).outerWidth()));
      });
      var combinedWidths = innerWidths.reduce(function (a, b) {
        return a + b;
      }, 0);

      if (combinedWidths > outerWidth) {
        this.$headerTools.css('max-width', "".concat(combinedWidths, "px"));
        this.$desktopNavigation.css('max-width', "calc(100% - ".concat(combinedWidths, "px)"));
      }
    }
  }]);

  return StaticSectionHeader;
}();



/***/ }),

/***/ 931:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ DynamicVideo_DynamicVideo; });

// EXTERNAL MODULE: ./node_modules/scriptjs/dist/script.js
var script = __webpack_require__(24);
var script_default = /*#__PURE__*/__webpack_require__.n(script);

// CONCATENATED MODULE: ./source/scripts/components/Youtube.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }


var api = 'https://www.youtube.com/iframe_api';
var apiLoadedCallbacks = [];
var apiLoaded = false;

window.onYouTubeIframeAPIReady = function () {
  apiLoadedCallbacks.forEach(function (apiLoadedCallback) {
    return apiLoadedCallback();
  });
  apiLoadedCallbacks = [];
  apiLoaded = true;
};

var Youtube_Youtube = /*#__PURE__*/function () {
  function Youtube(el) {
    _classCallCheck(this, Youtube);

    var url = el.getAttribute('data-video-url');
    var regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
    this.el = el;
    this.id = url.match(regex)[1] || null;
    this.onApiLoaded = this._onApiLoaded.bind(this);
    this.isReady = false;
    this.onReady = this._onReady.bind(this);
    this.onReadyCallback = null;
    this.onStateChange = this._onStateChange.bind(this);
    this.onPlayCallback = null;

    if (apiLoaded) {
      this._onApiLoaded();
    } else {
      apiLoadedCallbacks.push(this.onApiLoaded);
      script_default()(api);
    }
  }

  _createClass(Youtube, [{
    key: "play",
    value: function play() {
      var _this = this;

      return new Promise(function (resolve) {
        _this.onPlayCallback = resolve;

        if (_this.isReady) {
          _this.player.playVideo();
        } else {
          _this.onReadyCallback = function () {
            _this.player.playVideo();
          };
        }
      });
    }
  }, {
    key: "pause",
    value: function pause() {
      var _this2 = this;

      return new Promise(function (resolve) {
        _this2.onPlayCallback = resolve;

        if (_this2.isReady) {
          _this2.player.pauseVideo();
        } else {
          _this2.onReadyCallback = function () {
            _this2.player.pauseVideo();
          };
        }
      });
    }
  }, {
    key: "autoplay",
    value: function autoplay() {
      var _this3 = this;

      return new Promise(function (resolve) {
        _this3.onPlayCallback = resolve;

        if (_this3.isReady) {
          _this3.player.playVideo();

          _this3.player.mute();
        } else {
          _this3.onReadyCallback = function () {
            _this3.player.playVideo();

            _this3.player.mute();
          };
        }
      });
    }
  }, {
    key: "unload",
    value: function unload() {
      this.player.destroy();
    }
  }, {
    key: "_onApiLoaded",
    value: function _onApiLoaded() {
      this.player = new YT.Player(this.el, {
        videoId: this.id,
        playerVars: {
          modestbranding: true,
          showinfo: false,
          controls: false,
          rel: 0
        },
        events: {
          onReady: this.onReady,
          onStateChange: this.onStateChange
        }
      });
    }
  }, {
    key: "_onReady",
    value: function _onReady() {
      this.isReady = true;

      if (this.onReadyCallback) {
        this.onReadyCallback();
      }
    }
  }, {
    key: "_onStateChange",
    value: function _onStateChange(event) {
      var state = event.data;

      if (this.onPlayCallback && state === YT.PlayerState.PLAYING) {
        this.onPlayCallback();
        this.onPlayCallback = null;
      }
    }
  }]);

  return Youtube;
}();


// CONCATENATED MODULE: ./source/scripts/components/Vimeo.js
function Vimeo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Vimeo_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Vimeo_createClass(Constructor, protoProps, staticProps) { if (protoProps) Vimeo_defineProperties(Constructor.prototype, protoProps); if (staticProps) Vimeo_defineProperties(Constructor, staticProps); return Constructor; }


var Vimeo_api = 'https://player.vimeo.com/api/player.js';
var Vimeo_apiLoaded = false;

var Vimeo_VimeoPlayer = /*#__PURE__*/function () {
  function VimeoPlayer(el) {
    Vimeo_classCallCheck(this, VimeoPlayer);

    var url = el.getAttribute('data-video-url');
    var urlParts = url.split('/');
    this.el = el;
    this.id = urlParts[urlParts.length - 1];
    this.onReadyCallback = null;
    this.onApiLoaded = this._onApiLoaded.bind(this);
    this.onProgress = this._onProgress.bind(this);
    this.onProgressCallback = null;

    if (Vimeo_apiLoaded) {
      this._onApiLoaded();
    } else {
      script_default()(Vimeo_api, this.onApiLoaded);
    }
  }

  Vimeo_createClass(VimeoPlayer, [{
    key: "play",
    value: function play() {
      var _this = this;

      return new Promise(function (resolve) {
        _this.onProgressCallback = resolve;

        if (Vimeo_apiLoaded) {
          _this.player.on('progress', _this.onProgress);

          _this.player.play();
        } else {
          _this.onReadyCallback = function () {
            _this.player.on('progress', _this.onProgress);

            _this.player.play();
          };
        }
      });
    }
  }, {
    key: "pause",
    value: function pause() {
      var _this2 = this;

      return new Promise(function (resolve) {
        _this2.onProgressCallback = resolve;

        if (Vimeo_apiLoaded) {
          _this2.player.on('progress', _this2.onProgress);

          _this2.player.pause();
        } else {
          _this2.onReadyCallback = function () {
            _this2.player.on('progress', _this2.onProgress);

            _this2.player.pause();
          };
        }
      });
    }
  }, {
    key: "autoplay",
    value: function autoplay() {
      var _this3 = this;

      return new Promise(function (resolve) {
        _this3.onProgressCallback = resolve;

        if (Vimeo_apiLoaded) {
          _this3.player.on('progress', _this3.onProgress);

          _this3.player.setVolume(0);

          _this3.player.play();
        } else {
          _this3.onReadyCallback = function () {
            _this3.player.on('progress', _this3.onProgress);

            _this3.player.setVolume(0);

            _this3.player.play();
          };
        }
      });
    }
  }, {
    key: "unload",
    value: function unload() {
      this.player.unload().catch();
    }
  }, {
    key: "_onApiLoaded",
    value: function _onApiLoaded() {
      this.player = new window.Vimeo.Player(this.el, {
        id: this.id
      });
      this.player.ready().then().catch();
      Vimeo_apiLoaded = true;

      if (this.onReadyCallback) {
        this.onReadyCallback();
      }
    }
  }, {
    key: "_onProgress",
    value: function _onProgress() {
      this.player.off('progress', this.onProgress);

      if (this.onProgressCallback) {
        this.onProgressCallback();
        this.onProgressCallback = null;
      }
    }
  }]);

  return VimeoPlayer;
}();


// CONCATENATED MODULE: ./source/scripts/components/Video.js
function Video_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Video_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Video_createClass(Constructor, protoProps, staticProps) { if (protoProps) Video_defineProperties(Constructor.prototype, protoProps); if (staticProps) Video_defineProperties(Constructor, staticProps); return Constructor; }




var Video_Video = /*#__PURE__*/function () {
  function Video(el, options) {
    Video_classCallCheck(this, Video);

    this.el = el;
    this.options = options;
    this.platform = el.getAttribute('data-video').trim();
    this.playButton = el.querySelector('[data-video-play-button]');
    this.videoEl = el.querySelector('[data-video-element]');
    this.onPlayClick = this._onPlayClick.bind(this);
    this.onPauseClick = this._onPauseClick.bind(this);
    this.autoplay = this._autoplay.bind(this);
    this.video = null;

    switch (this.platform) {
      case 'youtube':
        this.video = new Youtube_Youtube(this.videoEl);
        break;

      case 'vimeo':
        this.video = new Vimeo_VimeoPlayer(this.videoEl);
        break;

      default:
        this.video = null;
        break;
    }

    if (this.playButton) {
      if (this.options && this.options.autoplay) {
        this.autoplay();
      }

      this.playButton.addEventListener('click', this.onPlayClick);
    }
  }

  Video_createClass(Video, [{
    key: "_onPlayClick",
    value: function _onPlayClick() {
      var _this = this;

      this.el.classList.add('video-loading');
      this.video.play().then(function () {
        _this.el.classList.add('video-transitioning');

        setTimeout(function () {
          _this.el.classList.remove('video-loading');

          _this.el.classList.remove('video-transitioning');

          _this.el.classList.add('video-playing');
        }, 200);
      });
    }
  }, {
    key: "_onPauseClick",
    value: function _onPauseClick() {
      this.video.pause();
    }
  }, {
    key: "_autoplay",
    value: function _autoplay() {
      var _this2 = this;

      this.el.classList.add('video-loading');
      this.video.autoplay().then(function () {
        _this2.el.classList.add('video-transitioning');

        setTimeout(function () {
          _this2.el.classList.remove('video-loading');

          _this2.el.classList.remove('video-transitioning');

          _this2.el.classList.add('video-playing');
        }, 200);
      });
    }
  }, {
    key: "unload",
    value: function unload() {
      if (this.playButton) {
        this.playButton.removeEventListener('click', this.onPlayClick);
      }

      if (this.video) {
        this.video.unload();
      }
    }
  }]);

  return Video;
}();


// CONCATENATED MODULE: ./source/scripts/sections/DynamicVideo.js
function DynamicVideo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DynamicVideo_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DynamicVideo_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicVideo_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicVideo_defineProperties(Constructor, staticProps); return Constructor; }



var DynamicVideo_DynamicVideo = /*#__PURE__*/function () {
  function DynamicVideo(section) {
    DynamicVideo_classCallCheck(this, DynamicVideo);

    var videoEl = section.el.querySelector('[data-video]');
    this.$el = section.el;
    this.autoplay = section.data.autoplay;
    this.hasPlayed = false;

    if (videoEl) {
      this.video = new Video_Video(videoEl);
      this.bindEvents();
    }
  }

  DynamicVideo_createClass(DynamicVideo, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      window.addEventListener('scroll', function () {
        if (_this.autoplay) {
          var rect = _this.$el.getBoundingClientRect();

          if (rect.top >= 0 || rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
            if (!_this.hasPlayed) {
              _this.video._autoplay();

              _this.hasPlayed = true;
            }
          } else {
            _this.video._onPauseClick();
          }
        }
      });
    }
  }, {
    key: "onSectionUnload",
    value: function onSectionUnload() {
      if (this.video) {
        this.video.unload();
      }
    }
  }]);

  return DynamicVideo;
}();



/***/ }),

/***/ 932:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ Account_Account; });

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(0);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./source/scripts/Forms.js
var Forms = __webpack_require__(21);

// EXTERNAL MODULE: ./source/scripts/components/ProductList.js
var ProductList = __webpack_require__(96);

// EXTERNAL MODULE: ./node_modules/liquidjs/dist/liquid.browser.esm.js
var liquid_browser_esm = __webpack_require__(166);

// EXTERNAL MODULE: ./source/scripts/helpers/index.js + 24 modules
var helpers = __webpack_require__(2);

// CONCATENATED MODULE: ./source/scripts/components/AccountOrder.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var AccountOrder_AccountOrder = /*#__PURE__*/function () {
  function AccountOrder(el, data) {
    _classCallCheck(this, AccountOrder);

    this.data = data;
    this.integrationData = data.integrationConfig;
    this.orderId = this._getParameterByName('id');
    this.$body = $(document.body);
    this.orderContainerEl = el;
    this.$orderContainer = this.$body.find('[data-account-order-content-outer]');
    this.$breadcrumb = this.$body.find('[data-breadcrumbs-order-name]');
    this.$loading = this.$body.find('[data-account-loader]'); // Collect containers

    this.orderHeaderEl = this.orderContainerEl.querySelector('#account-order-header');
    this.orderEl = this.orderContainerEl.querySelector('#account-order-content');
    this.orderTransactionEl = this.orderContainerEl.querySelector('#account-order-transaction');
    this.orderFulfillmentsEl = this.orderContainerEl.querySelector('#account-order-fulfillments'); // Collect templates

    this.orderHeaderTemplateEl = this.orderContainerEl.querySelector('#account-order-header-template');
    this.orderTemplateEl = this.orderContainerEl.querySelector('#account-order-template');
    this.orderTransactionTemplateEl = this.orderContainerEl.querySelector('#account-order-transaction-template');
    this.orderFulfillmentsTemplateEl = this.orderContainerEl.querySelector('#account-order-fulfillments-template'); // Parse templates

    this.liquidEngine = new liquid_browser_esm["a" /* Liquid */]();
    this.orderHeaderLiquid = this.liquidEngine.parse(this.orderHeaderTemplateEl.innerHTML);
    this.orderLiquid = this.liquidEngine.parse(this.orderTemplateEl.innerHTML);
    this.orderTransactionLiquid = this.liquidEngine.parse(this.orderTransactionTemplateEl.innerHTML);
    this.orderFulfillmentsLiquid = this.liquidEngine.parse(this.orderFulfillmentsTemplateEl.innerHTML);

    this._getOrderPage(this.orderId);
  }

  _createClass(AccountOrder, [{
    key: "_getParameterByName",
    value: function _getParameterByName(name) {
      var query = location.search;
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      var results = regex.exec(query);

      if (!results) {
        return null;
      }

      if (!results[2]) {
        return '';
      }

      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }, {
    key: "_formatData",
    value: function _formatData(data) {
      for (var key in data) {
        var value = data[key];

        if (key === 'price' && data.quantity) {
          var line_price = parseFloat(value, 10) * data.quantity;
          data.line_price_money = Object(helpers["m" /* formatMoney */])(line_price.toFixed(2));
        }

        if (Object(helpers["r" /* isMoney */])(key)) {
          data["".concat(key, "_money")] = Object(helpers["m" /* formatMoney */])(value);
        }

        if (_typeof(value) === 'object') {
          this._formatData(value);
        }

        if (typeof value === 'array') {
          for (var i in value) {
            if (_typeof(i) === 'object') {
              this._formatData(i);
            }
          }
        }
      }
    }
  }, {
    key: "_getOrderPage",
    value: function _getOrderPage() {
      var _this = this;

      var api = Object(helpers["y" /* useIntegrationAPI */])();
      return $.ajax({
        data: api.authPayload(),
        dataType: 'json',
        method: 'GET',
        url: api.getOrder(this.orderId)
      }).done(function (response) {
        var orderData = response.data;

        var validLicence = _this._validateLicenceNumber(orderData);

        if (!validLicence) {
          return window.location = '/account';
        }

        _this.$loading.addClass('hidden');

        _this.$orderContainer.removeClass('hidden');

        _this._formatData(orderData);

        _this.$breadcrumb.text(orderData.name);

        _this._renderOrderPartial(orderData, _this.orderHeaderLiquid, _this.orderHeaderEl);

        _this._renderOrderPartial(orderData, _this.orderLiquid, _this.orderEl);

        _this._renderOrderPartial(orderData, _this.orderTransactionLiquid, _this.orderTransactionEl);

        _this._renderOrderPartial(orderData, _this.orderFulfillmentsLiquid, _this.orderFulfillmentsEl);
      }).fail(function () {
        _this._handleError();
      });
    }
  }, {
    key: "_renderOrderPartial",
    value: function _renderOrderPartial(order, template, dest) {
      return this.liquidEngine.render(template, {
        order: order
      }).then(function (response) {
        dest.innerHTML = response;
      });
    }
  }, {
    key: "_validateLicenceNumber",
    value: function _validateLicenceNumber(orderData) {
      var orderLicence = orderData.note_attributes.filter(function (attr) {
        // NOTE: Need to support incorrect (legacy) spelling, see CH80048
        return attr.name === 'licence_number' || attr.name === 'license_number';
      });
      return orderLicence[0].value === this.integrationData.customerL;
    }
  }, {
    key: "_handleError",
    value: function _handleError() {
      // Add error handling
      console.error('Error connecting to order API');
    }
  }]);

  return AccountOrder;
}();


// EXTERNAL MODULE: ./node_modules/lodash/fp/clamp.js
var clamp = __webpack_require__(394);
var clamp_default = /*#__PURE__*/__webpack_require__.n(clamp);

// CONCATENATED MODULE: ./source/scripts/components/AccountLicenceHistory.js
function AccountLicenceHistory_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AccountLicenceHistory_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AccountLicenceHistory_createClass(Constructor, protoProps, staticProps) { if (protoProps) AccountLicenceHistory_defineProperties(Constructor.prototype, protoProps); if (staticProps) AccountLicenceHistory_defineProperties(Constructor, staticProps); return Constructor; }


/**
 * Formats the licence order limits rendered in the LicenceHistory component on the Order History page.
 *
 * @param order_limits = Data object returned from Integration
 * @returns {limitsData}
 * @constructor
 */

var AccountLicenceHistory_AccountLicenceHistory = /*#__PURE__*/function () {
  function AccountLicenceHistory(props) {
    AccountLicenceHistory_classCallCheck(this, AccountLicenceHistory);

    var limit = props.limit,
        remaining = props.remaining;

    var consumed = this._calcConsumed(limit, remaining);

    this.limitsData = {
      consumed: this._formatMoney(consumed),
      donut: this._formatMoney(remaining, 0),
      limit: this._formatMoney(limit),
      percent: this._calcPercent(remaining, limit),
      remaining: this._formatMoney(remaining),
      donutFillEl: '#donutFill'
    };
    return this.limitsData;
  }

  AccountLicenceHistory_createClass(AccountLicenceHistory, [{
    key: "_formatMoney",
    value: function _formatMoney(money) {
      var decimalPoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

      // Round down so that amount is never larger then what has come from the response.
      // Otherwise if there are no decimals and it is rounded up it could be larger then the true amount remaining.
      if (decimalPoints === 0) {
        money = Math.floor(money);
      }

      return new Intl.NumberFormat('en-CA', {
        currency: 'CAD',
        style: 'currency',
        maximumFractionDigits: decimalPoints,
        minimumFractionDigits: decimalPoints
      }).format(money);
    }
  }, {
    key: "_calcPercent",
    value: function _calcPercent(limit, remaining) {
      /* eslint-disable no-magic-numbers */
      var percentage = Math.round(limit / remaining * 100);
      return clamp_default()(0, 100, percentage);
      /* eslint-enable no-magic-numbers */
    }
  }, {
    key: "_calcConsumed",
    value: function _calcConsumed(limit, remaining) {
      return remaining > limit ? 0 : "".concat(limit - remaining);
    }
  }]);

  return AccountLicenceHistory;
}();


// CONCATENATED MODULE: ./source/scripts/components/AccountOrders.js
function AccountOrders_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { AccountOrders_typeof = function _typeof(obj) { return typeof obj; }; } else { AccountOrders_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return AccountOrders_typeof(obj); }

function AccountOrders_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AccountOrders_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AccountOrders_createClass(Constructor, protoProps, staticProps) { if (protoProps) AccountOrders_defineProperties(Constructor.prototype, protoProps); if (staticProps) AccountOrders_defineProperties(Constructor, staticProps); return Constructor; }





var AccountOrders_AccountOrders = /*#__PURE__*/function () {
  function AccountOrders(data) {
    AccountOrders_classCallCheck(this, AccountOrders);

    this.data = data;
    this.orderLimitsEnabled = data.tf.ol; // NOTE: OLOT Feature flag.

    this.$body = $(document.body);
    this.loaderEl = document.querySelector('#account-loader'); // Setup container elements for JS content

    this.itemsContainerEl = document.querySelector('#account-order-items');
    this.orderHistoryEl = document.querySelector('#account-order-history');
    this.paginationContainerEl = document.querySelector('#account-order-history-pagination'); // Liquid JS Templates

    this.itemsTemplateEl = document.querySelector('#account-order-items-template');
    this.paginationTemplateEl = document.querySelector('#account-order-history-pagination-template'); // Instantiate order validator

    this.orderValidator = new helpers["h" /* OrderValidator */]();
    this.liquidEngine = new liquid_browser_esm["a" /* Liquid */]();
    this.$items = $(this.itemsContainerEl);
    this.$pagination = $(this.paginationContainerEl);
    this.itemsLiquid = this.liquidEngine.parse(this.itemsTemplateEl.innerHTML);
    this.paginationLiquid = this.liquidEngine.parse(this.paginationTemplateEl.innerHTML);
    this.currentPage = 1;
    this.orders = {};

    if (this.orderLimitsEnabled) {
      this.historyContainerEl = document.querySelector('#account-licence-history');
      this.historyLicenceEl = document.querySelector('#licence-history-template');
      this.licenceLiquid = this.liquidEngine.parse(this.historyLicenceEl.innerHTML);
    }

    this.events = [this.$pagination.on('click.order-history', 'a', this._getOrderHistoryPage.bind(this))];

    this._getOrderHistoryPage(null, 1);
  }

  AccountOrders_createClass(AccountOrders, [{
    key: "_getOrderHistoryPage",
    value: function _getOrderHistoryPage(event, index) {
      var _this = this;

      var pageIndex = index ? index : event.target.href.replace('#', '');
      var api = Object(helpers["y" /* useIntegrationAPI */])();
      return $.ajax({
        data: api.authPayload(),
        dataType: 'json',
        method: 'GET',
        url: api.getOrders()
      }).done(function (response) {
        _this._hideLoader();

        _this.currentPage = pageIndex;

        _this._renderPageComponents(response);
      }).fail(function () {
        _this._handleError();

        _this._showEmptyMessage();
      });
    }
  }, {
    key: "_renderPageComponents",
    value: function _renderPageComponents(payload) {
      if (this.orderLimitsEnabled) {
        this._renderLicenceHistory(payload.order_limits);
      }

      this._renderOrderHistory(payload.data);

      this._renderPagination();
    }
  }, {
    key: "_renderOrderHistory",
    value: function _renderOrderHistory(orders) {
      var _this2 = this;

      this._formatData(orders);

      return this.liquidEngine.render(this.itemsLiquid, {
        orders: orders
      }).then(function (response) {
        _this2.itemsContainerEl.innerHTML = response;
      });
    }
  }, {
    key: "_renderLicenceHistory",
    value: function _renderLicenceHistory(limits) {
      var _this3 = this;

      var data = new AccountLicenceHistory_AccountLicenceHistory(limits);
      return this.liquidEngine.render(this.licenceLiquid, {
        data: data
      }).then(function (response) {
        _this3.historyContainerEl.innerHTML = response;

        _this3._setDonutValue(data.percent, data.donutFillEl);
      });
    }
  }, {
    key: "_setDonutValue",
    value: function _setDonutValue() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var donutSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (value > 0) {
        var el = document.querySelector("".concat(donutSelector));
        el.style.strokeDasharray = "".concat(value, ", 1000");
        el.classList.add('loaded');
      }
    }
  }, {
    key: "_showEmptyMessage",
    value: function _showEmptyMessage() {
      var emptyEl = document.getElementById('account-order-history-empty-template');
      this.orderHistoryEl.innerHTML = emptyEl.innerHTML;
    }
  }, {
    key: "_hideLoader",
    value: function _hideLoader() {
      return this.loaderEl.classList.add('hidden');
    } // Loop through and object looking for specific keys
    // from isMoney and adding a new key that includes _money

  }, {
    key: "_formatData",
    value: function _formatData(data) {
      for (var key in data) {
        var value = data[key];

        if (Object(helpers["r" /* isMoney */])(key)) {
          data["".concat(key, "_money")] = Object(helpers["m" /* formatMoney */])(value);
        }

        if (AccountOrders_typeof(value) === 'object') {
          this._formatData(value);
        }

        if (typeof value === 'array') {
          for (var i in value) {
            if (AccountOrders_typeof(i) === 'object') {
              this._formatData(i);
            }
          }
        }
      }
    }
  }, {
    key: "_renderPagination",
    value: function _renderPagination() {
      var _this4 = this;

      // TODO: How do we determine no. of pages (i.e., lastPageIndex)?
      var lastPageIndex = 1;
      var previousPageIndex = Math.max(this.currentPage - 1, 0);
      var nextPageIndex = Math.min(this.currentPage + 1, lastPageIndex);
      var paginate = {
        previous: {
          url: "#".concat(previousPageIndex)
        },
        next: {
          url: "#".concat(nextPageIndex)
        },
        parts: []
      };

      if (this.currentPage === 1) {
        delete paginate.previous;
      }

      if (this.currentPage === lastPageIndex) {
        delete paginate.next;
      }

      var lastSkippedIndex = false;

      for (var i = 1; i <= lastPageIndex; i++) {
        if (lastPageIndex > 5 && i !== 1 && i !== lastPageIndex) {
          if (this.currentPage > 5 || this.currentPage < lastPageIndex - 4) {
            if (i < this.currentPage - 2 || i > this.currentPage + 2) {
              if (lastSkippedIndex !== i - 1) {
                this._addPaginationPart(paginate, '&hellip;', false, undefined);
              }

              lastSkippedIndex = i;
              continue;
            }
          }
        }

        if (i === this.currentPage) {
          this._addPaginationPart(paginate, i, false, undefined);
        } else {
          this._addPaginationPart(paginate, i, true, "#".concat(i));
        }
      }

      return this.liquidEngine.render(this.paginationLiquid, {
        paginate: paginate
      }).then(function (response) {
        _this4.paginationContainerEl.innerHTML = response;
      });
    }
  }, {
    key: "_addPaginationPart",
    value: function _addPaginationPart(paginate, title, is_link, url) {
      return paginate.parts.push({
        is_link: is_link,
        title: title,
        url: url
      });
    }
  }, {
    key: "_handleError",
    value: function _handleError() {
      // Add error handling
      console.error('Error connecting to order listing API');
    }
  }]);

  return AccountOrders;
}();


// CONCATENATED MODULE: ./source/scripts/templates/Account.js
function Account_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Account_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Account_createClass(Constructor, protoProps, staticProps) { if (protoProps) Account_defineProperties(Constructor.prototype, protoProps); if (staticProps) Account_defineProperties(Constructor, staticProps); return Constructor; }








var Account_Account = /*#__PURE__*/function () {
  function Account() {
    Account_classCallCheck(this, Account);

    this.$body = jquery_default()(document.body);
    this.$accountContents = jquery_default()('[data-template-account]');
    this.$loginContent = jquery_default()('[data-template-account-login]');
    this.$addressesContent = jquery_default()('[data-template-account-addresses]');
    this.$orderHistory = jquery_default()('[data-template-account-order-history]');
    this.$order = jquery_default()('[data-template-account-order]');
    this.$addressButtonFocus = null;
    this._loginToggle = this._loginToggle.bind(this);

    if (document.querySelector('[data-template-data]')) {
      this.data = Object(helpers["q" /* getLiquidVars */])('[data-template-data]');
    }

    if (document.querySelector('[data-integration]')) {
      this.integrationData = Object(helpers["q" /* getLiquidVars */])('[data-integration]');
      var liquidFeatureFlags = Object(helpers["q" /* getLiquidVars */])('[data-features]');
      this.orderLimitFeatureFlags = liquidFeatureFlags ? liquidFeatureFlags : false;
      this.data = jquery_default.a.extend({}, this.data, this.integrationData, this.orderLimitFeatureFlags);
    }

    if (this.$loginContent.length) {
      this._initLoginPage();
    }

    if (this.$addressesContent.length) {
      this._initAddressPage();
    }

    if (this.$accountContents.length) {
      this._init();
    }

    if (this.$orderHistory.length && this.data) {
      this._renderOrders();
    }

    if (this.$order.length && this.data) {
      this._renderOrder();
    }
  }

  Account_createClass(Account, [{
    key: "_init",
    value: function _init() {
      new Forms["a" /* default */](this.$accountContents);
    }
  }, {
    key: "_renderOrders",
    value: function _renderOrders() {
      this.orderHistory = new AccountOrders_AccountOrders(this.data);
    }
  }, {
    key: "_initLoginPage",
    value: function _initLoginPage() {
      this.$loginToggle = this.$loginContent.find('[data-login-toggle]');
      this.$login = this.$loginContent.find('[data-account-login-main]');
      this.$recovery = this.$loginContent.find('[data-account-login-recovery]');
      this.$recoveryHasMessage = this.$recovery.find('[data-recovery-has-message]');
      this.$loginToggle.on('click', this._loginToggle);

      if (this.$recoveryHasMessage.length) {
        this._loginToggle();
      }
    }
  }, {
    key: "_loginToggle",
    value: function _loginToggle() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (event) {
        event.preventDefault();
      }

      this.$login.toggleClass('visible');
      this.$recovery.toggleClass('visible');
    }
  }, {
    key: "_initAddressPage",
    value: function _initAddressPage() {
      var _this = this;

      var $customerAddresses = this.$addressesContent.find('[data-address-id]');
      this.$addressesContent.on('click', '[data-edit-address]', function (event) {
        var $target = jquery_default()(event.currentTarget);
        var itemId = $target.attr('data-edit-address');
        $customerAddresses.removeClass('visible');
        _this.$addressButtonFocus = $target;
        jquery_default()("[data-address-id=\"".concat(itemId, "\"]")).addClass('visible').find('.form-field-input').eq(0).focus();
      });
      this.$addressesContent.on('click', '[data-edit-address-cancel]', function () {
        $customerAddresses.removeClass('visible');
        jquery_default()('[data-address-id="new"]').addClass('visible'); // Return focus to last used button

        _this.$addressButtonFocus.focus();

        _this.$addressButtonFocus = null;
      });
      this.$addressesContent.on('click', '[data-delete-address]', function (event) {
        var itemId = jquery_default()(event.target).attr('data-delete-address');
        Shopify.CustomerAddress.destroy(itemId, '');
      });
      $customerAddresses.each(function (i, el) {
        var id = jquery_default()(el).attr('data-address-id');
        var countryEl = "customer_addr_".concat(id, "_country");
        var provinceEl = "customer_addr_".concat(id, "_province");
        var options = {
          hideElement: "address_province_container_".concat(id)
        }; // Initiate provinces for address forms

        new Shopify.CountryProvinceSelector(countryEl, provinceEl, options);
      });
    }
  }, {
    key: "_renderOrder",
    value: function _renderOrder() {
      var _this2 = this;

      this.order = new AccountOrder_AccountOrder(this.$order[0], this.data); // TODO: Move this stuff into AccountOrder.js
      // DESCOPE REORDER FOR MVP
      // this.$order.on(
      //   'click.account-orders',
      //   '[data-account-orders-reorder]',
      //   event => {
      //     event.preventDefault();
      //     this._reorder();
      //   }
      // );

      this.$order.on('click.account-orders', '[data-order-fulfillments-toggle]', function (event) {
        event.preventDefault();

        _this2._toggleFulfillment(event);
      });
      var options = {
        infiniteScroll: false
      };
      this.productList = new ProductList["a" /* default */]('[data-product-list]', options);
    } // DESCOPE REORDER FOR MVP
    // _reorder() {
    //   const data = {};
    //   this.data.products.forEach(item => {
    //     data[item.id] = {
    //       action: 'add',
    //       data: {
    //         id: item.id,
    //         quantity: item.quantity,
    //         properties: {
    //           case_size: item.caseSize,
    //         }
    //       }
    //     };
    //   });
    //   this.$body.trigger('manage-cart:submit-staged', data);
    // }

  }, {
    key: "_toggleFulfillment",
    value: function _toggleFulfillment(event) {
      var $target = jquery_default()(event.currentTarget);
      var $item = $target.closest('[data-order-fulfillments-item]');
      var $products = $item.find('[data-order-fulfillments-products]');

      if ($products.revealer('isVisible')) {
        $products.revealer('hide');
        $target.text(this.data.context.show_more);
      } else {
        $products.revealer('show');
        $target.text(this.data.context.show_less);
      }
    }
  }]);

  return Account;
}();



/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dropdown; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var Dropdown = /*#__PURE__*/function () {
  function Dropdown(el, callbacks) {
    _classCallCheck(this, Dropdown);

    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el);
    this.$body = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body);
    this.$toggle = this.$el.find('[data-dropdown-toggle]');
    this.$dropdown = this.$el.find('[data-dropdown-items]');
    this.callbacks = callbacks || null;
    this.firstOpen = false;

    this._bindEvents();
  }

  _createClass(Dropdown, [{
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;

      this.$toggle.on('click.dropdown', function (event) {
        event.preventDefault();

        _this._toggleDropdown();
      });
    }
  }, {
    key: "_toggleDropdown",
    value: function _toggleDropdown() {
      this.$dropdown.revealer('toggle');

      if (this.$dropdown.revealer('isVisible')) {
        this._bindClickToClose();

        this.$el.addClass('active');
      } else {
        this._unbindClickToClose();

        this.$el.removeClass('active');
      }

      if (this.firstOpen) return false;
      this.firstOpen = true;
      if (this.callbacks && this.callbacks.onFirstOpen) this.callbacks.onFirstOpen();
    }
  }, {
    key: "_closeDropdown",
    value: function _closeDropdown(target) {
      var $target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(target);
      var dropdownInModal = !!this.$el.closest('[data-modal-container]').length;
      var targetInModal = !!$target.closest('[data-modal-container]').length;
      var shouldClose = !(targetInModal && !dropdownInModal) && !$target.closest(this.$el).length;

      if (shouldClose) {
        this.$dropdown.revealer('hide');
        this.$el.removeClass('active');

        this._unbindClickToClose();
      }
    }
  }, {
    key: "_bindClickToClose",
    value: function _bindClickToClose() {
      var _this2 = this;

      // Close account menu when clicking outside
      this.$body.on('click.dropdown', function (event) {
        _this2._closeDropdown(event.target);
      });
    }
  }, {
    key: "_unbindClickToClose",
    value: function _unbindClickToClose() {
      this.$body.off('.dropdown');
    }
  }, {
    key: "unload",
    value: function unload() {
      this.$toggle.off('.dropdown');
      this.$body.off('.dropdown');
    }
  }]);

  return Dropdown;
}();



/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Search; });
/* harmony import */ var eventemitter2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(162);
/* harmony import */ var eventemitter2__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(eventemitter2__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


/**
 * Search API Class
 */

var Search = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Search, _EventEmitter);

  var _super = _createSuper(Search);

  /**
   * Create a new Search instance, and override defaults
   *
   * @param options
   * @property {string} options.type - Search restriction. Use 'article', 'page', 'product', or ''
   * @property {string} options.view - Search template suffix. Specify different templates as needed
   */
  function Search() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Search);

    _this = _super.call(this);
    _this.searchType = options.type || '';
    _this.view = options.view || 'json';
    _this.inProgress = false;
    _this.onCompletePayload = {};
    _this.xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
    _this._xhrLoad = _this._xhrLoad.bind(_assertThisInitialized(_this));
    _this._xhrError = _this._xhrError.bind(_assertThisInitialized(_this));
    _this._xhrAbort = _this._xhrAbort.bind(_assertThisInitialized(_this));

    _this._bindEvents();

    return _this;
  }

  _createClass(Search, [{
    key: "_bindEvents",
    value: function _bindEvents() {
      this.xhr.addEventListener('load', this._xhrLoad);
      this.xhr.addEventListener('error', this._xhrError);
      this.xhr.addEventListener('abort', this._xhrAbort);
    }
    /**
     * XHR was successfull
     *
     * @description XHR completed successfully
     * @param {object} event
     * @fires Search#complete
     * @private
     */

  }, {
    key: "_xhrLoad",
    value: function _xhrLoad(event) {
      var response = {};
      var readyState = event.target.readyState;
      var status = event.target.status;

      try {
        if (readyState > 3 && status == 200) {
          response = JSON.parse(event.target.responseText);
          this.emit('complete', response, this.onCompletePayload);
        } else {
          var message = "Invalid readyState: ".concat(readyState, ", or status: ").concat(status, ".");
          return this._xhrError(event, message);
        }
      } catch (error) {
        return this._xhrError(event, 'Invalid JSON', error);
      }

      this.inProgress = false;
    }
    /**
     * XHR contains an error
     *
     * @description XHR has contained an error, and was unable to complete
     * @param {object} event
     * @param {object|string} message
     * @param {object} error
     * @fires Search#error
     * @private
     */

  }, {
    key: "_xhrError",
    value: function _xhrError(event) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      this.inProgress = false;
      this.emit('error', {
        event: event,
        message: message,
        error: error
      });
    }
    /**
     * XHR has been aborted
     *
     * @description This event only fires if there is an active XHR request that has been terminated
     * @fires Search#aborted
     * @private
     */

  }, {
    key: "_xhrAbort",
    value: function _xhrAbort() {
      this.emit('aborted');
    }
    /**
     * Perform the search
     *
     * @param {string} term - Search term(s)
     * @param {object} onCompletePayload - Payload of data to pass through with
     * successfull search
     * @fires Search#initialized
     * @fires Search#cancelled
     */

  }, {
    key: "execute",
    value: function execute(term) {
      var onCompletePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.emit('initialized', {
        term: term
      });

      if (this.inProgress) {
        this.emit('cancelled');
        this.xhr.abort();
      }

      this.inProgress = true;
      this.onCompletePayload = onCompletePayload;
      var url = '/search';
      var params = {
        q: term,
        type: this.searchType,
        view: this.view
      };
      var searchParams = Object.keys(params).map(function (key) {
        var value = params[key];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
      }).join('&');
      this.xhr.open('get', "".concat(url, "?").concat(searchParams));
      this.xhr.setRequestHeader('Accept', 'application/json');
      this.xhr.send();
    }
  }]);

  return Search;
}(eventemitter2__WEBPACK_IMPORTED_MODULE_0___default.a);
/**
 * @description XHR initialized
 * @event Search#initialized
 * @type {object}
 */

/**
 * @description XHR completed
 * @event Search#complete
 * @property {object} response - JSON response from end point
 */

/**
 * @description XHR had an error
 * @event Search#error
 */

/**
 * @description XHR cancelled due to user interaction. If an XHR is being processed, this does not terminate it
 * @event Search#cancelled
 */

/**
 * @description XHR aborted due to user interaction, terminating previously executed XHR.
 * @event Search#aborted
 */




/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductList; });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _pixelunion_rimg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93);
/* harmony import */ var _CheckboxMaster__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(164);
/* harmony import */ var _ProductListItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }







var ProductList = /*#__PURE__*/function () {
  function ProductList(el, options) {
    var _this = this;

    _classCallCheck(this, ProductList);

    this.el = el;
    this.$el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el);
    this.$body = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body);
    this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
      infiniteScroll: true,
      sectionId: this.$el.attr('id')
    }, options);
    this.id = this.options.sectionId;
    this.manageCart = new _helpers__WEBPACK_IMPORTED_MODULE_4__[/* ManageCart */ "g"]();
    this.eventHandler = new _helpers__WEBPACK_IMPORTED_MODULE_4__[/* EventHandler */ "d"]();
    this.$utils = this.$el.find('[data-product-list-utils]');
    this.$utilsDefault = this.$utils.find('[data-product-list-utils-default]');
    this.$utilsSelected = this.$utils.find('[data-product-list-utils-selected]'); // Add to order button

    this.$ato = this.$el.find('[data-product-list-ato]');
    this.productItems = [];

    if (!this.$body.hasClass('template-collection--grid')) {
      this.checkboxMasterOptions = {
        onChange: this._onCheckboxMasterChange.bind(this)
      };
      this.checkboxMaster = new _CheckboxMaster__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"](this.$el[0], this.checkboxMasterOptions);
      this.$productItems = this.$el.find('[data-product-list-item]');
    } else {
      this.$productItems = this.$el.find('[data-product-item]');
    }

    this.$productItems.each(function (i, productItem) {
      _this.productItems.push(new _ProductListItem__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"](jquery__WEBPACK_IMPORTED_MODULE_0___default()(productItem), _this.id));
    });

    if (this.options.infiniteScroll) {
      this.InfiniteScroll = new _helpers__WEBPACK_IMPORTED_MODULE_4__[/* InfiniteScroll */ "e"]({
        el: el,
        itemsContainer: '[data-product-list-items]',
        callbacks: {
          onSuccess: this._onScrollSuccess.bind(this)
        }
      });
    }

    this._bindEvents();
  }

  _createClass(ProductList, [{
    key: "unload",
    value: function unload() {
      this.$el.off('.product-list');
      this.$ato.off('.product-list');
      this.productItems.forEach(function (productItem) {
        productItem.unload();
      });
    }
  }, {
    key: "_onCheckboxMasterChange",
    value: function _onCheckboxMasterChange(state) {
      this.$el.toggleClass('product-selected', state != 'empty');
      this.$utilsDefault.toggleClass('active', state == 'empty');
      this.$utilsSelected.toggleClass('active', state != 'empty');

      if (state == 'empty') {
        this.$productItems.removeClass('productlist--item-active');
        this.manageCart.unstageAll();
      }
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this2 = this;

      this.$ato.on('click.product-list', function (event) {
        event.preventDefault();
        var buttonHTMLElement = jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.currentTarget);
        Object(_helpers__WEBPACK_IMPORTED_MODULE_4__[/* disableButton */ "j"])(buttonHTMLElement);

        _this2.manageCart.submit('add', buttonHTMLElement);
      });
      this.eventHandler.on('cartRequestComplete', this._onCartRequestComplete.bind(this));
    }
  }, {
    key: "_onCartRequestComplete",
    value: function _onCartRequestComplete() {
      if (this.checkboxMaster) {
        this.checkboxMaster.clear();
      }
    }
  }, {
    key: "_onScrollSuccess",
    value: function _onScrollSuccess(items) {
      var _this3 = this;

      if (this.$body.hasClass('template-collection--grid')) {
        // Load images
        Object(_pixelunion_rimg__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])('[data-product-list-items] [data-rimg]');
      }

      items.forEach(function (productItem) {
        _this3.productItems.push(new _ProductListItem__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"](jquery__WEBPACK_IMPORTED_MODULE_0___default()(productItem), _this3.id));
      }); // Re-establish checkbox hooks

      if (this.checkboxMaster) {
        this.checkboxMaster.init();
      }
    }
  }]);

  return ProductList;
}();



/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InlineSearch_InlineSearch; });

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(0);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/just-debounce/index.js
var just_debounce = __webpack_require__(32);
var just_debounce_default = /*#__PURE__*/__webpack_require__.n(just_debounce);

// EXTERNAL MODULE: ./source/scripts/Search.js
var Search = __webpack_require__(95);

// EXTERNAL MODULE: ./source/scripts/Layout.js
var Layout = __webpack_require__(4);

// EXTERNAL MODULE: ./source/scripts/components/SearchForm.js
var SearchForm = __webpack_require__(71);

// EXTERNAL MODULE: ./source/scripts/components/ProductListItem.js + 1 modules
var ProductListItem = __webpack_require__(48);

// CONCATENATED MODULE: ./source/scripts/components/InlineSearchProductPicker.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var InlineSearchProductPicker_InlineSearchProductPicker = /*#__PURE__*/function () {
  function InlineSearchProductPicker($el) {
    var _this = this;

    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, InlineSearchProductPicker);

    this.$el = $el;
    this.$body = jquery_default()(document.body);
    this.$form = this.$el.find('[data-live-search-form]');
    this.$toggle = this.$el.find('[data-live-search-toggle]');
    this.$cancel = this.$el.find('[data-live-search-takeover-cancel]');
    this.settings = jquery_default.a.extend({
      addTo: 'cart'
    }, settings);
    this.events = [this.$el.on('click.inline-search-product-picker', '[data-product-list-item]', function (event) {
      _this._addProduct(event);
    }), this.$el.on('click.inline-search-product-picker', '[data-quickshop-full]', function (event) {
      event.stopPropagation();
    }), this.$toggle.on('click.inline-search-product-picker', function (event) {
      event.preventDefault();

      _this._showPicker();
    }), this.$cancel.on('click.inline-search-product-picker', function (event) {
      event.preventDefault();

      _this._hidePicker();
    })];
  }

  _createClass(InlineSearchProductPicker, [{
    key: "_showPicker",
    value: function _showPicker() {
      this.$toggle.removeClass('visible');
      this.$form.addClass('visible').find('[data-live-search-input]').focus();
    }
  }, {
    key: "_hidePicker",
    value: function _hidePicker() {
      this.$toggle.addClass('visible');
      this.$form.removeClass('visible');
    }
  }, {
    key: "_addProduct",
    value: function _addProduct(event) {
      event.preventDefault();
      var $target = jquery_default()(event.currentTarget); // Update checkout button passing true, as we do not
      // know the validity of the entire order

      var validityFlag = true;
      this.$body.trigger('cart:update-checkout-button', validityFlag);
      $target.trigger('product-item:add-to-cart', true);
    }
  }, {
    key: "unload",
    value: function unload() {
      this.events.forEach(function ($el) {
        return $el.off('.inline-search-product-picker');
      });
    }
  }]);

  return InlineSearchProductPicker;
}();


// CONCATENATED MODULE: ./source/scripts/components/InlineSearchTemplates.js
/**
 * Show a message when no product results are found
 *
 * @param props
 * @returns {jQuery|HTMLElement}
 * @constructor
 */
function ProductNoResults(props) {
  var context = props.context,
      terms = props.terms;
  return $("\n    <div class=\"search-flydown--product-items--none\" data-live-search-no-products>\n      <h5>\n        ".concat(context.no_results_products.title.replace('*terms*', terms), "\n      </h5>\n      <p>\n        ").concat(context.no_results_products.message, "\n      </p>\n      <p>\n        <a class=\"search-flydown--continue\" href=\"/collections/all\">\n          ").concat(context.view_all_products, "\n        </a>\n      </p>\n    </div>\n  "));
}
/**
 * Show's the Results footer, directing customers to all products
 *
 * @param props
 * @returns {jQuery|HTMLElement}
 * @constructor
 */


function ResultsFooter(props) {
  var context = props.context,
      terms = props.terms,
      type = props.type;
  return $("\n    <div class=\"search-flydown--footer\">\n      <a class=\"search-flydown--continue\" href=\"/search?q=".concat(terms, "&type=").concat(type, "\">\n        ").concat(context.view_all_results, "\n      </a>\n    </div>\n  "));
}


// CONCATENATED MODULE: ./source/scripts/components/InlineSearch.js
function InlineSearch_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function InlineSearch_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function InlineSearch_createClass(Constructor, protoProps, staticProps) { if (protoProps) InlineSearch_defineProperties(Constructor.prototype, protoProps); if (staticProps) InlineSearch_defineProperties(Constructor, staticProps); return Constructor; }










var InlineSearch_InlineSearch = /*#__PURE__*/function () {
  function InlineSearch($els, settings) {
    var _this = this;

    InlineSearch_classCallCheck(this, InlineSearch);

    this.$el = $els.$el;
    this.id = this.$el.attr('id');
    this.$body = jquery_default()('body');
    this.$header = $els.$header;
    this.$document = jquery_default()(document);
    this.settings = settings;
    this.flyDownActive = false;
    this.takeOverActive = false;
    this.showFlyDown = false;
    this.searchType = 'product';
    this.productItems = [];
    this.$form = this.$el.find('[data-live-search-form]');
    this.$input = this.$form.find('[data-live-search-input]');
    this.$button = this.$form.find('[data-live-search-submit]');
    this.$takeOverButton = this.$form.find('[data-live-search-takeover-cancel]');
    this.$flyDown = this.$el.find('[data-live-search-flydown]');
    this.$searchResults = this.$flyDown.find('[data-live-search-results]');
    this.$searchPlaceholder = this.$flyDown.find('[data-live-search-placeholder]');
    this.$quickLinks = this.$flyDown.find('[data-live-search-quick-links]');
    this.staticSearch = new SearchForm["a" /* default */](this.$el);
    this.search = new Search["a" /* default */]({
      view: this.settings.view,
      type: this.searchType
    });
    this._search = this._search.bind(this);
    this._toggleTakeOver = this._toggleTakeOver.bind(this);
    this._searchFocused = this._searchFocused.bind(this);
    this._documentFocus = this._documentFocus.bind(this);
    this._searchCancelled = this._searchCancelled.bind(this);
    this._searchComplete = this._searchComplete.bind(this);
    this._searchError = this._searchError.bind(this);
    this.closeEvents = [];
    this.search.on('cancelled', this._searchCancelled);
    this.search.on('complete', this._searchComplete);
    this.search.on('error', this._searchError);
    this.events = [this.$button.on('click.inline-search', function (event) {
      event.preventDefault();

      _this._search(event);
    }), this.$input.on('input.inline-search', just_debounce_default()(this._search, 250)), this.$input.on('focus.inline-search', this._searchFocused), this.$takeOverButton.on('click.inline-search', this._toggleTakeOver), this.$body.on('flyout:open', this._closeFlyDown.bind(this))];

    if (this.settings.view != 'header') {
      this.productPicker = new InlineSearchProductPicker_InlineSearchProductPicker(this.$el, {
        addTo: this.settings.addTo,
        listTitle: this.settings.listTitle,
        listId: this.settings.listId
      });
    }
  }

  InlineSearch_createClass(InlineSearch, [{
    key: "unload",
    value: function unload() {
      this.events.forEach(function ($el) {
        return $el.off('.inline-search');
      });
      this.search.off('cancelled', this._searchCancelled);
      this.search.off('complete', this._searchComplete);
      this.search.off('error', this._searchError);
      this.staticSearch.unload();

      if (this.productItems.length) {
        this.productItems.forEach(function (productItem) {
          productItem.unload();
        });
      }
    }
    /**
     * If is searching, only show placeholder
     *
     * @private
     */

  }, {
    key: "_flyDownSearching",
    value: function _flyDownSearching() {
      this.$searchResults.removeClass('visible');
      this.$quickLinks.removeClass('visible');
      this.$searchPlaceholder.addClass('visible');
    }
    /**
     * Search field has been focused, or has been cleared of contents
     *   - If previous search contents, show
     *   - If no previous search contents, show quicklinks if exists
     *
     * @param hasTerms
     * @private
     */

  }, {
    key: "_flyDownInitial",
    value: function _flyDownInitial(hasTerms) {
      this.showFlyDown = false;
      var hasNoResults = this.$searchResults.find('[data-live-search-no-products]').length === 0;
      var hasPreviousResults = this.$searchResults.children().length > 0;

      if (hasTerms && hasNoResults && hasPreviousResults) {
        this.$searchResults.addClass('visible');
        this.$quickLinks.removeClass('visible');
        this.showFlyDown = true;
      } else if (this.$quickLinks.length) {
        this.$searchResults.removeClass('visible');
        this.$quickLinks.addClass('visible');
        this.showFlyDown = true;
      }
    }
  }, {
    key: "_search",
    value: function _search(event) {
      // Ignore non character key strokes
      var invalidKeyStrokes = ['Alt', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Capslock', 'Control', 'Meta', 'Shift', 'Tab'];

      if (event.key && invalidKeyStrokes.indexOf(event.key) !== -1) {
        return;
      }

      var terms = this.$input.val();
      var hasTerms = terms.length > 0; // If is XS, pop the search out into a Takeover screen

      if (Layout["a" /* default */].isBreakpoint('XS')) {
        this._toggleTakeOver(null, true);
      }

      if (!hasTerms) {
        this._flyDownInitial(true);

        if (!this.showFlyDown) {
          this._closeFlyDown(true);
        }

        return;
      }

      this._flyDownSearching(); // Clear previous results


      this.$searchResults.html(''); // If terms has length, this will be true

      this._toggleButton(hasTerms); // Show the flyout if it isn't open


      if (!this.$flyDown.data('is-open')) {
        this.showFlyDown = true;

        this._openFlyDown();
      } // Adds `*` after each word in search terms, doesn't add to last word


      if (terms.indexOf(' ') > 0) {
        terms = terms.split(' ').join('* ').trim();
      } // Adds `*` at the end of the search terms


      terms = "".concat(terms, "*");
      this.search.execute(terms);
    }
  }, {
    key: "_searchError",
    value: function _searchError(response) {
      console.warn('Search had error');
      console.log(response.message, response.error, response.event);

      this._toggleButton(false);
    }
    /**
     * Search has been cancelled due to new search being performed
     *
     * @private
     */

  }, {
    key: "_searchCancelled",
    value: function _searchCancelled() {// Searches are canceled on user interaction, UI should remain unchanged
    }
  }, {
    key: "_searchComplete",
    value: function _searchComplete(response) {
      var _this2 = this;

      var products = response.products,
          terms = response.terms,
          sanitizedTerms = response.sanitizedTerms;
      var settings = {
        products: {
          results: {
            products: products
          },
          noResults: {
            context: this.settings.context,
            terms: sanitizedTerms
          }
        },
        footer: {
          context: this.settings.context,
          terms: terms,
          type: this.searchType
        }
      };
      var $productResults = products.length ? products : ProductNoResults(settings.products.noResults); // Hide placeholder
      // TODO: Lock minimum height?

      this.$searchPlaceholder.removeClass('visible'); // Show results

      this.$searchResults.html($productResults).addClass('visible');
      this.productItems = [];
      this.$searchResults.find('[data-product-list-item]').each(function (i, productItem) {
        _this2.productItems.push(new ProductListItem["a" /* default */](jquery_default()(productItem), _this2.id));
      });
      this.$searchResults.append(ResultsFooter(settings.footer));

      this._toggleButton(false);
    }
    /**
     * Toggles search button while processing
     *
     * @param disable
     * @private
     */

  }, {
    key: "_toggleButton",
    value: function _toggleButton(disable) {
      if (disable) {
        this.$button.addClass('search-icon--processing').attr('disabled');
      } else {
        this.$button.removeClass('search-icon--processing').removeAttr('disabled');
      }
    }
  }, {
    key: "_searchFocused",
    value: function _searchFocused() {
      if (this.flyDownActive) {
        return;
      }

      var hasTerms = this.$input.val().length > 0; // Only listen for events outside of the search flydown when its open

      this.closeEvents.concat([this.$header.on('focus.inline-search', 'a, button', this._documentFocus), this.$document.on('touchstart.inline-search', this._documentFocus), this.$document.on('click.inline-search', this._documentFocus)]);
      this.$el.addClass('site-header-search--focused'); // If is XS, pop the search out into a Takeover screen

      if (Layout["a" /* default */].isBreakpoint('XS')) {
        this._toggleTakeOver(null, true);
      }

      this._flyDownInitial(hasTerms);

      this._openFlyDown();
    }
  }, {
    key: "_openFlyDown",
    value: function _openFlyDown() {
      if (!this.showFlyDown) {
        return;
      }

      this.$el.addClass('site-header-search--active');
      this.$flyDown.data('is-open', true);
      this.flyDownActive = true;
    }
    /**
     * Close the FlyDown when no longer needed
     *  - Keep focus styling if input is still being interacted with
     *
     * @param retainFocus
     * @private
     */

  }, {
    key: "_closeFlyDown",
    value: function _closeFlyDown() {
      var retainFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.flyDownActive) {
        if (!retainFocus) {
          this.$el.removeClass('site-header-search--focused');
        }

        return;
      }

      if (this.takeOverActive) {
        this._toggleTakeOver(null, false);
      }

      this.$flyDown.data('is-open', false);
      this.$el.removeClass('site-header-search--active');

      if (!retainFocus) {
        this.$el.removeClass('site-header-search--focused');
      }

      this.flyDownActive = false;
      this.closeEvents.forEach(function ($el) {
        return $el.off('.inline-search');
      });
      this.closeEvents = [];
    }
    /**
     * Open or close the Take over for mobile
     *
     *
     * @param event
     * @param enable
     * @private
     */

  }, {
    key: "_toggleTakeOver",
    value: function _toggleTakeOver() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.takeOverActive = enable;

      if (event) {
        event.preventDefault();
      }

      if (!enable) {
        this._closeFlyDown(false);
      }

      if (this.$header.hasClass('search--section')) {
        this.$body.toggleClass('search-takeover-active', enable);
      }

      this.$el.toggleClass('site-header-search--takeover', enable);
      this.$body.toggleClass('scroll-lock', enable);
    }
    /**
     * When the focus element has changed, either by clicking, touching, or tabbing
     * check to see if it is within the flydown
     *
     * @param event
     * @private
     */

  }, {
    key: "_documentFocus",
    value: function _documentFocus(event) {
      var $target = jquery_default()(event.target);
      var $parent = $target.parents('[data-live-search]');
      var $modal = $target.closest('[data-modal-container]');
      var isAtc = $target.is('[data-product-atc]');

      if (($parent.length || $modal.length) && !isAtc) {
        return;
      }

      this._closeFlyDown();
    }
  }]);

  return InlineSearch;
}();



/***/ })

/******/ });